import {
  APP_TITLE,
  LANDING_BRIEF,
  LANDING_LANGUAGE_SELECTOR,
  LANDING_COUNTRY_SELECTOR,
  LANDING_TERMS,
  LANDING_TERMS_ERROR,
  LANDING_CAPTCHA_ERROR,
  BUTTON_PREV,
  BUTTON_NEXT,
  BUTTON_SUBMIT,
  MENU_FEEDBACK_FORM,
  MENU_FEEDBACK_STATUS,
  MENU_FORM_INTAKE,
  MENU_FORM_EVENT_DETAILS,
  MENU_FORM_PRODUCT_INFO,
  SYSTEM_FEEDBACK_FORM,
  SYSTEM_FEEDBACK_STATUS,
  FORM_TITLE,
  FORM_MANDATORY_FIELDS,
  APP_DESCRIPTION,
  SUBMIT_FEEDBACK,
  CHECK_SUBMITTED_FEEDBACK,
  BTN_LAUNCH_FORM,
  BTN_CHECK_STATUS,
  SELECT_RESPONSE,
  FUNCTION_ROLE,
  CUSTOMER_ACCOUNT_NUMBER,
  ENTER_CUSTOMER_ACCOUNT,
  HELP_CUSTOMER_ACCOUNT_NUMBER,
  EVENT_REPORTED,
  REFERENCE_NUMBER,
  ENTER_REFERENCE,
  WHO_REPORTED_TO,
  WHO_WAS_NOTIFIED,
  ENTER_NAME,
  PRODUCT_SURVEILLANCE,
  YOUR_NAME,
  OCCUPATION,
  PHONE_NUMBER,
  ENTER_PHONE_NUMBER,
  ENTER_EMAIL,
  EMAIL_ADDRESS,
  ENTER_ADDRESS,
  ENTER_NA_IF_UNKNOWN,
  FACILITY_HOSPITAL,
  ENTER_FACILITY,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  STATE,
  POSTAL_CODE,
  COUNTRY,
  END_USER_CUSTOMER,
  ADDITIONAL_CONTACT_PERSON,
  ADDITIONAL_PHONE,
  ADDITIONAL_EMAIL,
  ANOTHER_FACILITY_ADDRESS,
  ANOTHER_FACILITY_HOSPITAL,
  ANOTHER_ENTER_FACILITY,
  ANOTHER_ADDRESS_1,
  ANOTHER_ADDRESS_2,
  ANOTHER_CITY,
  ANOTHER_STATE,
  ANOTHER_POSTAL_CODE,
  ANOTHER_COUNTRY,
  LOT_SERIAL_NUMBER,
  ENTER_LOT_SERIAL_NUMBER,
  HELP_LOT_SERIAL_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE,
  PRODUCT_CODE,
  ENTER_PRODUCT_CODE,
  HELP_PRODUCT_CODE,
  NDC,
  ENTER_NDC,
  UDI,
  ENTER_UDI,
  PRODUCT_NAME,
  ENTER_PRODUCT_NAME,
  HELP_PRODUCT_NAME,
  BEST_DESCRIBES,
  QUANTITY_TO_SELECT,
  ENTER_QUANTITY,
  HELP_QUANTITY,
  UNIT,
  AVAILABLE_TO_RETURNED,
  PHOTOGRAPH_AVAILABLE,
  HELP_PHOTOGRAPH_AVAILABLE,
  UPLOAD_IMAGES,
  REPORTER_NAME,
  REPORTER_FACILITY,
  REPORTER_OCCUPATION,
  ENTER_NUMBER,
  REPORTER_PHONE_NUMBER,
  REPORTER_EMAIL_ADDRESS,
  EMPLOYEE_NAME,
  EMPLOYEE_PHONE_NUMBER,
  EMPLOYEE_EMAIL_ADDRESS,
  RETURNING_FOR_INVESTIGATION,
  HELP_RETURNING_FOR_INVESTIGATION,
  UNUSED_BAXTER_PRODUCT,
  YOU_INDICATED_SAMPLES,
  SAMPLE_RETURN_KIT,
  A_BOX_WITH_A_PREPAID_LABEL,
  SAME_AS_MY_ADDRESS,
  OTHER_CONTACT_NAME,
  OTHER_CONTACT_OCCUPATION,
  OTHER_CONTACT_PHONE_NUMBER,
  OTHER_CONTACT_EMAIL_ADDRESS,
  MANUFACTURED_BY_ANOTHER_COMPANY,
  CUSTOMER_EXPLICITLY_REQUEST,
  EXPLICITLY_REQUEST_CREDIT,
  PRODUCT_FROM_BAXTER,
  QUANTITY_REQUESTED_CREDIT,
  ENTER_OCCUPATION,
  LOT_QUANTITY_NUMBER,
  WHOLESALERS_NAME,
  PLACE_WHOLESALERS_NAME,
  DATE_OF_EVENT,
  DATE_OF_EVENT_MSG,
  HELP_DATE_OF_EVENT,
  DATE_BAXTER_EMPLOYEE,
  DATE_MESSAGE_BAXTER_EMPLOYEE,
  DURING_WHAT_PROCESS,
  WAS_THE_PATIENT,
  WERE_YOU_CONNECTED,
  PROVIDE_ANY_ADDITIONAL,
  HELP_YOU_IDENTIFIED_MORE,
  ENTER_DETAILS,
  PROVIDE_ANY_ATTACHMENT,
  WAS_NEGATIVE_MEDICAL,
  WAS_MEDICAL_INTERVENTION,
  PROVIDE_DETAILS,
  REQUIRED_TREATMENT,
  ENTER_TREATMENT,
  RELEVANT_TESTS,
  HELP_RELEVANT_TESTS,
  RELEVANT_MEDICAL_HISTORY,
  ENTER_HISTORY,
  PATIENT_NAME,
  PATIENT_INITIALS,
  PATIENT_PHONE_NUMBER,
  PATIENT_EMAIL_ADDRESS,
  I_DO_NOT_WISH_TO_PROVIDE,
  PATIENT_ADDRESS,
  SAME_ADDRESS,
  DRUG_BEING_USED,
  PATIENT_IDENTIFIER,
  PATIENT_AGE_OR_DOB,
  ENTER_PATIENT_AGE,
  PATIENT_GENDER,
  PATIENT_WEIGHT,
  ENTER_WEIGHT,
  PATIENT_WEIGHT_UNIT,
  MY_NAME,
  ENTER_IN_YOUR_CONTACT,
  MY_PHONE_NUMBER,
  MY_EMAIL_ADDRESS,
  MY_ADDRESS,
  NAME_OF_BAXTER_DRUG,
  ENTER_DRUG_NAME,
  PLEASE_PROVIDE_THE_NAME,
  APPLY_TO_EACH_UNIT,
  SELECT_THE_COMPONENT,
  USE_THE_DIAGRAM,
  TYPE_OF_DAMAGE,
  PLEASE_ENTER_VALUE,
  WAS_THE_PRODUCT_KINKED,
  WERE_ANY_CLEANING,
  WHAT_WAS_THE_DISINFECTANT,
  NOTE_BAXTER_LABELING,
  SELECT_ALL_THAT_APPLY,
  DID_FOLLOWING_OCCUR,
  SELECT_THE_LOCATION,
  WAS_THE_PRODUCT_EXPOSED,
  HOW_LONG_TRANSFER,
  WAS_THERE_DIFFICULTY,
  WAS_DEVICE_OR_TOOL,
  DESCRIBE_HOW_PRODUCT,
  DID_YOU_OBSERVE,
  WERE_DIFFICULTIES_PUTTING,
  WAS_THE_TRANSFER,
  SELECT_TYPE_OF_FLOW,
  WAS_ANYTHING_BLOCKING,
  WAS_ANY_ALARM,
  SELECT_BEST_DESCRIBE,
  WERE_THE_MINICAPS,
  WAS_THE_SPONGE_VISIBLE,
  WHERE_PARTICULATE_MATTERFOREIGN,
  DESCRIBE_THE_EXACT_LOCATION,
  WAS_THE_PARTICULATE_MATTER,
  DOES_THE_PARTICULATE_MATER,
  WHAT_COMPONENT_DOES,
  SELECT_CONNECTION_ISSUE,
  WERE_ASSIST_DEVICES,
  WERE_ANY_DIFFICULTIES,
  PROVIDE_PRODUCT_INFORMATION,
  WERE_THE_SPIKE_LUER,
  BAXTER_LABELING_STATES,
  WERE_PETS_OR_ANIMALS,
  BAXTER_LABELING_CONTAMINATION,
  WERE_OTHER_ISSUES,
  WAS_MINICAP_TWISTED,
  WERE_DIFFICULTIES_TRANSFER_SET,
  DID_TRANSFER_SET_CONNECTORS,
  WHAT_WAS_THE_ALARM,
  WHERE_OBSERVED_DAMAGE,
  SELECT_THE_TYPE_OBSERVED,
  DID_DAMAGE_CAUSE_LEAK,
  WAS_THE_SHIPPING_CARTON,
  SELECT_FLOW_ISSUE_OBSERVED,
  HOW_LONG_WAS_STORAGE,
  WAS_THERE_AN_ADAPTER,
  NAME_AND_MODEL,
  NAME_VAPORIZER,
  WAS_VIAL_INVERTED,
  WHAT_VIAL_USED,
  DRUG_NAME_MANUFACTURER,
  WERE_BREAK_FRANGIBLE,
  WAS_ALARM_ASSOCIATED,
  WHAT_PART_DISCOLORED,
  DESCRIBE_DISCOLORATION,
  HOW_PRODUCT_STORED,
  DOES_DISCOLORATION_APPEAR,
  WHICH_CHAMBER_DISCOLORED,
  WAS_PEEL_SEAL_INTERCHAMBER,
  WAS_DISCOLORATION_NOTICED,
  SELECT_SPECIFICALLY_DESCRIBES,
  WHAT_DEVICE_HAD_ALARM,
  WHAT_MISSING_MISASSEMBLED,
  RECONSTITUTION_ISSUE,
  WHAT_MEDICATION_SOLUTION,
  WHAT_VOLUME_MEDICATION,
  WHAT_DEVICES_RECONSTITUTION,
  WAS_PRODUCT_EXPOSED_HEAT,
  DESCRIBE_EXPOSURE,
  WHAT_USED_ACTIVATE_SOLUTION,
  WAS_DAMAGE_OBSERVED,
  DESCRIBE_THE_DAMAGE,
  APPROXIMATELY_SOLUTION_POWDER,
  WAS_LEAK_OBSERVED,
  WHAT_FEATUR_DIFFICULT_USE,
  HOW_WAS_DIFFICULT_USE,
  WHERE_MATTER_FOREIGN,
  DOES_PARTICULATE_MATTER,
  DESCRIBE_EXACT_LOCATION,
  WAS_MATTER_FOREIGN,
  WHEN_MATTER_FOREIGN,
  PROVIDE_INFORMATION_MEDICATION,
  PRODUCT_NAME_CODE_NUMBER,
  DESCRIBE_SPIKING,
  INCLUDE_NEEDLE,
  WHAT_ADMINISTRATION_RECONSTITUTION,
  INCLUDE_MANUFACTURER,
  WAS_MEDICATION_ADDITIVE,
  WHAT_MEDICATION_ADDITIVE,
  WHAT_STATE_OF_PRODUCT,
  AFTER_UNITS_SAT,
  DID_ATTEMPT_AGITATE,
  DID_PRECIPITATE_DISSOLVE,
  WHAT_STORAGE_TEMPERATURE,
  PROVIDE_TEMPERATURE_LOCATION,
  ARE_TEMPERATURE_LOGS,
  LOGS_CAN_BE_ATTACHED,
  IS_THE_STORAGE_UNIT,
  HOW_PRODUCT_THAWED,
  WHAT_STORAGE_CONDITIONS,
  WAS_ANY_DAMAGE,
  MORE_SPECIFIC_INFORMATION,
  WHAT_PURPOSE_INDICATION,
  WHAT_ROUTE_ADMINISTRATION,
  WHAT_DATE_ADMINISTRATION,
  WHAT_DOSAGE_STRENGTH,
  WAS_RECENT_PRESCRIPTION,
  WHAT_WAS_STORAGE_TEMPERATURE,
  WERE_ANY_ADJUSTMENTS,
  SELECT_APPROPRIATE_DESCRIPTION,
  SELECT_LABELING_ISSUE,
  WAS_CONNECTION_SECURE,
  WAS_EXPIRED_PRODUCT,
  WAS_COMPONENT_DAMAGED,
  WERE_ABNORMALITIES_DAMAGE,
  WHAT_PURCHASE_ORDER_NUMBER,
  WHAT_DATE_OF_ADMINISTRATION,
  WHAT_WAS_EXPIRATION_DATE,
  DESCRIBE_WAS_INCORRECT,
  WHAT_SCANNER_USED,
  WAS_OVERPOUCH_POUCH,
  WHAT_BACKGROUND_COLOR,
  DO_ALL_OF_THE_LABELS,
  PRODUCT_INFORMATION,
  IS_A_BARCODE_SCANNER,
  HOW_ARE_THESE_PRODUCTS,
  WHAT_INFORMATION_INCORRECTLY,
  WAS_THERE_LEAK,
  WHERE_LEAK_OBSERVED,
  WAS_FRANGIBLE_OBSERVED,
  IS_MOISTURE_CLEAR,
  WHO_IS_YOUR_DISTRIBUTOR,
  WHAT_MANUFACTURER_MEDICATION,
  WHAT_GAUGE_NEEDLE,
  WHAT_ADMINISTRATION_SET,
  WAS_DIFFICULTY_SPIKING,
  WERE_FOLLOWING_SCENARIOS,
  WAS_FRANGIBLE_OBSERVED_DEFECT,
  WHAT_AMOUNT_PRESSURE,
  WAS_BAG_COMPLETELY,
  WHAT_MANUFACTURER_MODEL,
  WHAT_PRESSURE_PRIOR,
  LIST_THE_VAPORIZER,
  APPROXIMATELY_HOW_MUCH,
  WAS_THE_BOTTLE_DIFFICULT,
  WERE_VISIBLE_DEFECTS,
  SELECT_THE_OPTION,
  PROVIDE_INVOLVED_CONNECTION_ISSUE,
  WHICH_PART_SEPARATED,
  WHAT_COMPONENT_DISCOLORED,
  SELECT_DESCRIBES_DISCOLORATION,
  WAS_THE_SET_DISCOLORED,
  DID_SET_CHANGE_COLOR,
  WHAT_MEDICATION_ADDED,
  WHERE_MATERIAL_LOCATED,
  DESCRIBE_APPEARANCE_COLOR_SIZE,
  WAS_EMBEDDED_PLASTIC,
  WAS_THERE_A_PRECIPITATE,
  WHAT_MEDICATIONS_SOLUTIONS,
  WHERE_DAMAGE_COMPONENT_AFFECTED,
  WHAT_DAMAGE_ISSUE,
  DID_ISSUE_RESULT,
  WAS_PATIENT_CONNECTED,
  WAS_PRODUCT_REPLACED,
  WHICH_SITUATION_BEST,
  SELECT_MOST_LABELING_ISSUE,
  WHAT_INFORMATION_DISPLAYED,
  WHAT_SCANNER_WAS_USED,
  INCLUDE_THE_MODEL_NAME,
  WAS_PRODUCT_ORDERED,
  WHERE_LEAK_COMING,
  DID_SCENARIOS_OCCURRED_LEAK,
  WAS_POWER_INJECTOR,
  WHAT_INJECTOR_USED,
  MANUFACTURER_NAME_CODE_LOT,
  DESCRIBE_INCORRECT_INCOMPLETE,
  PROVIDE_INFORMATION_SECOND_PRODUCT,
  WHICH_COMPONENTS_WERE_FOUND,
  DESCRIBE_CUT_HOLE_SLICE,
  WAS_LEAK_ORIGINATING,
  PROVIDE_DISCONNECTION_CONNECTION,
  WHICH_SPECIFIC_BONDED,
  WERE_VISIBLE_IRREGULARITIES,
  WAS_SUCCESSFUL_CONNECTION,
  WAS_TOOL_USED_ASSIST,
  WERE_LUER_CONNECTIONS,
  WAS_PRODUCT_SECURELY,
  WHICH_DESCRIBES_FLOW_ISSUE,
  WHAT_FLOWING_BACKWARDS,
  DESCRIBE_COMPONENTS_BACKFLOW,
  DO_SITUATIONS_APPLY,
  WHICH_SPECIFIC_AREA,
  WAS_FLOW_PREVIOUSLY_SEEN,
  WAS_ANY_FOLLOWING_OBSERVED,
  WHERE_SIMULTANEOUS_FLOW,
  WHAT_TYPE_HANGER,
  WHAT_WAS_HANGER_LENGTH,
  WHICH_BAG_LOWER,
  WHAT_Y_SITE_WAS,
  WHAT_COMPONENT_WITHIN,
  WAS_COMPONENT_SET_REPLACED,
  WHAT_VOLUME_FLUID_PERIOD_TIME,
  WHAT_VOLUME_FLUID_OVER_TIME,
  WAS_USED_WITH_PUMP,
  DID_CLAMP_FAIL,
  WHAT_CLAMP_FAILED,
  WAS_ISSUES_OBSERVED_CLAMP,
  DO_OTHER_SITUATIONS_DESCRIBE,
  DESCRIBE_ALARM_OBSERVED,
  INCLUDE_ANY_MESSAGES,
  WHICH_CLAMP_HAD_ISSUE,
  WHICH_TYPE_CLAMP_ISSUE,
  SELECT_BEST_DESCRIBES_ISSUE,
  PROVIDE_MORE_DETAILS,
  PROVIDE_MORE_DETAILS_INSTRUCTIONS,
  DESCRIBE_THE_SMELL,
  WAS_ISSUES_WITH_SET,
  WHERE_LEAK_LOCATED,
  DID_OCCUR_WITH_LEAK,
  PROVIDE_INVOLVED_DISCONNECTION,
  DID_OCCURRED_WITH_THE_LEAK,
  WHERE_WAS_PRODUCT_DAMAGED,
  SELECT_ALL_APPLY,
  DESCRIBE_OBSERVED_DAMAGE,
  WHAT_COMPONENT_IS_DISCOLORED,
  DESCRIBE_HUE_TINT_SHADE,
  INSIDE_OUTSIDE_OVERPOUCH,
  DESCRIBE_EXACT_LOCATION_SIZE,
  DOES_THE_PARTICULATE_MATTER,
  WAS_PARTICULATE_MATERIAL_EMBEDDED,
  DOES_APPEAR_PRODUCT_MATERIAL,
  WHERE_DID_THE_ISSUE_OCCUR,
  LIST_COMPONENTS_IF,
  WERE_THERE_VISIBLE_IRREGULARITIES,
  SELECT_OPTION_FLOW_ISSUE,
  DESCRIBE_IRREGULARITIES,

  HOW_PRODUCT_SETUP,
  SELECT_MOST_APPROPRIATE_DESCRIPTION,
  DESCRIBE_WHAT_INCORRECT_INCOMPLETE,
  WAS_SHIPPING_CARTON_DAMAGED,
  WHAT_PRODUCT_WAS_SUPPOSED,
  IF_PRODUCT_CODE_NOT,
  WAS_THE_CASE_MISSING,
  WHAT_CARRIER_DELIVERED,
  WHAT_IS_PURCHASE_ORDER_NUMBER,
  WHAT_QUANTITY_MISSING_UNITS,
  WAS_EXPIRED_PRODUCT_USE,
  ADD_PRODUCT_TO_THE_GRID,
  SAVE,
  CANCEL,
  ADD_MORE_PRODUCTS,
  REPORTER_ADDRESS,
  ATTACHMENTS,
  COPYRIGHT,
  TERMS_CONDITIONS,
  PRIVACY_POLICY,
  COOKIE_POLICY,
  FORM_SUB_TITLE,
  OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN,
  OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE,
  OPTION_FUNCTIONOPTIONS_CAREGIVER,
  OPTION_FUNCTIONOPTIONS_DISTRIBUTOR,
  OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL,
  OPTION_FUNCTIONOPTIONS_PATIENT,
  OPTION_FUNCTIONOPTIONS_OTHER,
  OPTION_PROCESSSTEPOPTIONS_AFTER_USE,
  OPTION_PROCESSSTEPOPTIONS_BEFORE_USE,
  OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION,
  OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY,
  OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS,
  OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED,
  OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_OCCUPATIONOPTIONS_NURSE,
  OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_OCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_UNITOPTIONS_BOXES,
  OPTION_UNITOPTIONS_PALLETS,
  OPTION_UNITOPTIONS_UNITS,
  OPTION_PROBLEMOPTIONS_ALARM_CONDITION,
  OPTION_PROBLEMOPTIONS_DAMAGE,
  OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE,
  OPTION_PROBLEMOPTIONS_DISCOLORED,
  OPTION_PROBLEMOPTIONS_FLOW_ISSUES,
  OPTION_PROBLEMOPTIONS_LABELING_ISSUES,
  OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE,
  OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL,
  OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT,
  OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY,
  OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION,
  OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT,
  OPTION_PATIENTSEXOPTIONS_FEMALE,
  OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE,
  OPTION_PATIENTSEXOPTIONS_MALE,
  OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER,
  OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER,
  OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE,
  OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR,
  OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER,
  OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE,
  OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN,
  OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT,
  OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER,
  OPTION_REPORTEROCCUPATIONOPTIONS_OTHER,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME,
  OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER,
  OPTION_REPORTEDTOOPTIONS_BAXTER,
  OPTION_REPORTEDTOOPTIONS_CHINA_FDA,
  OPTION_REPORTEDTOOPTIONS_EMA,
  OPTION_REPORTEDTOOPTIONS_FDA,
  OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA,
  OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN,
  OPTION_REPORTEDTOOPTIONS_TUV,
  OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA,
  OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL,
  OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED,
  OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT,
  OPTION_DAMAGEMINICAPOPTIONS_CARTON,
  OPTION_DAMAGEMINICAPOPTIONS_MINICAP,
  OPTION_DAMAGEMINICAPOPTIONS_POUCH,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE,
  OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE,
  OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP,
  OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED,
  OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY,
  OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD,
  OPTION_BLOCKINGFLOWOPTIONS_FIBRIN,
  OPTION_BLOCKINGFLOWOPTIONS_KINK,
  OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE,
  OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE,
  OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE,
  OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH,
  OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE,
  OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR,
  OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID,
  OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH,
  OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE,
  OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE,
  OPTION_RESIDUETHREADSOPTIONS_YES_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE,
  OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT,
  OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_PATCH,
  OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON,
  OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND,
  OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER,
  OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR,
  OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW,
  OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING,
  OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE,
  OPTION_PRODUCTDISCOLOREDOPTIONS_LINER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH,
  OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS,
  OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION,
  OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR,
  OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER,
  OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED,
  OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE,
  OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING,
  OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER,
  OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS,
  OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT,
  OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT,
  OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY,
  OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR,
  OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_DESCOFISSUEOPTIONS_CARTON_BOX,
  OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_DESCOFISSUEOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER,
  OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK,
  OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING,
  OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE,
  OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH,
  OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER,
  OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER,
  OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE,
  OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER,
  OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND,
  OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR,
  OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN,
  OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER,
  OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER,
  NO_DESCRIBE_THE_COLOR,
  OPTION_LIQUIDSPILLEDOPTIONS_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML,
  OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML,
  OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE,
  OPTION_VISIBLEDEFECTSOPTIONS_CAP,
  OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK,
  OPTION_VISIBLEDEFECTSOPTIONS_NONE,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY,
  OTHER_PLEASE_SPECIFY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH,
  OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY,
  OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV,
  OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV,
  OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED,
  OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE,
  OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE,
  OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR,
  OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING,
  DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN,
  DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR,
  OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION,
  OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER,
  OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON,
  OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING,
  OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE,
  OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT,
  OPTION_LEAKCOMINGFROMOPTIONS_BURETTES,
  OPTION_LEAKCOMINGFROMOPTIONS_CAP,
  OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_CLAMP,
  OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER,
  OPTION_LEAKCOMINGFROMOPTIONS_FILTERS,
  OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES,
  OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR,
  OPTION_LEAKCOMINGFROMOPTIONS_SPIKE,
  OPTION_LEAKCOMINGFROMOPTIONS_TUBING,
  OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER,
  OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE,
  OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED,
  OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION,
  OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN,
  DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES,
  YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE,
  OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION,
  OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME,
  OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION,
  OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD,
  OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING,
  OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION,
  OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS,
  OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION,
  OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER,
  OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER,
  OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT,
  OPTION_BAGLOWEROPTIONS_PRIMARY,
  OPTION_BAGLOWEROPTIONS_SECONDARY,
  OPTION_YSITECONNECTEDOPTIONS_MIDDLE,
  OPTION_YSITECONNECTEDOPTIONS_LOWER,
  OPTION_YSITECONNECTEDOPTIONS_UPPER,
  OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME,
  OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE,
  OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP,
  OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR,
  OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER,
  OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH,
  OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP,
  OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN,
  OPTION_WHICHCLAMPISSUEOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT,
  OPTION_LEAKOCCUROPTIONS_CRACK_BREAK,
  OPTION_LEAKOCCUROPTIONS_CUT_SLICE,
  OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE,
  OPTION_LEAKOCCUROPTIONS_HOLE_TEA,
  OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED,
  OPTION_LEAKOCCUROPTIONS_OTHER,
  OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES,
  OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON,
  OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING,
  OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN,
  OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF,
  OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED,
  OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT,
  OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS,
  OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF,
  OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF,
  OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING,
  OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR,
  OPTION_OPTIONFLOWISSUEOPTIONS_OTHER,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE,
  OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER,
  OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT,
  OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT,
  OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN,
  OPTION_ALARMOPTIONS_YES_SPECIFY,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL,
  OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH,
  OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_CASSETT,
  OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE,
  OPTION_COMPONENTHADISSUEOPTIONS_LINES,
  OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE,
  OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE,
  OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS,
  OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON,
  OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD,
  OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE,
  OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE,
  OPTION_MONTHOPTIONS_JAN,
  OPTION_MONTHOPTIONS_FEB,
  OPTION_MONTHOPTIONS_MAR,
  OPTION_MONTHOPTIONS_APR,
  OPTION_MONTHOPTIONS_MAY,
  OPTION_MONTHOPTIONS_JUN,
  OPTION_MONTHOPTIONS_JUL,
  OPTION_MONTHOPTIONS_AUG,
  OPTION_MONTHOPTIONS_SEP,
  OPTION_MONTHOPTIONS_OCT,
  OPTION_MONTHOPTIONS_NOV,
  OPTION_MONTHOPTIONS_DEC,
  OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES,
  OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME,
  OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING,
  OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED,
  OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER,
  OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR,
  OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER,
  OPTION_PROBLEMOPTIONS_OTHER,
  OPTION_REPORTEDTOOPTIONS_OTHER,
  OPTION_DIFFICULTTOUSEOPTIONS_OTHER,
  OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER,
  OPTION_BLOCKINGFLOWOPTIONS_OTHER,
  OPTION_DESCRIBEISSUEOPTIONS_OTHER,
  OPTION_MATERIALLOCATEDOPTIONS_OTHER,
  OPTION_OBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER,
  OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER,
  OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER,
  OPTION_PRODUCTTHAWEDOPTIONS_OTHER,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER,
  OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER,
  OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER,
  OPTION_LABELINGISSUEOPTIONS_OTHER,
  OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER,
  OPTION_MOISTUREOBSERVEDOPTIONS_OTHER,
  OPTION_COMPONENTLEAKINGOPTIONS_OTHER,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER,
  OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER,
  OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER,
  OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER,
  OPTION_WHATCLAMPFAILEDOPTIONS_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER,
  OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER,
  OPTION_PRODUCTDAMAGEDOPTIONS_OTHER,
  OPTION_COMPONENTHADISSUEOPTIONS_OTHER,
  OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_NO,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN,
  OPTION_PREVIOUSLYREPORTEDOPTIONS_YES,
  OPTION_ADDANOTHERFACILITYOPTIONS_NO,
  OPTION_ADDANOTHERFACILITYOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_NO,
  OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN,
  OPTION_PATIENINVOLVEMENTOPTIONS_YES,
  OPTION_OTHERFACILITYREPORTOPTIONS_NO,
  OPTION_OTHERFACILITYREPORTOPTIONS_YES,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN,
  OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES,
  OPTION_AVAILABILITYOPTIONS_NO,
  OPTION_AVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYOPTIONS_NO,
  OPTION_MEDIAAVAILABILITYOPTIONS_YES,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES,
  OPTION_UNUSEDAVAILABILITYOPTIONS_NO,
  OPTION_UNUSEDAVAILABILITYOPTIONS_YES,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_NO,
  OPTION_SELFNEGATIVEIMPACTOPTIONS_YES,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO,
  OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES,
  OPTION_COUNTERACTIONOPTIONS_NO,
  OPTION_COUNTERACTIONOPTIONS_YES,
  OPTION_DRUGUSEDOPTIONS_NO,
  OPTION_DRUGUSEDOPTIONS_YES,
  OPTION_SHARECONTACTOPTIONS_NO,
  OPTION_SHARECONTACTOPTIONS_YES,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO,
  OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES,
  OPTION_DIRECTORDEROPTIONS_NO,
  OPTION_DIRECTORDEROPTIONS_YES,
  OPTION_EXCESSIVEFORCEOPTIONS_NO,
  OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN,
  OPTION_EXCESSIVEFORCEOPTIONS_YES,
  OPTION_TWISTCLAMPOPTIONS_NO,
  OPTION_TWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TWISTCLAMPOPTIONS_YES,
  OPTION_DIFFICULTIESMINICAPOPTIONS_NO,
  OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_NO,
  OPTION_ENVIRONMENTOPTIONS_UNKNOWN,
  OPTION_ENVIRONMENTOPTIONS_YES,
  OPTION_SPONGEVISIBLEOPTIONS_NO,
  OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN,
  OPTION_SPONGEVISIBLEOPTIONS_YES,
  OPTION_MATERIALEMBEDDEDOPTIONS_NO,
  OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_MATERIALEMBEDDEDOPTIONS_YES,
  OPTION_PIECESMATERIALOPTIONS_NO,
  OPTION_PIECESMATERIALOPTIONS_UNKNOWN,
  OPTION_PIECESMATERIALOPTIONS_YES,
  OPTION_DISPOSABLECONNECTIONOPTIONS_NO,
  OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN,
  OPTION_DISPOSABLECONNECTIONOPTIONS_YES,
  OPTION_INITIALCONNECTIONOPTIONS_NO,
  OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN,
  OPTION_INITIALCONNECTIONOPTIONS_YES,
  OPTION_SPIKELUERCONNECTORSOPTIONS_NO,
  OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN,
  OPTION_SPIKELUERCONNECTORSOPTIONS_YES,
  OPTION_PETSORANIMALSOPTIONS_NO,
  OPTION_PETSORANIMALSOPTIONS_UNKNOWN,
  OPTION_PETSORANIMALSOPTIONS_YES,
  OPTION_MINICAPTWISTEDOPTIONS_NO,
  OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN,
  OPTION_MINICAPTWISTEDOPTIONS_YES,
  OPTION_TRANSFERSETOPTIONS_NO,
  OPTION_TRANSFERSETOPTIONS_UNKNOWN,
  OPTION_TRANSFERSETOPTIONS_YES,
  OPTION_RESIDUETHREADSOPTIONS_NO,
  OPTION_RESIDUETHREADSOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_NO,
  OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN,
  OPTION_DAMAGECAUSELEAKOPTIONS_YES,
  OPTION_SHIPPINGCARTONOPENOPTIONS_NO,
  OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONOPENOPTIONS_YES,
  OPTION_ADAPTERDEVICEOPTIONS_NO,
  OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN,
  OPTION_ADAPTERDEVICEOPTIONS_YES,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN,
  OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES,
  OPTION_FORTHMOTIONOPTIONS_NO,
  OPTION_FORTHMOTIONOPTIONS_UNKNOWN,
  OPTION_FORTHMOTIONOPTIONS_YES,
  OPTION_ALARMNOFLOWOPTIONS_NO,
  OPTION_ALARMNOFLOWOPTIONS_UNKNOWN,
  OPTION_ALARMNOFLOWOPTIONS_YES,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_NO,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN,
  OPTION_DISCOLORATIONMARKINGSOPTIONS_YES,
  OPTION_BROKENACTIVATEDOPTIONS_NO,
  OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN,
  OPTION_BROKENACTIVATEDOPTIONS_YES,
  OPTION_vaporizerSightGlassOptions_NO,
  OPTION_vaporizerSightGlassOptions_UNKNOWN,
  OPTION_vaporizerSightGlassOptions_YES,
  OPTION_PRODUCTHEATOPTIONS_NO,
  OPTION_PRODUCTHEATOPTIONS_UNKNOWN,
  OPTION_PRODUCTHEATOPTIONS_YES,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN,
  OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES,
  OPTION_LEAKOBSERVEDOPTIONS_NO,
  OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN,
  OPTION_LEAKOBSERVEDOPTIONS_YES,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN,
  OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES,
  OPTION_CLOUDINESSGOAWAYOPTIONS_NO,
  OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN,
  OPTION_CLOUDINESSGOAWAYOPTIONS_YES,
  OPTION_AGITATEUNITOPTIONS_NO,
  OPTION_AGITATEUNITOPTIONS_UNKNOWN,
  OPTION_AGITATEUNITOPTIONS_YES,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_NO,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN,
  OPTION_PRECIPITATEDISSOLVEOPTIONS_YES,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN,
  OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN,
  OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES,
  OPTION_RECENTPRESCRIPTIONOPTIONS_NO,
  OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN,
  OPTION_RECENTPRESCRIPTIONOPTIONS_YES,
  OPTION_EXPIREDPRODUCTOPTIONS_NO,
  OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTOPTIONS_YES,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_NO,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN,
  OPTION_ABNORMALITIESDAMAGEOPTIONS_YES,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN,
  OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_NO,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN,
  OPTION_LABELSSAMEINFORMATIONOPTIONS_YES,
  OPTION_BARCODESCANNEROPTIONS_NO,
  OPTION_BARCODESCANNEROPTIONS_UNKNOWN,
  OPTION_BARCODESCANNEROPTIONS_YES,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_NO,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEOBSERVEDOPTIONS_YES,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES,
  OPTION_FRANGIBLEBROKENOPTIONS_NO,
  OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN,
  OPTION_FRANGIBLEBROKENOPTIONS_YES,
  OPTION_MOISTURECLEAROPTIONS_UNKNOWN,
  OPTION_MOISTURECLEAROPTIONS_YES,
  OPTION_DIFFICULTYSPIKINGOPTIONS_NO,
  OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN,
  OPTION_DIFFICULTYSPIKINGOPTIONS_YES,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN,
  OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES,
  OPTION_PRESSURECUFFOPTIONS_NO,
  OPTION_PRESSURECUFFOPTIONS_UNKNOWN,
  OPTION_PRESSURECUFFOPTIONS_YES,
  OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN,
  OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_NO,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN,
  OPTION_REMOVEDFROMPACKAGEOPTIONS_YES,
  OPTION_ADDINGMEDICATIONOPTIONS_NO,
  OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN,
  OPTION_ADDINGMEDICATIONOPTIONS_YES,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN,
  OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES,
  OPTION_WASPRODUCTREPLACEDOPTIONS_NO,
  OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN,
  OPTION_WASPRODUCTREPLACEDOPTIONS_YES,
  OPTION_WASPOWERINJECTOROPTIONS_NO,
  OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN,
  OPTION_WASPOWERINJECTOROPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_NO,
  OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN,
  OPTION_INJECTIONSITEOPENINGOPTIONS_YES,
  OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_NO,
  OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN,
  OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES,
  OPTION_TOOLUSEDASSISTOPTIONS_NO,
  OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_NO,
  OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN,
  OPTION_SECUREPRIORUSEOPTIONS_YES,
  OPTION_PRIORDISCONNECTINGOPTIONS_NO,
  OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN,
  OPTION_PRIORDISCONNECTINGOPTIONS_YES,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN,
  OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES,
  OPTION_YSITECONNECTEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_NO,
  OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN,
  OPTION_COMPONENTSETREPLACEDOPTIONS_YES,
  OPTION_WITHPUMPOPTIONS_NO,
  OPTION_WITHPUMPOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_NO,
  OPTION_CLAMPFAILOPTIONS_UNKNOWN,
  OPTION_CLAMPFAILOPTIONS_YES,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_NO,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN,
  OPTION_WASMATERIALEMBEDDEDOPTIONS_YES,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_NO,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN,
  OPTION_APPEARPRODUCTMATERIALOPTIONS_YES,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN,
  OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES,
  OPTION_GELPACKSOPTIONS_NO,
  OPTION_GELPACKSOPTIONS_YES,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_NO,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN,
  OPTION_EXPIREDPRODUCTUSEOPTIONS_YES,
  OPTION_ALARMOPTIONS_NO,
  OPTION_ALARMOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_NO,
  OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN,
  OPTION_CLEANINGSOLUTIONSOPTIONS_YES,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO,
  OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_NO,
  OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN,
  OPTION_TRANSFERREPLACEDOPTIONS_YES,
  OPTION_FULLYTIGHTENEDOPTIONS_NO,
  OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN,
  OPTION_FULLYTIGHTENEDOPTIONS_YES,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO,
  OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_NO,
  OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN,
  OPTION_ISSUERESULTLEAKOPTIONS_YES,
  OPTION_ISSUERESULTLEAKOPTIONS_OTHER,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO,
  OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES,
  OPTION_EXPLICITLYREQUESTOPTIONS_NO,
  OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN,
  OPTION_EXPLICITLYREQUESTOPTIONS_YES,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN,
  OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES,
  OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN,
  OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN,
  OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO,
  OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN,
  OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE,
  OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR,
  OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN,
  OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN,
  OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL,
  OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION,
  OPTION_HANGERUSEDOPTIONS_UNKNOWN,
  OPTION_HANGERUSEDOPTIONS_NONE,
  OPTION_BAGLOWEROPTIONS_UNKNOWN,
  OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER,
  OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN,
  OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO,
  OPTION_WEIGHTUNITOPTIONS_KILOGRAM,
  OPTION_WEIGHTUNITOPTIONS_POUND,
  OPTION_INFUSATESOLUTIONOPTIONS_NO,
  OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN,
  PLEASE_ENTER_THE_VALUE,
  PLEASE_SELECT_THE_VALUE,
  PLEASE_SELECT_THE_DATE,
  PLEASE_CHOOSE_THE_VALUE,
  OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN,
  OPTION_COUNTRYOPTIONS_GREAT_BRITAIN,
  OPTION_COUNTRYOPTIONS_KOSOVO,
  OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND,
  OPTION_COUNTRYOPTIONS_AFGHANISTAN,
  OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS,
  OPTION_COUNTRYOPTIONS_ALBANIA,
  OPTION_COUNTRYOPTIONS_ALGERIA,
  OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA,
  OPTION_COUNTRYOPTIONS_ANDORRA,
  OPTION_COUNTRYOPTIONS_ANGOLA,
  OPTION_COUNTRYOPTIONS_ANGUILLA,
  OPTION_COUNTRYOPTIONS_ANTARCTICA,
  OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA,
  OPTION_COUNTRYOPTIONS_ARGENTINA,
  OPTION_COUNTRYOPTIONS_ARMENIA,
  OPTION_COUNTRYOPTIONS_ARUBA,
  OPTION_COUNTRYOPTIONS_AUSTRALIA,
  OPTION_COUNTRYOPTIONS_AUSTRIA,
  OPTION_COUNTRYOPTIONS_AZERBAIJAN,
  OPTION_COUNTRYOPTIONS_BAHAMAS,
  OPTION_COUNTRYOPTIONS_BAHRAIN,
  OPTION_COUNTRYOPTIONS_BANGLADESH,
  OPTION_COUNTRYOPTIONS_BARBADOS,
  OPTION_COUNTRYOPTIONS_BELARUS,
  OPTION_COUNTRYOPTIONS_BELGIUM,
  OPTION_COUNTRYOPTIONS_BELIZE,
  OPTION_COUNTRYOPTIONS_BENIN,
  OPTION_COUNTRYOPTIONS_BERMUDA,
  OPTION_COUNTRYOPTIONS_BHUTAN,
  OPTION_COUNTRYOPTIONS_BOLIVIA,
  OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA,
  OPTION_COUNTRYOPTIONS_BOTSWANA,
  OPTION_COUNTRYOPTIONS_BOUVET_ISLAND,
  OPTION_COUNTRYOPTIONS_BRAZIL,
  OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY,
  OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM,
  OPTION_COUNTRYOPTIONS_BULGARIA,
  OPTION_COUNTRYOPTIONS_BURKINA_FASO,
  OPTION_COUNTRYOPTIONS_BURUNDI,
  OPTION_COUNTRYOPTIONS_CAMBODIA,
  OPTION_COUNTRYOPTIONS_CAMEROON,
  OPTION_COUNTRYOPTIONS_CANADA,
  OPTION_COUNTRYOPTIONS_CAPE_VERDE,
  OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS,
  OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_CHAD,
  OPTION_COUNTRYOPTIONS_CHILE,
  OPTION_COUNTRYOPTIONS_CHINA,
  OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND,
  OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS,
  OPTION_COUNTRYOPTIONS_COLOMBIA,
  OPTION_COUNTRYOPTIONS_COMOROS,
  OPTION_COUNTRYOPTIONS_CONGO,
  OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE,
  OPTION_COUNTRYOPTIONS_COOK_ISLANDS,
  OPTION_COUNTRYOPTIONS_COSTA_RICA,
  OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST,
  OPTION_COUNTRYOPTIONS_CROATIA,
  OPTION_COUNTRYOPTIONS_CUBA,
  OPTION_COUNTRYOPTIONS_CYPRUS,
  OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC,
  OPTION_COUNTRYOPTIONS_DENMARK,
  OPTION_COUNTRYOPTIONS_DJIBOUTI,
  OPTION_COUNTRYOPTIONS_DOMINICA,
  OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC,
  OPTION_COUNTRYOPTIONS_ECUADOR,
  OPTION_COUNTRYOPTIONS_EGYPT,
  OPTION_COUNTRYOPTIONS_EL_SALVADOR,
  OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA,
  OPTION_COUNTRYOPTIONS_ERITREA,
  OPTION_COUNTRYOPTIONS_ESTONIA,
  OPTION_COUNTRYOPTIONS_ETHIOPIA,
  OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS,
  OPTION_COUNTRYOPTIONS_FAROE_ISLANDS,
  OPTION_COUNTRYOPTIONS_FIJI,
  OPTION_COUNTRYOPTIONS_FINLAND,
  OPTION_COUNTRYOPTIONS_FRANCE,
  OPTION_COUNTRYOPTIONS_FRENCH_GUIANA,
  OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA,
  OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES,
  OPTION_COUNTRYOPTIONS_GABON,
  OPTION_COUNTRYOPTIONS_GAMBIA,
  OPTION_COUNTRYOPTIONS_GEORGIA,
  OPTION_COUNTRYOPTIONS_GERMANY,
  OPTION_COUNTRYOPTIONS_GHANA,
  OPTION_COUNTRYOPTIONS_GIBRALTAR,
  OPTION_COUNTRYOPTIONS_GREECE,
  OPTION_COUNTRYOPTIONS_GREENLAND,
  OPTION_COUNTRYOPTIONS_GRENADA,
  OPTION_COUNTRYOPTIONS_GUADELOUPE,
  OPTION_COUNTRYOPTIONS_GUAM,
  OPTION_COUNTRYOPTIONS_GUATEMALA,
  OPTION_COUNTRYOPTIONS_GUERNSEY,
  OPTION_COUNTRYOPTIONS_GUINEA,
  OPTION_COUNTRYOPTIONS_GUINEA_BISSAU,
  OPTION_COUNTRYOPTIONS_GUYANA,
  OPTION_COUNTRYOPTIONS_HAITI,
  OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE,
  OPTION_COUNTRYOPTIONS_HONDURAS,
  OPTION_COUNTRYOPTIONS_HONG_KONG,
  OPTION_COUNTRYOPTIONS_HUNGARY,
  OPTION_COUNTRYOPTIONS_ICELAND,
  OPTION_COUNTRYOPTIONS_INDIA,
  OPTION_COUNTRYOPTIONS_INDONESIA,
  OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_IRAQ,
  OPTION_COUNTRYOPTIONS_IRELAND,
  OPTION_COUNTRYOPTIONS_ISLE_OF_MAN,
  OPTION_COUNTRYOPTIONS_ISRAEL,
  OPTION_COUNTRYOPTIONS_ITALY,
  OPTION_COUNTRYOPTIONS_JAMAICA,
  OPTION_COUNTRYOPTIONS_JAPAN,
  OPTION_COUNTRYOPTIONS_JERSEY,
  OPTION_COUNTRYOPTIONS_JORDAN,
  OPTION_COUNTRYOPTIONS_KAZAKHSTAN,
  OPTION_COUNTRYOPTIONS_KENYA,
  OPTION_COUNTRYOPTIONS_KIRIBATI,
  OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_KUWAIT,
  OPTION_COUNTRYOPTIONS_KYRGYZSTAN,
  OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  OPTION_COUNTRYOPTIONS_LATVIA,
  OPTION_COUNTRYOPTIONS_LEBANON,
  OPTION_COUNTRYOPTIONS_LESOTHO,
  OPTION_COUNTRYOPTIONS_LIBERIA,
  OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA,
  OPTION_COUNTRYOPTIONS_LIECHTENSTEIN,
  OPTION_COUNTRYOPTIONS_LITHUANIA,
  OPTION_COUNTRYOPTIONS_LUXEMBOURG,
  OPTION_COUNTRYOPTIONS_MACAO,
  OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_MADAGASCAR,
  OPTION_COUNTRYOPTIONS_MALAWI,
  OPTION_COUNTRYOPTIONS_MALAYSIA,
  OPTION_COUNTRYOPTIONS_MALDIVES,
  OPTION_COUNTRYOPTIONS_MALI,
  OPTION_COUNTRYOPTIONS_MALTA,
  OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS,
  OPTION_COUNTRYOPTIONS_MARTINIQUE,
  OPTION_COUNTRYOPTIONS_MAURITANIA,
  OPTION_COUNTRYOPTIONS_MAURITIUS,
  OPTION_COUNTRYOPTIONS_MAYOTTE,
  OPTION_COUNTRYOPTIONS_MEXICO,
  OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF,
  OPTION_COUNTRYOPTIONS_MOLDOVA,
  OPTION_COUNTRYOPTIONS_MONACO,
  OPTION_COUNTRYOPTIONS_MONGOLIA,
  OPTION_COUNTRYOPTIONS_MONTENEGRO,
  OPTION_COUNTRYOPTIONS_MONTSERRAT,
  OPTION_COUNTRYOPTIONS_MOROCCO,
  OPTION_COUNTRYOPTIONS_MOZAMBIQUE,
  OPTION_COUNTRYOPTIONS_MYANMAR,
  OPTION_COUNTRYOPTIONS_NAMIBIA,
  OPTION_COUNTRYOPTIONS_NAURU,
  OPTION_COUNTRYOPTIONS_NEPAL,
  OPTION_COUNTRYOPTIONS_NETHERLANDS,
  OPTION_COUNTRYOPTIONS_NEW_CALEDONIA,
  OPTION_COUNTRYOPTIONS_NEW_ZEALAND,
  OPTION_COUNTRYOPTIONS_NICARAGUA,
  OPTION_COUNTRYOPTIONS_NIGER,
  OPTION_COUNTRYOPTIONS_NIGERIA,
  OPTION_COUNTRYOPTIONS_NIUE,
  OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND,
  OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS,
  OPTION_COUNTRYOPTIONS_NORWAY,
  OPTION_COUNTRYOPTIONS_OMAN,
  OPTION_COUNTRYOPTIONS_PAKISTAN,
  OPTION_COUNTRYOPTIONS_PALAU,
  OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED,
  OPTION_COUNTRYOPTIONS_PANAMA,
  OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA,
  OPTION_COUNTRYOPTIONS_PARAGUAY,
  OPTION_COUNTRYOPTIONS_PERU,
  OPTION_COUNTRYOPTIONS_PHILIPPINES,
  OPTION_COUNTRYOPTIONS_PITCAIRN,
  OPTION_COUNTRYOPTIONS_POLAND,
  OPTION_COUNTRYOPTIONS_PORTUGAL,
  OPTION_COUNTRYOPTIONS_PUERTO_RICO,
  OPTION_COUNTRYOPTIONS_QATAR,
  OPTION_COUNTRYOPTIONS_RÉUNION,
  OPTION_COUNTRYOPTIONS_ROMANIA,
  OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION,
  OPTION_COUNTRYOPTIONS_RWANDA,
  OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY,
  OPTION_COUNTRYOPTIONS_SAINT_HELENA,
  OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS,
  OPTION_COUNTRYOPTIONS_SAINT_LUCIA,
  OPTION_COUNTRYOPTIONS_SAINT_MARTIN,
  OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON,
  OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES,
  OPTION_COUNTRYOPTIONS_SAMOA,
  OPTION_COUNTRYOPTIONS_SAN_MARINO,
  OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE,
  OPTION_COUNTRYOPTIONS_SAUDI_ARABIA,
  OPTION_COUNTRYOPTIONS_SENEGAL,
  OPTION_COUNTRYOPTIONS_SERBIA,
  OPTION_COUNTRYOPTIONS_SEYCHELLES,
  OPTION_COUNTRYOPTIONS_SIERRA_LEONE,
  OPTION_COUNTRYOPTIONS_SINGAPORE,
  OPTION_COUNTRYOPTIONS_SLOVAKIA,
  OPTION_COUNTRYOPTIONS_SLOVENIA,
  OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS,
  OPTION_COUNTRYOPTIONS_SOMALIA,
  OPTION_COUNTRYOPTIONS_SOUTH_AFRICA,
  OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  OPTION_COUNTRYOPTIONS_SPAIN,
  OPTION_COUNTRYOPTIONS_SRI_LANKA,
  OPTION_COUNTRYOPTIONS_SUDAN,
  OPTION_COUNTRYOPTIONS_SURINAME,
  OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN,
  OPTION_COUNTRYOPTIONS_SWAZILAND,
  OPTION_COUNTRYOPTIONS_SWEDEN,
  OPTION_COUNTRYOPTIONS_SWITZERLAND,
  OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC,
  OPTION_COUNTRYOPTIONS_TAIWAN_ROC,
  OPTION_COUNTRYOPTIONS_TAJIKISTAN,
  OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF,
  OPTION_COUNTRYOPTIONS_THAILAND,
  OPTION_COUNTRYOPTIONS_TIMOR_LESTE,
  OPTION_COUNTRYOPTIONS_TOGO,
  OPTION_COUNTRYOPTIONS_TOKELAU,
  OPTION_COUNTRYOPTIONS_TONGA,
  OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO,
  OPTION_COUNTRYOPTIONS_TUNISIA,
  OPTION_COUNTRYOPTIONS_TURKEY,
  OPTION_COUNTRYOPTIONS_TURKMENISTAN,
  OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS,
  OPTION_COUNTRYOPTIONS_TUVALU,
  OPTION_COUNTRYOPTIONS_UGANDA,
  OPTION_COUNTRYOPTIONS_UKRAINE,
  OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES,
  OPTION_COUNTRYOPTIONS_UNITED_KINGDOM,
  OPTION_COUNTRYOPTIONS_UNITED_STATES,
  OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS,
  OPTION_COUNTRYOPTIONS_URUGUAY,
  OPTION_COUNTRYOPTIONS_UZBEKISTAN,
  OPTION_COUNTRYOPTIONS_VANUATU,
  OPTION_COUNTRYOPTIONS_VENEZUELA,
  OPTION_COUNTRYOPTIONS_VIET_NAM,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH,
  OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US,
  OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA,
  OPTION_COUNTRYOPTIONS_WESTERN_SAHARA,
  OPTION_COUNTRYOPTIONS_YEMEN,
  OPTION_COUNTRYOPTIONS_ZAMBIA,
  OPTION_COUNTRYOPTIONS_ZIMBABWE,
  LANDING_TERMS_I_HAVE_READ,
  LANDING_TERMS_THE_USE_DISCLOSURE,
  LANDING_TERMS_THE_TRANSFER_OF,
  LANDING_TERMS_I_UNDERSTAND_THAT,
  OPTION_DOESTHEPARTICULATEMATTER_NO,
  OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN,
  OPTION_DOESTHEPARTICULATEMATTER_YES,
  I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE,
  PRODUCT_LOT,
  SHIPPING_DISTRIBUTION_LABEL,
  CARTON_LABEL,
  INTERNAL_PRODUCT_LABEL,
  TITLE_PD_RENAL,
  TITLE_SOLUTIONS,
  TITLE_ACCESS,
  TITLE_ALL_OTHER_PRODUCT,
  REPORTED_PROBLEM,
  LOGIN,
  SYSTEM_MENU,
  INITIATE_PRODUCT_FEEDBACK,
  FEEDBACK_STATUS,
  OKTACALLBACK,
  VALID_EMAIL,
  VALID_NUMERIC,
  PLEASE_UPLOAD_IMAGE,
  VALID_DATE,
  QUANTITY,
  EDIT,
  DELETE,
  LOT_SERIAL_NO,
  LOT_NUMBER_NOT_FOUND,
  SEARCHING_LOT_NUMBER,
  PRODUCT_CODE_NOT_FOUND,
  SEARCHING_PRODUCT_CODE,
  FILE_OF_TYPES_ARE_NOT_ALLOWED,
  THE_FILE_YOU_ARE_ATTEMPTING,
  IMAGE_ICON,
  LOGIN_TO_ACCOUNT,
  SIGN_IN_TO_YOUR_ACCOUNT,
  BAXTER_EMAIL_ADDRESS,
  PASSWORD,
  SIGN_IN,
  UNKNOWN,
  ASKED_UNKNOWN,
  DD_MMM_YYYY,
  DD,
  MMM,
  YYYY,
  SELECT_COUNTRY,
  CHINESE_SIMPLIFIED_CHINESE,
  DUTCH,
  ENGLISH,
  FRENCH,
  GERMAN,
  ITALIAN,
  JAPANESE,
  KOREAN,
  MANDARIN_TRADITIONAL_CHINESE,
  POLISH,
  PORTUGUESE,
  SPANISH,
  THAI,
  TURKISH,
  VIETNAMESE,
  BROWSE,
  FEEDBACK_SUBMITTED,
  YOUR_PRODUCT_EXPERIENCE_FEEDBACK,
  IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION,
  CLOSE,
  PATIENT_AGE,
  ENTER_AGE,
  PATIENT_DOB,
  RELEVANT_ATTACHMENTS,
  BAXTER_ACCOUNT_CREDENTIALS,
  GET_PRODUCT_DETAILS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_2,
  FACILITY_ADDRESS,
  LABEL_ANOTHER_FACILITY_ADDRESS,
  CHOOSE_PRODUCT_CODE,
  PRIVACY_NOTICE,
  DECLINE,
  OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA,
  OPTION_COUNTRYOPTIONS_CURAÇAO,
  OPTION_COUNTRYOPTIONS_SOUTH_SUDAN,
  OPTION_COUNTRYOPTIONS_ESWATINI,
  FORM_HELP_TEXT,
  YOUR_FIRST_NAME,
  YOUR_LAST_NAME,
  MY_FIRST_NAME,
  MY_LAST_NAME,
  PATIENT_FIRST_NAME,
  PATIENT_LAST_NAME,
  REPORTER_FIRST_NAME,
  REPORTER_LAST_NAME,
  EMPLOYEE_FIRST_NAME,
  EMPLOYEE_LAST_NAME,
  END_USER_CUSTOMER_FIRST_NAME,
  END_USER_CUSTOMER_LAST_NAME,
  ADDITIONAL_CONTACT_FIRST_NAME,
  ADDITIONAL_CONTACT_LAST_NAME,
  COPYRIGHT_BAXTER,
  COPYRIGHT_VERSION,
  ADD_ADDITIONAL_CONTACT,
  CONTACT_ME,
  DO_NOT_CONTACT,
  END_USER_CUSTOMER_FACILITY_NAME,
  END_USER_CUSTOMER_PHONE,
  END_USER_CUSTOMER_EMAIL,
  END_USER_CUSTOMER_FACILITY_ADDRESS,
  SAME_AS_PATIENT_ADDRESS,
  SAME_AS_REPORTER_ADDRESS,
  SAME_AS_END_USER_CUSTOMER_ADDRESS,
  USE_THE_DIAGRAM_ABOVE_FIGURE_3,
  CONTACT_US,
  LANDING_BRIEF_FOR_DEVICE,
  PATIENT_SEX,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY,
  OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER,
  ATTENTION_NEEDED,
  SUBMIT_ERR_MSG,
  SUBMIT_RETRY_MSG,
  OK,
} from '@translations';

let lang: any = {};
let translations: any = {};
lang.translations = translations;

translations[APP_TITLE] = "ช่องทางเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[LANDING_BRIEF] = "ช่องทางเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์ออนไลน์นี้มีจุดประสงค์เพื่อรายงานข้อมูลและแสดงความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[LANDING_LANGUAGE_SELECTOR] = "เลือกภาษา";
translations[LANDING_COUNTRY_SELECTOR] = "เลือกประเทศ";
translations[LANDING_TERMS] = "ฉันได้อ่านและยอมรับเงื่อนไขการใช้งานและนโยบายความเป็นส่วนตัวของช่องทางเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[LANDING_TERMS_ERROR] = "คุณจำเป็นต้องอ่านและยอมรับเงื่อนไขการใช้งานและนโยบายความเป็นส่วนตัวของช่องทางเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[LANDING_CAPTCHA_ERROR] = "โปรดยืนยันว่าคุณไม่ใช่หุ่นยนต์";
translations[APP_DESCRIPTION] = "ช่องทางเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์รูปแบบออนไลน์นี้จัดทำขึ้นเพื่อใช้รายงานข้อมูลเกี่ยวกับผลิตภัณฑ์ หากคุณพบปัญหาจากผลิตภัณฑ์ของแบ็กซ์เตอร์ เราขอสนับสนุนให้คุณร่วมแบ่งปันรายละเอียดของปัญหาดังกล่าวกับเรา ทุกความเห็นของคุณมีความสำคัญและเป็นส่วนช่วยในการพัฒนาผลิตภัณฑ์อย่างต่อเนื่องเพื่อก่อให้เกิดความพึงพอใจสูงสุด";
translations[LANDING_TERMS_I_HAVE_READ] = "ฉันได้อ่านประกาศเกี่ยวกับความเป็นส่วนตัวที่เชื่อมโยงสำหรับพอร์ทัลคำติชมผลิตภัณฑ์ของ Baxter และเข้าใจว่า Baxter Healthcare Corporation (“Baxter”) กำลังขอความยินยอมจากฉันในการใช้ เปิดเผย และประมวลผลข้อมูลส่วนบุคคลของฉันเพื่อวัตถุประสงค์และตามที่อธิบายไว้ในประกาศความเป็นส่วนตัว ฉันขอยินยอมให้:";
translations[LANDING_TERMS_THE_USE_DISCLOSURE] = "การใช้ เปิดเผย จัดเก็บ และประมวลผลข้อมูลส่วนบุคคลของฉัน(รวมถึงข้อมูลที่ละเอียดอ่อน เช่น ข้อมูลที่เกี่ยวข้องกับสุขภาพ ที่ฉันเลือกให้) เพื่อวัตถุประสงค์ที่ระบุไว้ในประกาศเกี่ยวกับความเป็นส่วนตัว";
translations[LANDING_TERMS_THE_TRANSFER_OF] = "การถ่ายโอนข้อมูลส่วนบุคคลของฉัน (รวมถึงข้อมูลที่ละเอียดอ่อน เช่น ข้อมูลด้านสุขภาพ ที่ฉันเลือกให้) ออกนอกประเทศของฉันและไปยังประเทศอื่นซึ่งอาจมีกฎหมายคุ้มครองข้อมูลที่เข้มงวดน้อยกว่าหรือไม่มีเลย";
translations[LANDING_TERMS_I_UNDERSTAND_THAT] = "ฉันเข้าใจว่าความยินยอมนี้เป็นไปโดยสมัครใจและฉันสามารถเปลี่ยนใจได้ตลอดเวลาและเพิกถอนความยินยอมของฉันโดยการติดต่อ Baxter โดยใช้รายละเอียดการติดต่อที่ให้ไว้ในประกาศความเป็นส่วนตัว ฉันเข้าใจว่าการเพิกถอนความยินยอมของฉันจะไม่ส่งผลต่อความถูกต้องตามกฎหมายของการประมวลผลก่อนการเพิกถอน";
translations[MENU_FEEDBACK_FORM] = "เริ่มต้นการเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[MENU_FEEDBACK_STATUS] = "ตรวจสอบสถานะการเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[MENU_FORM_INTAKE] = "ข้อมูลผู้รายงาน";
translations[MENU_FORM_EVENT_DETAILS] = "รายละเอียดเหตุการณ์";
translations[MENU_FORM_PRODUCT_INFO] = "ข้อมูลผลิตภัณฑ์";
translations[SYSTEM_FEEDBACK_FORM] = "สร้างแบบฟอร์มเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[SYSTEM_FEEDBACK_STATUS] = "ตรวจสอบสถานะการเสนอแนะความคิดเห็น";
translations[SUBMIT_FEEDBACK] = "กดที่นี่เพื่อส่ง";
translations[CHECK_SUBMITTED_FEEDBACK] = "กดที่นี่เพื่อตรวจสอบสถานะการเสนอแนะความคิดเห็นครั้งก่อนหน้า";
translations[BTN_LAUNCH_FORM] = "เปิดแบบฟอร์ม";
translations[BTN_CHECK_STATUS] = "ตรวจสอบสถานะ";
translations[FORM_TITLE] = "แบบฟอร์มการเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[FORM_SUB_TITLE] = "หากมีผู้ป่วยหลายรายที่เกี่ยวข้อง โปรดกรอก 1 แบบฟอร์มต่อผู้ป่วย 1 ราย";
translations[FORM_MANDATORY_FIELDS] = "กรุณาใส่ข้อความในช่องที่มีเครื่องหมาย * ให้ครบถ้วน";
translations[BUTTON_PREV] = "ก่อนหน้า";
translations[BUTTON_NEXT] = "ต่อไป";
translations[BUTTON_SUBMIT] = "ส่ง";
translations[SELECT_RESPONSE] = "เลือกการตอบรับ";
translations[FUNCTION_ROLE] = "อาชีพ/ตำแหน่ง";
translations[CUSTOMER_ACCOUNT_NUMBER] = "หมายเลขประจำตัวลูกค้า";
translations[ENTER_CUSTOMER_ACCOUNT] = "ระบุหมายเลขประจำตัวลูกค้า";
translations[HELP_CUSTOMER_ACCOUNT_NUMBER] = "หมายเลขประจำตัวของลูกค้าที่เกี่ยวข้องในเหตุการณ์นี้คืออะไร";
translations[EVENT_REPORTED] = "เหตุการณ์นี้เคยถูกแจ้งให้ทางแบ็กซ์เตอร์หรือผู้เกี่ยวข้องทราบมาก่อนหน้า";
translations[REFERENCE_NUMBER] = "หมายเลขอ้างอิงที่เกี่ยวข้องกับเหตุการณ์";
translations[ENTER_REFERENCE] = "ระบุหมายเลขอ้างอิง (หากเหตุการณ์เคยถูกรายงานมาก่อน)";
translations[WHO_REPORTED_TO] = "คุณแจ้งเหตุการณ์นี้กับใคร";
translations[WHO_WAS_NOTIFIED] = "ระบุชื่อผู้ได้รับแจ้ง";
translations[ENTER_NAME] = "กรุณาใส่ชื่อ";
translations[PRODUCT_SURVEILLANCE] = "บริษัทขออนุญาตติดต่อกลับไปยังคุณหรือบุลคลใกล้ชิดเพื่อสอบถามข้อมูลเพิ่มเติมได้หรือไม่";
translations[YOUR_NAME] = "ชื่อ";
translations[OCCUPATION] = "อาชีพ/ตำแหน่ง";
translations[PHONE_NUMBER] = "เบอร์โทรศัพท์";
translations[ENTER_PHONE_NUMBER] = "กรุณาใส่เบอร์โทรศัพท์";
translations[ENTER_EMAIL] = "กรุณาใส่อีเมล";
translations[EMAIL_ADDRESS] = "อีเมล";
translations[ENTER_ADDRESS] = "กรุณาใส่อีเมล";
translations[ENTER_NA_IF_UNKNOWN] = "ป้อน NA หากไม่ทราบ";
translations[FACILITY_HOSPITAL] = "ชื่อโรงพยาบาล/สถานที่ หรือ ชื่อผู้จัดหน่าย(ถ้ามี)";
translations[ENTER_FACILITY] = "กรุณาใส่สถานที่";
translations[ADDRESS_1] = "ที่อยู่ 1";
translations[ADDRESS_2] = "ที่อยู่ 2";
translations[CITY] = "เมือง";
translations[STATE] = "รัฐ";
translations[POSTAL_CODE] = "รหัสไปรษณีย์";
translations[COUNTRY] = "ประเทศ";
translations[END_USER_CUSTOMER] = "ปัญญานี้พบโดยผู้ใช้งาน/ลูกค้าใช่หรือไม่";
translations[ADDITIONAL_CONTACT_PERSON] = "ชื่อผู้ติดต่อเพิ่มเติม";
translations[ADDITIONAL_PHONE] = "เบอร์โทรศัพท์ผู้ติดต่อเพิ่มเติม";
translations[ADDITIONAL_EMAIL] = "อีเมลผู้ติดต่อเพิ่มเติม";
translations[ANOTHER_FACILITY_ADDRESS] = "สถานที่/ที่อยู่อื่น ๆ เพิ่มเติม";
translations[ANOTHER_FACILITY_HOSPITAL] = "ชื่อโรงพยาบาล/สถานที่ หรือ ชื่อผู้จัดจำหน่ายเพิ่มเติม (ถ้ามี)";
translations[ANOTHER_ENTER_FACILITY] = "กรุณาใส่สถานที่";
translations[ANOTHER_ADDRESS_1] = "ที่อยู่ 1";
translations[ANOTHER_ADDRESS_2] = "ที่อยู่ 2";
translations[ANOTHER_CITY] = "เมือง";
translations[ANOTHER_STATE] = "รัฐ";
translations[ANOTHER_POSTAL_CODE] = "รหัสไปรษณีย์";
translations[ANOTHER_COUNTRY] = "ประเทศ";
translations[LOT_SERIAL_NUMBER] = "หมายเลขรุ่นการผลิต (Lot Number/Serial Number)";
translations[ENTER_LOT_SERIAL_NUMBER] = "กรุณาใส่หมายเลขรุ่นการผลิต (Lot number/Serial Number)";
translations[HELP_LOT_SERIAL_NUMBER] = "เลือก 'Unknown' หากว่าคุณไม่ทราบหมายเลข Lot หรือ Serial number หรือหากคุณผู้แจ้งแล้วผู้แจ้งไม่ทราบ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_PRODUCT_CODE] = "รหัสผลิตภัณฑ์";
translations[PRODUCT_CODE] = "รหัสผลิตภัณฑ์";
translations[ENTER_PRODUCT_CODE] = "กรุณาใส่รหัสผลิตภัณฑ์ (Product code)";
translations[HELP_PRODUCT_CODE] = "เลือก 'Unknown' หากว่าคุณไม่ทราบรหัสผลิตภัณฑ์ (Product Code) หรือหากคุณถามผู้แจ้งแล้วผู้แจ้งไม่ทราบรหัสผลิตภัณฑ์";
translations[NDC] = "รหัสยาของสหรัฐฯ (National Drug Code-NDC Number)";
translations[ENTER_NDC] = "กรุณาใส่รหัสยาของสหรัฐฯ (National Drug Code-NDC Number)";
translations[UDI] = "หมายเลขเฉพาะประจำอุปกรณ์ (Unique Device Identifier-UDI)";
translations[ENTER_UDI] = "กรุณาใส่หมายเลขเฉพาะประจำอุปกรณ์ (Unique Device Identifier-UDI)";
translations[PRODUCT_NAME] = "ชื่อผลิตภัณฑ์";
translations[ENTER_PRODUCT_NAME] = "กรุณาใส่ชื่อผลิตภัณฑ์";
translations[HELP_PRODUCT_NAME] = "ระบุชื่อหรือคำอธิบายของผลิตภัณฑ์";
translations[BEST_DESCRIBES] = "โปรดเลือกคำอธิบายปัญหาที่เหมาะสม";
translations[QUANTITY_TO_SELECT] = "จำนวน";
translations[ENTER_QUANTITY] = "กรุณาใส่จำนวน";
translations[HELP_QUANTITY] = "จำนวนผลิตภัณฑ์ที่มีปัญหา";
translations[UNIT] = "ชิ้น";
translations[AVAILABLE_TO_RETURNED] = "ผลิตภัณฑ์ที่มีปัญหาสามารถถูกส่งกลับมายังแบ็กซ์เตอร์เพื่อทำการตรวจสอบได้หรือไม่";
translations[PHOTOGRAPH_AVAILABLE] = "มีรูปภาพหรือวีดีโอประกอบหรือไม่";
translations[HELP_PHOTOGRAPH_AVAILABLE] = "ตรวจสอบให้แน่ใจว่าปัญหาที่รายงานสามารถมองเห็นได้ในภาพถ่ายหรือวิดีโอ";
translations[UPLOAD_IMAGES] = "อัพโหลดรูปภาพ";
translations[REPORTER_NAME] = "ชื่อผู้แจ้ง";
translations[REPORTER_FACILITY] = "ชื่อสถานที่/ที่อยู่ของผู้แจ้ง";
translations[REPORTER_OCCUPATION] = "อาชีพของผู้แจ้ง";
translations[ENTER_NUMBER] = "กรุณาใส่หมายเลข";
translations[REPORTER_PHONE_NUMBER] = "เบอร์โทรศัพท์ของผู้แจ้ง";
translations[REPORTER_EMAIL_ADDRESS] = "อีเมลของผู้แจ้ง";
translations[EMPLOYEE_NAME] = "ชื่อพนักงาน";
translations[EMPLOYEE_PHONE_NUMBER] = "เบอร์โทรศัพท์ของพนักงาน";
translations[EMPLOYEE_EMAIL_ADDRESS] = "อีเมลของพนักงาน";
translations[RETURNING_FOR_INVESTIGATION] = "จำนวนผลิตภัณฑ์ที่มีปัญหาที่คุณจะส่งกลับมาให้ทางบริษัททำการสืบสวน";
translations[HELP_RETURNING_FOR_INVESTIGATION] = "ตัวอย่างเหล่านี้ควรเป็นผลิตภัณฑ์ที่มีปัญหาที่ถูกรายงาน";
translations[UNUSED_BAXTER_PRODUCT] = "มีผลิตภัณฑ์แบ็กซ์เตอร์ที่ยังไม่เปิดใช้งานและมีหมายเลขรุ่นการผลิตเดียวกันกับผลิตภัณฑ์ที่มีปัญหา ที่สามารถส่งกลับให้ทางแบ็กซ์เตอร์ตรวจสอบหรือไม่";
translations[YOU_INDICATED_SAMPLES] = "คุณสามารถส่งผลิตภัณฑ์ที่มีปัญหาให้กับผู้ให้บริการทางการแพทย์ของคุณได้หรือไม่ ";
translations[SAMPLE_RETURN_KIT] = "You indicated samples were available for evaluation, please confirm the address provided to send the sample return kit:";
translations[A_BOX_WITH_A_PREPAID_LABEL] = "กล่องที่มีฉลากแปะจะถูกส่งไปยังที่อยู่นี้สำหรับการส่งคืนตัวอย่าง";
translations[SAME_AS_MY_ADDRESS] = "เหมือนกันกับที่อยู่ข้างต้น";
translations[OTHER_CONTACT_NAME] = "ชื่อผู้ติดต่อท่านอื่นๆ";
translations[OTHER_CONTACT_OCCUPATION] = "อาชีพผู้ติดต่อท่านอื่นๆ";
translations[OTHER_CONTACT_PHONE_NUMBER] = "เบอร์โทรศัพท์ผู้ติดต่อท่านอื่นๆ";
translations[OTHER_CONTACT_EMAIL_ADDRESS] = "อีเมลผู้ติดต่อท่านอื่นๆ";
translations[MANUFACTURED_BY_ANOTHER_COMPANY] = "ในกรณีที่เป็นผลิตภัณฑ์จากบริษัทอื่น คุณยินยอมให้บริษัทดังกล่าวติดต่อไปยังคุณกรณีที่มีคำถามอื่นๆ เพิ่มเติมหรือไม่";
translations[CUSTOMER_EXPLICITLY_REQUEST] = "ลูกค้ามีการขอผลการสืบสวนหาสาเหตุหรือไม่";
translations[EXPLICITLY_REQUEST_CREDIT] = "ลูกค้าขอเครดิตหรือไม่";
translations[PRODUCT_FROM_BAXTER] = "ลูกค้าได้ทำการสั่งผลิตภัณฑ์จากแบ็กซ์เตอร์โดยตรงใช่หรือไม่";
translations[QUANTITY_REQUESTED_CREDIT] = "หมายเลขรุ่นการผลิตและจำนวนที่ลูกค้ามีการขอเครดิต";
translations[ENTER_OCCUPATION] = "กรุณาใส่อาชีพ";
translations[LOT_QUANTITY_NUMBER] = "กรุณาใส่หมายเลขรุ่นการผลิต (Lot number) และจำนวน";
translations[WHOLESALERS_NAME] = "ะไรชื่อบริษัทฯ ค้าส่งและที่อยู่ (จังหวัด)";
translations[PLACE_WHOLESALERS_NAME] = "ชื่อบริษัทฯ ค้าส่งและที่อยู่ (จังหวัด)";
translations[ADD_PRODUCT_TO_THE_GRID] = "เพิ่มผลิตภัณฑ์ลงในตาราง";
translations[SAVE] = "บันทึก";
translations[CANCEL] = "ยกเลิก";
translations[ADD_MORE_PRODUCTS] = "เพิ่มผลิตภัณฑ์อื่นๆ";
translations[REPORTER_ADDRESS] = "ที่อยู่ของผู้แจ้ง";
translations[ATTACHMENTS] = "ไฟล์แนบ";
translations[DATE_OF_EVENT] = "วันที่ที่เกิดเหตุการณ์";
translations[DATE_OF_EVENT_MSG] = "วันที่เกิดเหตุการณ์ไม่สามารถเกิดหลังวันที่พนักงานแบ็กซ์เตอร์ได้รับแจ้งเหตุการณ์ กรุณาใส่วันที่ใหม่";
translations[HELP_DATE_OF_EVENT] = "หากมีวันที่เกิดเหตุการณ์หลายวัน โปรดกรอกแบบฟอร์มสำหรับเหตุการณ์แต่ละวัน";
translations[DATE_BAXTER_EMPLOYEE] = "วันที่ที่พนักงานแบ็กซ์เตอร์ได้รับแจ้งครั้งแรก";
translations[DATE_MESSAGE_BAXTER_EMPLOYEE] = "(วันที่ที่ระบุไม่จำเป็นต้องตรงกับวันที่ป้อนข้อมูล)";
translations[DURING_WHAT_PROCESS] = "เหตุการณ์เกิดขึ้นระหว่างขั้นตอนใดของการใช้งานผลิตภัณฑ์";
translations[WAS_THE_PATIENT] = "เหตุการณ์เกิดขึ้นขณะผู้ป่วยทำการรักษา/ใช้งานผลิตภัณฑ์นี้ใช่หรือไม่";
translations[WERE_YOU_CONNECTED] = "ขณะเกิดเหตุการณ์ คุณกำลังอยู่ระหว่างการทำการรักษาหรือไม่";
translations[PROVIDE_ANY_ADDITIONAL] = "อธิบายรายละเอียดที่เกี่ยวข้องกับเหตุการณ์/ปัญหาเพิ่มเติม";
translations[HELP_YOU_IDENTIFIED_MORE] = "คุณระบุผลิตภัณฑ์และปัญหามากกว่าหนึ่งรายการ โปรดชี้แจงว่าผลิตภัณฑ์ใดที่ต้องการรายงานปัญหา";
translations[ENTER_DETAILS] = "กรุณาใส่รายละเอียด";
translations[PROVIDE_ANY_ATTACHMENT] = "แนบไฟล์เพิ่มเติม (ถ้ามี)";
translations[WAS_NEGATIVE_MEDICAL] = "ผู้ป่วยพบอาการผิดปกติหรือได้รับบาดเจ็บจากเหตุการณ์นี้หรือไม่";
translations[WAS_MEDICAL_INTERVENTION] = "ผู้ป่วยได้รับการรักษาหรือยาเพื่อเป็นการบรรเทาอาการที่เกิดขึ้นจากเหตุการณ์นี้หรือไม่";
translations[PROVIDE_DETAILS] = "อธิบายรายละเอียดเหตุการณ์";
translations[REQUIRED_TREATMENT] = "การรักษา/การให้ยาที่ผู้ป่วยได้รับ";
translations[ENTER_TREATMENT] = "กรุณาใส่การรักษา";
translations[RELEVANT_TESTS] = "ผลการทดสอบที่เกี่ยวข้อง รวมถึงผลแลปต่างๆ";
translations[HELP_RELEVANT_TESTS] = "กรุณาใส่ผลการทดสอบที่เกี่ยวข้อง";
translations[RELEVANT_MEDICAL_HISTORY] = "ประวัติการใช้ยาของผู้ป่วย รวมถึงยาที่ผู้ป่วยใช้อยู่";
translations[ENTER_HISTORY] = "ระบุประวัติการรักษาทั้งหมดที่เกี่ยวข้อง";
translations[PATIENT_NAME] = "ชื่อผู้ป่วย";
translations[PATIENT_INITIALS] = "ชื่อย่อของผู้ป่วยหรือชื่อเต็ม หากมีผู้ป่วยหลายรายที่เกี่ยวข้อง โปรดกรอก 1 แบบฟอร์มต่อผู้ป่วย 1 ราย";
translations[PATIENT_PHONE_NUMBER] = "เบอร์โทรศัพท์ผู้ป่วย";
translations[I_DO_NOT_WISH_TO_PROVIDE] = "ไม่ประสงค์จะให้ข้อมูล";
translations[PATIENT_EMAIL_ADDRESS] = "อีเมลผู้ป่วย";
translations[PATIENT_ADDRESS] = "ที่อยู่ผู้ป่วย";
translations[SAME_ADDRESS] = "ที่อยู่เดียวกัน";
translations[DRUG_BEING_USED] = "ขณะเกิดเหตุการณ์ พบการใช้ผลิตภัณฑ์ยาของแบ็กซ์เตอร์หรือไม่";
translations[PATIENT_IDENTIFIER] = "ชื่อหรืออักษรย่อของผู้ป่วย";
translations[PATIENT_AGE_OR_DOB] = "อายุผู้ป่วยหรือ DOB";
translations[ENTER_PATIENT_AGE] = "เดือน/วัน/ปี, กรุณาใส่ชื่อผู้ป่วย";
translations[PATIENT_GENDER] = "เพศของผู้ป่วย";
translations[PATIENT_WEIGHT] = "น้ำหนักของผู้ป่วย";
translations[ENTER_WEIGHT] = "กรุณาใส่น้ำหนัก";
translations[PATIENT_WEIGHT_UNIT] = "หน่วยน้ำหนักของผู้ป่วย";
translations[MY_NAME] = "ชื่อของฉัน";
translations[ENTER_IN_YOUR_CONTACT] = "ป้อนข้อมูลติดต่อของคุณ";
translations[MY_PHONE_NUMBER] = "เบอร์โทรศัพท์ของฉัน";
translations[MY_EMAIL_ADDRESS] = "อีเมลของฉัน";
translations[MY_ADDRESS] = "ที่อยู่";
translations[NAME_OF_BAXTER_DRUG] = "ชื่อยาของแบ็กซ์เตอร์";
translations[ENTER_DRUG_NAME] = "กรุณาใส่ชื่อยา";
translations[PLEASE_PROVIDE_THE_NAME] = "โปรดระบุชื่อหรือรหัสผลิตภัณฑ์ของยา Baxter ระบุชื่อยาของ Baxter ทั้งหมดที่กำลังใช้ในขณะที่รายงานปัญหา";
translations[SELECT_THE_COMPONENT] = "เลือกส่วนประกอบที่มีปัญหา";
translations[USE_THE_DIAGRAM] = "ใช้แผนภาพด้านบน (รูปที่ 1) เพื่อระบุตำแหน่งของความเสียหายที่เกิดขึ้น";
translations[TYPE_OF_DAMAGE] = "โปรดอธิบายลักษณะของความเสียหายที่เกิดขึ้น";
translations[PLEASE_ENTER_VALUE] = "กรุณาใส่เลือกค่า";
translations[WAS_THE_PRODUCT_KINKED] = "ผลิตภัณฑ์บุบ แตก งอ ขาด ฯลฯ หรือไม่?";
translations[WERE_ANY_CLEANING] = "มีการใช้น้ำยาทำความสะอาดหรือน้ำยาฆ่าเชื้อกับผลิตภัณฑ์หรือไม่";
translations[WHAT_WAS_THE_DISINFECTANT] = "ชื่อน้ำยาฆ่าเชื้อที่ใช้และวิธีการใช้";
translations[NOTE_BAXTER_LABELING] = "ข้อความบนฉลากแบ็กซ์เตอร์ะบุว่าไม่ให้ใช้สารฟอกขาว ไฮโดรเจนเปอร์ออกไซด์ แอลกอฮอล์ หรือน้ำยาฆ่าเชื้อที่มีแอลกอฮอล์กับเซ็ต การใช้น้ำยาเหล่านี้กับเซ็ตสามารถทำให้ผลิตภัณฑ์เกิดรอยแตกได้";
translations[SELECT_ALL_THAT_APPLY] = "เลือกทั้งหมดที่เกี่ยวข้อง";
translations[DID_FOLLOWING_OCCUR] = "ท่านพบเหตุการณ์ใดบ้าง";
translations[SELECT_THE_LOCATION] = "กรุณาชี้บริเวณที่มินิแคป (minicap) เกิดความเสียหาย";
translations[WAS_THE_PRODUCT_EXPOSED] = "ก่อนจะพบปัญหา ผลิตภัณฑ์ได้รับแรงกระแทกเสียหาย (ชน, ทำตก, โยน) หรือไม่";
translations[HOW_LONG_TRANSFER] = "ผู้ป่วยใช้งานทรานเฟอร์เซต (transfer set) มานานเท่าไร";
translations[WAS_THERE_DIFFICULTY] = "การหมุนเกลียวเพื่อเปิดและปิดทำได้ยากหรือไม่";
translations[WAS_DEVICE_OR_TOOL] = "มีการใช้เครื่องมือหรืออุปกรณ์ช่วยในการหมุนเกลียวเปิดและปิดหรือไม่";
translations[DESCRIBE_HOW_PRODUCT] = "กรุณาอธิบายถึงความยากในการใช้งานผลิตภัณฑ์ (เลือกทุกข้อที่ตรงกัน)";
translations[DID_YOU_OBSERVE] = "คุณสังเกตเห็นความเสียหายบนผลิตภัณฑ์หรือไม่ (รอยตัด, รู, แตก)";
translations[WERE_DIFFICULTIES_PUTTING] = "การหมุนปิดทรานเฟอร์เซตด้วยมินิแคปเป็นไปอย่างลำบากหรือไม่";
translations[WAS_THE_TRANSFER] = "มีการเปลี่ยนไปใช้ทรานเฟอร์เซตอันใหม่แทนหรือไม่";
translations[SELECT_TYPE_OF_FLOW] = "กรุณาเลือกประเภทของปัญหาการไหล";
translations[WAS_ANYTHING_BLOCKING] = "มีบางอย่างขัดขวางการไหลหรือไม่";
translations[WAS_ANY_ALARM] = "พบการแจ้งเตือนใดๆหรือไม่";
translations[SELECT_BEST_DESCRIBE] = "เลือกคำที่อธิบายปัญหาได้ดีที่สุด";
translations[WERE_THE_MINICAPS] = "มินิแคปถูกเก็บไว้ในสถานที่ที่ร้อน/เย็นเกินไป หรือสัมผัสความร้อน/เย็นเกินไปหรือไม่";
translations[WAS_THE_SPONGE_VISIBLE] = "สามารถมองเห็นฟองน้ำภายในมินิแคปหรือไม่";
translations[WHERE_PARTICULATE_MATTERFOREIGN] = "บริเวณใดที่พบสิ่งแปลกปลอม/สิ่งปลอมปน";
translations[DESCRIBE_THE_EXACT_LOCATION] = "กรุณาระบุตำแหน่ง ขนาด รูปร่าง และสีของสิ่งแปลกปลอม/สิ่งปลอมปนที่พบ";
translations[WAS_THE_PARTICULATE_MATTER] = "สิ่งแปลกปลอม/สิ่งปลอมปนฝังอยู่ในผลิตภัณฑ์หรือไม่";
translations[DOES_THE_PARTICULATE_MATER] = "สิ่งแปลกปลอม/สิ่งปลอมปนที่พบมีส่วนที่น่าจะเป็นวัสดุที่ใช้ในการผลิตผลิตภัณฑ์หรือไม่";
translations[WHAT_COMPONENT_DOES] = "อนุภาคดังกล่าวน่าจะมาจากส่วนประกอบใด";
translations[SELECT_CONNECTION_ISSUE] = "เลือกคำที่อธิบายปัญหาการเชื่อมต่อได้ดีที่สุด";
translations[WERE_ASSIST_DEVICES] = "มีการใช้เครื่องมือหรืออุปกรณ์เพื่อช่วยในการเชื่อมต่อหรือไม่";
translations[WERE_ANY_DIFFICULTIES] = "การเชื่อมต่อและการถอดออกเป็นไปได้ด้วยความยากลำบากหรือไม่";
translations[PROVIDE_PRODUCT_INFORMATION] = "ระบุข้อมูลเกี่ยวกับผลิตภัณฑ์อื่นๆที่ใช้พร้อมกันระหว่างเจอปัญหาการเชื่อมต่อ";
translations[WERE_THE_SPIKE_LUER] = "เกลียวหมุนสามารถหมุนตามเข็มนาฬิกาจนปิดสนิทได้หรือไม่";
translations[BAXTER_LABELING_STATES] = "ข้อความบนฉลากแบ็กซ์เตอร์ะบุให้คุณตรวจสอบให้แน่ใจว่าการเชื่อมต่อเซ็ตประเภทใช้แล้วทิ้งทั้งหมดต่อได้แน่นก่อนเริ่มการรักษา";
translations[WERE_PETS_OR_ANIMALS] = "มีโอกาสที่แมลงหรือสัตว์จะเข้าไปทำลายผลิตภัณฑ์หรือไม่";
translations[BAXTER_LABELING_CONTAMINATION] = "ข้อความบนฉลากแบ็กซ์เตอร์ะบุว่าหากสัตว์เลี้ยงหรือสัตว์กัดผลิตภัณฑ์ของคุณ อาจส่งผลให้เกิดการปนเปื้อนของสารละลายขณะใช้งานได้ เพื่อลดความเสี่ยงดังกล่าว กรุณางดทำการล้างไตในห้องเดียวกันกับสัตว์เลี้ยงหรือสัตว์";
translations[WERE_OTHER_ISSUES] = "พบปัญหาอื่นๆที่เกี่ยวข้องกับ spike หรือ luer หรือไม่ (ตัวอย่างเช่น แตก, ผิดรูป, หักงอ เป็นต้น)";
translations[WAS_MINICAP_TWISTED] = "สามารถหมุนฝามินิแคปตามเข็มนาฬิกาจนปิดสนิทได้หรือไม่";
translations[WERE_DIFFICULTIES_TRANSFER_SET] = "การปิดทรานเฟอร์เซตด้วยมินิแคปเป็นไปอย่างลำบากหรือไม่";
translations[DID_TRANSFER_SET_CONNECTORS] = "พบร่องรอยความเสียหายที่บริเวณเกลียวหมุนหรือไม่";
translations[WHAT_WAS_THE_ALARM] = "ลักษณะการแจ้งเตือนเป็นอย่างไร";
translations[WHERE_OBSERVED_DAMAGE] = "บริเวณใดที่พบความเสียหายของผลิตภัณฑ์ (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[SELECT_THE_TYPE_OBSERVED] = "โปรดเลือกประเภทของความเสียหายที่พบ (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[DID_DAMAGE_CAUSE_LEAK] = "ความเสียหายดังส่งผลให้เกิดการรั่วของน้ำยาหรือไม่";
translations[WAS_THE_SHIPPING_CARTON] = "คุณได้ใช้ของมีคมในการเปิดกล่องบรรจุสินค้าหรือไม่";
translations[SELECT_FLOW_ISSUE_OBSERVED] = "เลือกปัญหาการไหลที่พบ";
translations[HOW_LONG_WAS_STORAGE] = "ผลิตภัณฑ์ถูกเก็บไว้นานเท่าไหร่ก่อนจะพบว่าหมดอายุ";
translations[WAS_THERE_AN_ADAPTER] = "มีการใช้อะแดปเตอร์หรืออุปกรณ์อื่นๆกับผลิตภัณฑ์หรือไม่";
translations[NAME_AND_MODEL] = "ขอทราบชื่อและรุ่นของอะแดปเตอร์หรืออุปกรณ์อื่นๆ";
translations[NAME_VAPORIZER] = "ขอทราบชื่อและรุ่นของเครื่อง vaporizer";
translations[WAS_VIAL_INVERTED] = "ก่อนจะมีการบีบสารละลายเข้าขวดแก้ว ขวดแก้วถูกต่อในลักษณะกลับหัวหรือไม่";
translations[WHAT_VIAL_USED] = "ระบุข้อมูลสินค้าของขวดแก้วที่ใช้";
translations[DRUG_NAME_MANUFACTURER] = "ระบุชื่อยา ผู้ผลิต ขนาดขวด";
translations[WERE_BREAK_FRANGIBLE] = "แกน frangible สามารถหักไปมาได้ตามปกติหรือไม่";
translations[WAS_ALARM_ASSOCIATED] = "พบการแจ้งเตือนใดๆ ที่เกี่ยวข้องกับการอุดตันนี้หรือไม่";
translations[WHAT_PART_DISCOLORED] = "ส่วนใดของผลิตภัณฑ์ที่มีการพบว่าสีเปลี่ยนไป  (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[DESCRIBE_DISCOLORATION] = "อธิบายเกี่ยวกับการเปลี่ยนสี (เช่น ลักษณะสี, เฉดสี, ความเข้ม, ความอ่อน ฯลฯ)";
translations[HOW_PRODUCT_STORED] = "อธิบายวิธีการเก็บผลิตภัณฑ์ของคุณ";
translations[DOES_DISCOLORATION_APPEAR] = "ลักษณะสีที่เปลี่ยนไปมีความขุ่นมัว หรือพบรอยวงกลม/รอยหกเหลี่ยม";
translations[WHICH_CHAMBER_DISCOLORED] = "พบน้ำยาเปลี่ยนสีในถุงน้ำยาช่องใด";
translations[WAS_PEEL_SEAL_INTERCHAMBER] = "มีการขาดของรอยกั้นระหว่างถุง (peel seal) หรือไม่";
translations[WAS_DISCOLORATION_NOTICED] = "พบสีเปลี่ยนบริเวณ vaporizer sight glass ใช่หรือไม่";
translations[SELECT_SPECIFICALLY_DESCRIBES] = "กรุณาเลือกข้อที่อธิบายปัญหาของคุณได้เจาะจงที่สุด";
translations[WHAT_DEVICE_HAD_ALARM] = "พบการแจ้งเตือนจากเครื่องหรือไม่";
translations[WHAT_MISSING_MISASSEMBLED] = "มีส่วนประกอบใดหายไปหรือประกอบผิดหรือไม่";
translations[RECONSTITUTION_ISSUE] = "กรุณาระบุคำอธิบายอย่างละเอียดเกี่ยวกับปัญหาการผสม";
translations[WHAT_MEDICATION_SOLUTION] = "ระบุชื่อยาหรือสารละลายที่ใช้ผสมกับผลิตภัณฑ์";
translations[WHAT_VOLUME_MEDICATION] = "ระบุปริมาณของยาหรือสารละลายที่ใช้ผสมกับผลิตภัณฑ์";
translations[WHAT_DEVICES_RECONSTITUTION] = "ระบุชื่อเครื่องมืออื่นๆที่ใช้ระหว่างทำการผสมผลิตภัณฑ์ (ชื่อ/ผู้ผลิต, ขนาดเข็ม ฯลฯ)";
translations[WAS_PRODUCT_EXPOSED_HEAT] = "ผลิตภัณฑ์โดนความร้อนหรือมีการสัมผัสอุณหภูมิสูงหรือไม่";
translations[DESCRIBE_EXPOSURE] = "กรุณาอธิบายลักษณะการสัมผัสความร้อน (อุณหภูมิเท่าไหร่, ระยะเวลานานเท่าไหร่ ฯลฯ)";
translations[WHAT_USED_ACTIVATE_SOLUTION] = "เทคนิคหรือวิธีที่ใช้ผสมผลิตภัณฑ์";
translations[WAS_DAMAGE_OBSERVED] = "พบความเสียหายที่ตัวผลิตภัณฑ์ก่อนเริ่มการผสมหรือไม่";
translations[DESCRIBE_THE_DAMAGE] = "กรุณาอธิบายความเสียหายดังกล่าว";
translations[APPROXIMATELY_SOLUTION_POWDER] = "ระบุปริมาณโดยประมาณที่สารละลายหรือผงยาที่หายไป";
translations[WAS_LEAK_OBSERVED] = "พบการรั่วของผลิตภัณฑ์หรือไม่";
translations[WHAT_FEATUR_DIFFICULT_USE] = "ส่วนประกอบใดของผลิตภัณฑ์ที่พบความยากในการใช้งาน";
translations[HOW_WAS_DIFFICULT_USE] = "ผลิตภัณฑ์ใช้งานยากอย่างไร โปรดอธิบาย";
translations[WHERE_MATTER_FOREIGN] = "บริเวณใดของผลิตภัณฑ์ที่คุณพบสิ่งแปลกปลอม/สิ่งปลอมปน";
translations[DOES_PARTICULATE_MATTER] = "สิ่งแปลกปลอม/สิ่งปลอมปนที่พบมีส่วนที่น่าจะเป็นวัสดุที่ใช้ในการผลิตผลิตภัณฑ์หรือไม่";
translations[DESCRIBE_EXACT_LOCATION] = "กรุณาระบุตำแหน่ง ขนาด รูปร่าง สี และลักษณะพื้นผิวของสิ่งแปลกปลอม/สิ่งปลอมปนที่พบ";
translations[WAS_MATTER_FOREIGN] = "สิ่งแปลกปลอม/สิ่งปลอมปนฝังอยู่ในผลิตภัณฑ์หรือไม่";
translations[WHEN_MATTER_FOREIGN] = "คุณสังเกตเห็นสิ่งแปลกปลอม/สิ่งปลอมปนฝังอยู่ในผลิตภัณฑ์เมื่อใด";
translations[PROVIDE_INFORMATION_MEDICATION] = "กรุณาระบุข้อมูลเกี่ยวกับยาที่ใช้ผสมร่วมกับผลิตภัณฑ์";
translations[PRODUCT_NAME_CODE_NUMBER] = "ระบุชื่อผลิตภัณฑ์ ชื่อยี่ห้อ รหัสผลิตภัณฑ์ หมายเลขรุ่นผลิตภัณฑ์ ชื่อยี่ห้อ";
translations[DESCRIBE_SPIKING] = "อธิบายเทคนิคและวิธีการที่คุณใช้ในการผสมผลิตภัณฑ์";
translations[INCLUDE_NEEDLE] = "ระบุขนาดของเข็ม/รูเข็ม มุมของการหมุน/การเจาะ และจำนวนที่พยายามเจาะทั้งหมด";
translations[WHAT_ADMINISTRATION_RECONSTITUTION] = "ระบุเครื่องมือหรืออุปกรณ์ที่ใช้ในการผสม";
translations[INCLUDE_MANUFACTURER] = "ระบุชื่อผู้ผลิต ชื่อผลิตภัณฑ์ รหัสผลิตภัณฑ์ หมายเลขรุ่นของผลิตภัณฑ์";
translations[WAS_MEDICATION_ADDITIVE] = "มีการใส่ยา สารเติมแต่ง หรือสารละลายสำหรับผสมลงในผลิตภัณฑ์หรือไม่";
translations[WHAT_MEDICATION_ADDITIVE] = "ระบุชื่อยา สารเติมแต่ง หรือสารละลายสำหรับผสมลงในผลิตภัณฑ์";
translations[WHAT_STATE_OF_PRODUCT] = "ผลิตภัณฑ์อยู่ในขั้นตอนใดขณะที่คุณสังเกตเห็นความขุ่น/การตกตะกอนของผลิตภัณฑ์";
translations[AFTER_UNITS_SAT] = "ความขุ่น/การตกตะกอนของผลิตภัณฑ์หายไปเมื่อตั้งทิ้งไว้ที่อุณหภูมิห้องหรือไม่";
translations[DID_ATTEMPT_AGITATE] = "มีการเขย่าผลิตภัณฑ์ร่วมด้วยหรือไม่";
translations[DID_PRECIPITATE_DISSOLVE] = "ตะกอนหายไปเมื่อทำการเขย่าหรือไม่";
translations[WHAT_STORAGE_TEMPERATURE] = "ระบุอุณหภูมิและลักษณะของบริเวณที่เก็บผลิตภัณฑ์";
translations[PROVIDE_TEMPERATURE_LOCATION] = "ระบุอุณหภูมิ สถานที่จัดเก็บ รวมถึงผลิตภัณฑ์ถูกเก็บไว้ภายในหรือภายนอกถุงหุ้ม/กล่อง ในกล่อง VSC/กล่องย่อย หรือเก็บแยกชิ้น";
translations[ARE_TEMPERATURE_LOGS] = "มีการใส่ตัววัดอุณหภูมิเพื่อติดตามอุณหภูมิในตู้เย็นด้วยหรือไม่";
translations[LOGS_CAN_BE_ATTACHED] = "สามารถแนบบันทึกการทำงานเครื่อง (log file) โดยตรงกับแบบฟอร์มนี้ได้ (ถ้ามี)";
translations[IS_THE_STORAGE_UNIT] = "ตู้เย็นที่ใชเก็บผลิตภัณฑ์มีการสอบเทียบ (calibration) และควมคุมอุณหภูมิระหว่างใช้งานหรือไม่";
translations[HOW_PRODUCT_THAWED] = "ระบุวิธีที่ใช้ละลายผลิตภัณฑ์";
translations[WHAT_STORAGE_CONDITIONS] = "อธิบายวิธีที่ใช้ในการเก็บผลิตภัณฑ์ (อุณหภูมิ, สถานที่, เก็บไว้ข้างนอกหรือข้างในถุงหุ้ม (overpouch) /กล่อง)";
translations[WAS_ANY_DAMAGE] = "พบความเสียหายเกิดขึ้นกับผลิตภัณฑ์หรือไม่";
translations[MORE_SPECIFIC_INFORMATION] = "กรุณาระบุอย่างรายละเอียด";
translations[WHAT_PURPOSE_INDICATION] = "ระบุจุดประสงค์ในการรักษาของผู้ป่วย";
translations[WHAT_ROUTE_ADMINISTRATION] = "ระบุวิธีบริหารยาที่ใช้";
translations[WHAT_DATE_ADMINISTRATION] = "ระบุวันที่และระยะเวลาที่ใช้ในการบริหารยา";
translations[WHAT_DOSAGE_STRENGTH] = "ระบุขนาดยาและความแรงของยา";
translations[WAS_RECENT_PRESCRIPTION] = "มีการเปลี่ยนแปลงการให้ยาเมื่อไม่นานมานี้หรือไม่";
translations[WHAT_WAS_STORAGE_TEMPERATURE] = "อธิบายเงื่อนไขและรายละเอียดที่ใช้ในการเก็บผลิตภัณฑ์ (ตำแหน่งของสถานที่เก็บ/ตู้เย็น ฯลฯ)";
translations[WERE_ANY_ADJUSTMENTS] = "มีการปรับปริมาณสารละลายหรือสารเติมแต่งที่ใช้ก่อนให้ยาหรือไม่";
translations[SELECT_APPROPRIATE_DESCRIPTION] = "กรุณาเลือกคำอธิบายที่เหมาะสมกับปัญหาที่เกิดขึ้นมากที่สุด";
translations[SELECT_LABELING_ISSUE] = "กรุณาเลือกคำอธิบายที่เหมาะสมกับปัญหาฉลากผลิตภัณฑ์มากที่สุด";
translations[WAS_CONNECTION_SECURE] = "การเชื่อมต่อทำได้แข็งแรงแน่นหนาหรือม่";
translations[WAS_EXPIRED_PRODUCT] = "มีการใช้ผลิตภัณฑ์หมดอายุกับผู้ป่วยหรือไม่";
translations[WAS_COMPONENT_DAMAGED] = "มีส่วนประกอบเสียหายหรือไม่";
translations[WERE_ABNORMALITIES_DAMAGE] = "พบความเสียหายเกิดขึ้นกับผลิตภัณฑ์หรือไม่";
translations[WHAT_PURCHASE_ORDER_NUMBER] = "ระบุหมายเลขคำสั่งซื้อของคุณ";
translations[WHAT_DATE_OF_ADMINISTRATION] = "ระบุวันที่บริหารยา";
translations[WHAT_WAS_EXPIRATION_DATE] = "ระบุวันหมดอายุของผลิตภัณฑ์";
translations[DESCRIBE_WAS_INCORRECT] = "ส่วนใดบนฉลากที่ไม่ถูกต้อง, ไม่สมบูรณ์, หายไป, อ่านไม่ออก หรือส่วนที่คล้ายกับฉลากของผลิตภัณฑ์อื่นมากเกินไป";
translations[WHAT_SCANNER_USED] = "ระบุประเภทเครื่องแสกนใช้";
translations[WAS_OVERPOUCH_POUCH] = "ผลิตภัณฑ์ยังคงอยู่ในถุงหุ้ม (overpouch) ขณะสแกนหรือไม่";
translations[WHAT_BACKGROUND_COLOR] = "สีพื้นหลังขณะแสกนคือสีใด";
translations[DO_ALL_OF_THE_LABELS] = "ฉลากทั้งหมด (ผลิตภัณฑ์, กล่อง, การจัดส่ง/การจัดจำหน่าย) มีข้อมูลผลิตภัณฑ์เดียวกันใช่หรือไม่";
translations[PRODUCT_INFORMATION] = "ข้อมูลผลิตภัณฑ์";
translations[IS_A_BARCODE_SCANNER] = "คุณมีใช้เครื่องสแกนบาร์โค้ดในหน่วยงานหรือไม่";
translations[HOW_ARE_THESE_PRODUCTS] = "อธิบายวิธีการเก็บผลิตภัณฑ์";
translations[WHAT_INFORMATION_INCORRECTLY] = "ข้อมูลใดที่แสดงไม่ถูกต้องเมื่อทำการสแกน";
translations[WAS_THERE_LEAK] = "พบความชื้นส่วนเกินหรือการรั่วหรือไม่";
translations[WHERE_LEAK_OBSERVED] = "ระบุสถานที่ที่พบการรั่วและส่วนประกอบที่พบการรั่ว";
translations[WAS_FRANGIBLE_OBSERVED] = "แกน frangible เสียหายหรือไม่";
translations[IS_MOISTURE_CLEAR] = "ความชื้นส่วนเกินที่พบมีลักษณะใสหรือไม่";
translations[WHO_IS_YOUR_DISTRIBUTOR] = "ระบุชื่อผู้จัดจำหน่ายของคุณ";
translations[WHAT_MANUFACTURER_MEDICATION] = "ระบุชื่อผู้ผลิต ชื่อยา และขนาดของขวดที่ใช้";
translations[WHAT_GAUGE_NEEDLE] = "ระบุขนาดเข็ม, ผู้ผลิต และจำนวนครั้งที่เจาะ";
translations[WHAT_ADMINISTRATION_SET] = "ระบุเซต (administraion set) ที่ใช้งาน";
translations[WAS_DIFFICULTY_SPIKING] = "การแทงทำได้ยากหรือไม่";
translations[WERE_FOLLOWING_SCENARIOS] = "มีสถานการณ์ใดต่อไปนี้ที่พบการรั่วบ้าง";
translations[WAS_FRANGIBLE_OBSERVED_DEFECT] = "พบแกน frangible เสียหายหรือไม่";
translations[WHAT_AMOUNT_PRESSURE] = "ระบุแรงดันและระยะเวลาที่ใช้";
translations[WAS_BAG_COMPLETELY] = "ถุงถูกใส่อย่างสมบูรณ์และถูกต้องลงใน pressure cuff หรือไม่ (ปลายด้านหนึ่งอยู่ด้านนอก  pressure cuff) ";
translations[WHAT_MANUFACTURER_MODEL] = "ระบุชื่อผู้ผลิตรุ่นและขนาดของ pressure cuff";
translations[WHAT_PRESSURE_PRIOR] = "ก่อนพบการรั่ว ความดันยังสามารถถูกวัดได้หรือไม่";
translations[LIST_THE_VAPORIZER] = "ระบุรชื่อของผู้ผลิต Vaporizer และชื่อเครื่อง/รุ่น";
translations[APPROXIMATELY_HOW_MUCH] = "ปริมาณของเหลวที่รั่วไหลออกมาประมาณเท่าใด";
translations[WAS_THE_BOTTLE_DIFFICULT] = "การใส่ขวดเข้าไปในเครื่อง Vaporizer ทำได้ยากหรือไม่";
translations[WERE_VISIBLE_DEFECTS] = "พบความเสียหายที่สามารถมองเห็นได้ด้วยตาเปล่าใช่หรือไม่";
translations[SELECT_THE_OPTION] = "เลือกคำที่อธิบายปัญหาการเชื่อมต่อได้ดีที่สุด";
translations[PROVIDE_INVOLVED_CONNECTION_ISSUE] = "ระบุข้อมูลเกี่ยวกับผลิตภัณฑ์อื่นๆที่ใช้พร้อมกันระหว่างเจอปัญหาการเชื่อมต่อ";
translations[WHICH_PART_SEPARATED] = "ส่วนใดของผลิตภัณฑ์ที่แยกจากกัน";
translations[WHAT_COMPONENT_DISCOLORED] = "ระบุส่วนประกอบที่พบการเปลี่ยนสี";
translations[SELECT_DESCRIBES_DISCOLORATION] = "กรุณาเลือกตัวเลือกที่อธิบายลักษณะการเปลี่ยนสีได้ดีที่สุด:";
translations[WAS_THE_SET_DISCOLORED] = "พบการเปลี่ยนสีเมื่อนำผลิตภัณฑ์ออกจากบรรจุภัณฑ์ใช่หรือไม่";
translations[DID_SET_CHANGE_COLOR] = "พบเซตเปลี่ยนสีหลังจากใส่ยาใช่หรือไม่";
translations[WHAT_MEDICATION_ADDED] = "ยาชนิดใดที่ใส่ลงในผลิภัณฑ์ก่อนพบการเปลี่ยนสี";
translations[WHERE_MATERIAL_LOCATED] = "ระบุตำแหน่งของสิ่งแปลกปลอม/สิ่งปลอมปน";
translations[DESCRIBE_APPEARANCE_COLOR_SIZE] = "อธิบายลักษณะของสิ่งแปลกปลอม/สิ่งปลอมปน (หน้าตา / สี / ขนาด):";
translations[WAS_EMBEDDED_PLASTIC] = "พบสิ่งแปลกปลอม/สิ่งปลอมปนฝังอยู่ในพลาสติกหรือไม่";
translations[WAS_THERE_A_PRECIPITATE] = "ตะกอนหรือการเปลี่ยนสีของสารละลายไม่ได้เกิดขึ้นตามปกติใช่หรือไม่";
translations[WHAT_MEDICATIONS_SOLUTIONS] = "ยา/สารละลายใดที่ถูกให้ผ่านเซต";
translations[WHERE_DAMAGE_COMPONENT_AFFECTED] = "ระบุตำแหน่งที่พบความเสียหายหรือส่วนประกอบที่ได้รับผลกระทบ (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[WHAT_DAMAGE_ISSUE] = "ระบุประเภทความเสียหาย/ปัญหาที่เกิดขึ้น (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[DID_ISSUE_RESULT] = "ปัญหานี้ส่งผลให้เกิดการรั่วไหลหรือไม่";
translations[WAS_PATIENT_CONNECTED] = "ผู้ป่วยเชื่อมต่อกับผลิตภัณฑ์หรือไม่";
translations[WAS_PRODUCT_REPLACED] = "ผลิตภัณฑ์ถูกเปลี่ยนเป็นผลิตภัณฑ์อันใหม่หรือไม่";
translations[WHICH_SITUATION_BEST] = "สถานการณ์ใดที่อธิบายปัญหาการแยก / การเชื่อมต่อได้ดีที่สุด";
translations[SELECT_MOST_LABELING_ISSUE] = "กรุณาเลือกคำอธิบายที่เหมาะสมกับปัญหาฉลากผลิตภัณฑ์มากที่สุด";
translations[WHAT_INFORMATION_DISPLAYED] = "ระบุข้อมูลที่แสดงให้เห็นบนหน้าจอหรืออุปกรณ์";
translations[WHAT_SCANNER_WAS_USED] = "ระบุประเภทเครื่องแสกนใช้";
translations[INCLUDE_THE_MODEL_NAME] = "ระบุชื่อรุ่น (โมเดล) ของเครื่อง";
translations[WAS_PRODUCT_ORDERED] = "คุณสั่งซื้อผลิตภัณฑ์โดยตรงจากแบ็กซ์เตอร์หรือสั่งซื้อผ่านตัวแทนผู้จัดจำหน่ายอื่นๆ";
translations[WHERE_LEAK_COMING] = "ระบุตำแหน่งที่พบการรั่ว (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[DID_SCENARIOS_OCCURRED_LEAK] = "สถานการณ์ต่อไปนี้ที่พบการรั่วขึ้นบ้าง";
translations[WAS_POWER_INJECTOR] = "ผลิตภัณฑ์ถูกใช้กับ power injector หรือไม่";
translations[WHAT_INJECTOR_USED] = "ระบุ power injector ที่ใช้";
translations[MANUFACTURER_NAME_CODE_LOT] = "ระบุชื่อผู้ผลิต ชื่อผลิตภัณฑ์ รหัสผลิตภัณฑ์ หมายเลขรุ่นผลิตภัณฑ์";
translations[DESCRIBE_INCORRECT_INCOMPLETE] = "ส่วนใดบนฉลากที่ไม่ถูกต้อง, ไม่สมบูรณ์, หายไป, อ่านไม่ออก หรือเปลี่ยนไปจากเดิม";
translations[PROVIDE_INFORMATION_SECOND_PRODUCT] = "ระบุข้อมูลของผลิตภัณฑ์ตัวอื่นที่ใช้ระหว่างพบปัญหาการแยก";
translations[WHICH_COMPONENTS_WERE_FOUND] = "ส่วนประกอบใดที่พบการแตก";
translations[DESCRIBE_CUT_HOLE_SLICE] = "ระบุตำแหน่งบนท่อที่พบรอยขาด รู รอยตัด/เฉือน";
translations[WAS_LEAK_ORIGINATING] = "พบการรั่วไหลจากการเปิด injection site";
translations[PROVIDE_DISCONNECTION_CONNECTION] = "ระบุข้อมูลของผลิตภัณฑ์ตัวอื่นที่ใช้ระหว่างพบปัญหาการแยก/การเชื่อมต่อ";
translations[WHICH_SPECIFIC_BONDED] = "ส่วนประกอบที่ควรเชื่อมติดกันส่วนใดที่พบว่าแยกออกจากกัน";
translations[WERE_VISIBLE_IRREGULARITIES] = "มีความผิดปกติ/ความเสียหายที่มองเห็นได้ในผลิตภัณฑ์/ส่วนประกอบที่เกี่ยวข้องหรือไม่";
translations[WAS_SUCCESSFUL_CONNECTION] = "คุณสามารถทำการเชื่อมต่อหรือการถอดอุปกรณ์ได้ตามปกติโดยที่ไม่ต้องเปลี่ยนผลิตภัณฑ์ใหม่ใช่หรือไม่";
translations[WAS_TOOL_USED_ASSIST] = "มีเครื่องมือที่ใช้เพื่อช่วยในการต่อเข้าหรือถอดออกหรือไม่";
translations[WERE_LUER_CONNECTIONS] = "มีการตรวจสอบรอยต่อของ Luer connector ทั้งหมดเพื่อให้แน่ใจว่าแน่นดีแล้วก่อนใช้หรือไม่ (ตามที่มีการระบุในฉลาก)";
translations[WAS_PRODUCT_SECURELY] = "ผลิตภัณฑ์เชื่อมต่ออย่างปลอดภัยกับผลิตภัณฑ์อื่นก่อนที่จะตัดการเชื่อมต่อหรือไม่?";
translations[WHICH_DESCRIBES_FLOW_ISSUE] = "ข้อใดที่อธิบายปัญหาการไหลได้ดีที่สุด";
translations[WHAT_FLOWING_BACKWARDS] = "ส่วนใด/สิ่งใดที่ไหลย้อนกลับ";
translations[DESCRIBE_COMPONENTS_BACKFLOW] = "ระบุส่วนประกอบที่พบการไหลย้อนกลับตั้งแต่บริเวณที่เริ่มต้นจนถึงบริเวณที่สิ้นสุด:";
translations[DO_SITUATIONS_APPLY] = "สถานการณ์ในข้อใดบ้างที่สอดคล้องกับเหตุการณ์ที่เกิดขึ้น";
translations[WHICH_SPECIFIC_AREA] = "ระบุตำแหน่งที่ชัดเจนของส่วนประกอบที่เกี่ยวข้องกับปัญหาการไหล";
translations[WAS_FLOW_PREVIOUSLY_SEEN] = "ก่อนหน้านี้สารละลายไหลผ่านเซตหรือส่วนประกอบได้ตามปกติหรือไม่";
translations[WAS_ANY_FOLLOWING_OBSERVED] = "คุณสังเกเห็นข้อใดบ้างต่อไปนี้:";
translations[WHERE_SIMULTANEOUS_FLOW] = "ระบุจุดที่พบการไหลอย่างต่อเนื่อง";
translations[WHAT_TYPE_HANGER] = "ระบุประเภทที่แขวนที่ใช้";
translations[WHAT_WAS_HANGER_LENGTH] = "ระบุชื่อผู้ผลิตและความสูงของที่แขวน";
translations[WHICH_BAG_LOWER] = "ระบุถุงที่อยู่ต่ำกว่า";
translations[WHAT_Y_SITE_WAS] = "ระบุตำแหน่ง Y-site ที่ต่อเข้ากับเซตลำดับที่สอง";
translations[WHAT_COMPONENT_WITHIN] = "ส่วนประกอบใดภายในเซตไม่สามารถล้างสารละลายหรือเลือดได้";
translations[WAS_COMPONENT_SET_REPLACED] = "มีการเปลี่ยนไปใช้ส่วนประกอบ/เซตอันใหม่หลังจากไม่สามารถล้างสารละลายหรือเลือดได้หรือไม่";
translations[WHAT_VOLUME_FLUID_PERIOD_TIME] = "ระบุปริมาตรของสารละลายที่ให้ผู้ป่วยและระยะเวลาที่ให้";
translations[WHAT_VOLUME_FLUID_OVER_TIME] = "ระบุปริมาณจริงของสารลายลายที่ผู้ป่วยได้รับทั้งหมด";
translations[WAS_USED_WITH_PUMP] = "มีการใช้เซตกับเครื่องปั๊มหรือไม่";
translations[DID_CLAMP_FAIL] = "ไม่สามารถใช้ที่หนีบ (clamp) เพื่อหยุดหรือควบคุมการไหลของของเหลวได้";
translations[WHAT_CLAMP_FAILED] = "ปัญหาที่พบคืออะไร";
translations[WAS_ISSUES_OBSERVED_CLAMP] = "ลักษณะที่หนีบ (clamp) มีปัญหาเป็นอย่างไร";
translations[DO_OTHER_SITUATIONS_DESCRIBE] = "มีสถานการณ์ใดด้านล่างที่สามารถอธิบายเกี่ยวกับปัญหาผลิตภัณฑ์ (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[DESCRIBE_ALARM_OBSERVED] = "อธิบายสัญญาณเตือนที่คุณพบ:";
translations[INCLUDE_ANY_MESSAGES] = "ระบุข้อความและหรือรหัสใด ๆ ที่พบจากสัญญาณแจ้งเตือน";
translations[WHICH_CLAMP_HAD_ISSUE] = "ที่หนีบ (clamp) อันใดมีปัญหา";
translations[WHICH_TYPE_CLAMP_ISSUE] = "ลักษณะปัญหาของที่หนีบ (clamp) แบบใดที่คุณเจอ (เลือกทุกข้อที่เกี่ยวข้อง)";
translations[SELECT_BEST_DESCRIBES_ISSUE] = "เลือกสถานการณ์ที่อธิบายปัญหาได้ดีที่สุด:";
translations[PROVIDE_MORE_DETAILS] = "อธิบายรายละเอียดเพิ่มเติมว่าผลิตภัณฑ์ใช้งานยากอย่างไร:";
translations[PROVIDE_MORE_DETAILS_INSTRUCTIONS] = "อธิบายรายละเอียดเพิ่มเติมเกี่ยวกับคำอธิบายวิธีการใช้งานที่ยากต่อการติดตาม/เข้าใจ:";
translations[DESCRIBE_THE_SMELL] = "อธิบายถึงลักษณะกลิ่นและที่มาของกลิ่น:";
translations[WAS_ISSUES_WITH_SET] = "พบปัญหาใดบ้างเกี่ยวกับเซต";
translations[WHERE_LEAK_LOCATED] = "ระบุตำแหน่งที่พบการรั่วไหลของผลิตภัณฑ์";
translations[DID_OCCUR_WITH_LEAK] = "มีสิ่งต่อไปนี้เกิดขึ้นระหว่างการรั่วหรือไม่";
translations[PROVIDE_INVOLVED_DISCONNECTION] = "ระบุข้อมูลของผลิตภัณฑ์ตัวอื่นที่ใช้ระหว่างพบปัญหาการแยก";
translations[DID_OCCURRED_WITH_THE_LEAK] = "สถานการณ์ต่อไปนี้ที่พบการรั่วขึ้นบ้าง";
translations[WHERE_WAS_PRODUCT_DAMAGED] = "ผลิตภัณฑ์เสียหายที่ไหน";
translations[SELECT_ALL_APPLY] = "เลือกทั้งหมดที่เกี่ยวข้อง";
translations[DESCRIBE_OBSERVED_DAMAGE] = "อธิบายความเสียหายที่เกิดขึ้น";
translations[WHAT_COMPONENT_IS_DISCOLORED] = "ส่วนประกอบของผลิตภัณฑ์ใดที่พบการเปลี่ยนสี";
translations[DESCRIBE_HUE_TINT_SHADE] = "อธิบายสีที่คุณสังเกตเห็นได้ (เฉดสี, โทนสี ฯลฯ ):";
translations[INSIDE_OUTSIDE_OVERPOUCH] = "บริเวณด้านในหรือด้านนอกของถุงหุ้มที่มีการสัมผัสกับแสง, อุณหภูมิสูง ฯลฯ";
translations[DESCRIBE_EXACT_LOCATION_SIZE] = "กรุณาระบุตำแหน่ง ขนาด รูปร่าง และสีของสิ่งแปลกปลอม/สิ่งปลอมปนที่พบ";
translations[DOES_THE_PARTICULATE_MATTER] = "สิ่งแปลกปลอม/สิ่งปลอมปนที่พบมีส่วนที่น่าจะเป็นวัสดุที่ใช้ในการผลิตผลิตภัณฑ์หรือไม่";
translations[WAS_PARTICULATE_MATERIAL_EMBEDDED] = "สิ่งแปลกปลอม/สิ่งปลอมปนฝังอยู่ในผลิตภัณฑ์หรือไม่";
translations[DOES_APPEAR_PRODUCT_MATERIAL] = "สิ่งแปลกปลอม/สิ่งปลอมปนที่พบมีส่วนที่น่าจะเป็นวัสดุที่ใช้ในการผลิตผลิตภัณฑ์หรือไม่";
translations[WHERE_DID_THE_ISSUE_OCCUR] = "ระบุตำแหน่งที่พบปัญหา";
translations[LIST_COMPONENTS_IF] = "ระบุรายการส่วนประกอบ หากมีผลิตภัณฑ์ที่อื่นๆมาเกี่ยวข้อง กรุณาระบุชื่อผู้ผลิต ชื่อผลิตภัณฑ์ รหัสผลิตภัณฑ์ หมายเลขผลิตภัณฑ์";
translations[WERE_THERE_VISIBLE_IRREGULARITIES] = "มีความผิดปกติ/ความเสียหายที่มองเห็นได้หรือไม่";
translations[SELECT_OPTION_FLOW_ISSUE] = "เลือกตัวเลือกที่อธิบายปัญหาการไหลได้ดีที่สุด";
translations[DESCRIBE_IRREGULARITIES] = "อธิบายความผิดปกติ/ความเสียหายที่พบก่อนหรือระหว่างการเชื่อมต่อ/การถอดออก";
translations[HOW_PRODUCT_SETUP] = "ผลิตภัณฑ์ถูกตั้งค่าอย่างไร";
translations[SELECT_MOST_APPROPRIATE_DESCRIPTION] = "เลือกข้อที่อธิบายปัญหาการติดฉลากที่เหมาะสมที่สุด:";
translations[DESCRIBE_WHAT_INCORRECT_INCOMPLETE] = "ส่วนใดบนฉลากที่ไม่ถูกต้อง, ไม่สมบูรณ์, หายไป, อ่านไม่ออก หรือส่วนที่คล้ายกับฉลากของผลิตภัณฑ์อื่นมากเกินไป";
translations[WAS_SHIPPING_CARTON_DAMAGED] = "พบผลิตภัณฑ์ที่ยังอยู่ภายในกล่องเสียหายหรือไม่";
translations[WHAT_PRODUCT_WAS_SUPPOSED] = "ผลิตภัณฑ์ที่ควรได้รับคือผลิตภัณฑ์ใด";
translations[IF_PRODUCT_CODE_NOT] = "หากไม่สามารถระบุรหัสผลิตภัณฑ์ได้ โปรดระบุคำอธิบายเกี่ยวกับผลิตภัณฑ์";
translations[WAS_THE_CASE_MISSING] = "ไม่พบน้ำแข็งแห้งหรือเจลแช่เย็นภายในกล่องใช่หรือไม่";
translations[WHAT_CARRIER_DELIVERED] = "ระบุชื่อผู้ขนส่งผลิตภัณฑ์";
translations[WHAT_IS_PURCHASE_ORDER_NUMBER] = "ระบุหมายเลขใบสั่งซื้อ";
translations[WHAT_QUANTITY_MISSING_UNITS] = "ระบุจำนวนที่หายไป";
translations[WAS_EXPIRED_PRODUCT_USE] = "ผลิตภัณฑ์ที่หมดอายุถูกใช้งานหรือไม่";
translations[APPLY_TO_EACH_UNIT] = "หากจำนวนผลิตภัณฑ์ที่มีปัญหามีมากกว่าหนึ่งชิ้น โปรดทราบว่าคำถามด้านล่างจะแทนหนึ่งคำถามต่อหนึ่งชิ้น";
translations[TERMS_CONDITIONS] = "ข้อกำหนดและเงื่อนไข";
translations[PRIVACY_POLICY] = "นโยบายความเป็นส่วนตัว";
translations[PRIVACY_NOTICE] = "ประกาศนโยบายความเป็นส่วนตัว";
translations[COOKIE_POLICY] = "นโยบายการใช้คุกกี้";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN] = "ผู้แจ้งไม่ทราบ";
translations[OPTION_FUNCTIONOPTIONS_BAXTER_EMPLOYEE] = "พนักงานแบ็กซ์เตอร์";
translations[OPTION_FUNCTIONOPTIONS_CAREGIVER] = "ผู้ดูแล";
translations[OPTION_FUNCTIONOPTIONS_DISTRIBUTOR] = "ผู้จัดจำหน่าย";
translations[OPTION_FUNCTIONOPTIONS_HEALTHCARE_PROFESSIONAL] = "บุคลากรทางการแพทย์";
translations[OPTION_FUNCTIONOPTIONS_PATIENT] = "ผู้ป่วย";
translations[OPTION_FUNCTIONOPTIONS_OTHER] = "อื่นๆ ";
translations[OPTION_PROCESSSTEPOPTIONS_AFTER_USE] = "หลังใช้งาน";
translations[OPTION_PROCESSSTEPOPTIONS_BEFORE_USE] = "ก่อนใช้งาน";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_SETUP_PREPARATION] = "ระหว่างเตรียมการใช้งาน/ผสมยา";
translations[OPTION_PROCESSSTEPOPTIONS_DURING_THERAPY] = "ระหว่างใช้งาน/การรักษา";
translations[OPTION_PROCESSSTEPOPTIONS_MULTIPLE_STEPS] = "เกิดระหว่างหลายขั้นตอน";
translations[OPTION_PROCESSSTEPOPTIONS_NOT_SPECIFIED] = "ไม่ระบุ";
translations[OPTION_OCCUPATIONOPTIONS_FAMILY_MEMBER] = "สมาชิกในครอบครัว";
translations[OPTION_OCCUPATIONOPTIONS_NURSE] = "พยาบาล";
translations[OPTION_OCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "พยาบาลวิชาชีพ";
translations[OPTION_OCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "บุคลากรทางการแพทย์อื่นๆ";
translations[OPTION_OCCUPATIONOPTIONS_PHYSICIAN] = "แพทย์";
translations[OPTION_UNITOPTIONS_BOXES] = "กล่อง";
translations[OPTION_UNITOPTIONS_PALLETS] = "พาเลท";
translations[OPTION_UNITOPTIONS_UNITS] = "ชิ้น";
translations[OPTION_PROBLEMOPTIONS_ALARM_CONDITION] = "การแจ้งเตือน";
translations[OPTION_PROBLEMOPTIONS_DAMAGE] = "เสียหาย";
translations[OPTION_PROBLEMOPTIONS_DIFFICULT_TO_USE] = "ใช้งานยาก";
translations[OPTION_PROBLEMOPTIONS_DISCOLORED] = "เปลี่ยนสี";
translations[OPTION_PROBLEMOPTIONS_FLOW_ISSUES] = "ปัญหาการไหล";
translations[OPTION_PROBLEMOPTIONS_LABELING_ISSUES] = "ปัญหาเกี่ยวกับฉลาก";
translations[OPTION_PROBLEMOPTIONS_LEAK_EXCESSIVE_MOISTURE] = "รั่ว/ของเหลวส่วนเกิน";
translations[OPTION_PROBLEMOPTIONS_PARTICULATE_MATTER_FOREIGN_MATERIAL] = "สิ่งแปลกปลอม/สิ่งปลอมปน";
translations[OPTION_PROBLEMOPTIONS_PATIENT_REACTION_ADVERSE_EVENT] = "เหตุการณ์ไม่พึงประสงค์";
translations[OPTION_PROBLEMOPTIONS_PRODUCT_INQUIRY] = "คำถามเกี่ยวกับผลิตภัณฑ์";
translations[OPTION_PROBLEMOPTIONS_SEPARATION_CONNECTION] = "ปัญหาการเชื่อมต่อ/การแยกส่วนออก";
translations[OPTION_PROBLEMOPTIONS_SHIPPING_ISSUES_EXPIRED_PRODUCT] = "ปัญหาการขนส่ง/ผลิตภัณฑ์หมดอายุ";
translations[OPTION_PATIENTSEXOPTIONS_FEMALE] = "หญิง";
translations[OPTION_PATIENTSEXOPTIONS_UNDIFFERENTIATE] = "ไม่แตกต่าง";
translations[OPTION_PATIENTSEXOPTIONS_MALE] = "ชาย";
translations[OPTION_PATIENTSEXOPTIONS_DECLINETOANSWER] = "ปฏิเสธที่จะตอบ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_ADMINISTRATOR_SUPERVISOR] = "แอดมิน/หัวหน้างาน";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_BIOMEDICAL_ENGINEER] = "วิศวกรชีวการแพทย์";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_COMPANY_REPRESENTATIVE] = "ผู้แทน";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DENTIST] = "ทันตแพทย์";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_DISTRIBUTOR] = "ผู้จัดจำหน่าย";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_FAMILY_MEMBER] = "สมาชิกในครอบครัว";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_LAY_USER] = "ผู้ใช้ทั่วไป";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE] = "พยาบาล";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_NURSE_PRACTITIONER] = "พยาบาลวิชาชีพ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER_HEALTH_CARE_PROFESSIONAL] = "บุคลากรทางการแพทย์อื่นๆ";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACIST] = "เภสัชกร";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHARMACY_TECHNICIAN] = "ผู้ช่วยเภสัชกร";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PHYSICIAN] = "แพทย์";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_PATIENT] = "ผู้ป่วย";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_RISK_MANAGER] = "ผู้จัดการความเสี่ยง";
translations[OPTION_REPORTEROCCUPATIONOPTIONS_OTHER] = "อื่นๆ";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ADDITIONAL_CONTACT_PERSON] = "ติดต่อรายชื่อผู้ติดต่อเพิ่มเติม";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_ME] = "ติดต่อฉัน";
translations[OPTION_PRODUCTSURVEILLANCECONTACTOPTIONS_CONTACT_OTHER] = "ติดต่อผู้อื่น";
translations[OPTION_REPORTEDTOOPTIONS_BAXTER] = "แบ็กซ์เตอร์";
translations[OPTION_REPORTEDTOOPTIONS_CHINA_FDA] = "FDA จีน ";
translations[OPTION_REPORTEDTOOPTIONS_EMA] = "EMA";
translations[OPTION_REPORTEDTOOPTIONS_FDA] = "สำนักงานคณะกรรมการอาหารและยา (FDA)";
translations[OPTION_REPORTEDTOOPTIONS_HEALTH_CANADA] = "สาธารณสุขประเทศแคนาดา (Health Canada)";
translations[OPTION_REPORTEDTOOPTIONS_PMDA_JAPAN] = "PMDA (ญี่ปุ่น)";
translations[OPTION_REPORTEDTOOPTIONS_TUV] = "TUV";
translations[OPTION_REPORTEDTOOPTIONS_TGA_AUSTRALIA] = "TGA (ออสเตรเลีย)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_PET_OR_ANIMAL] = "สัตว์เลี้ยงหรือสัตว์อาจก่อให้เกิดปัญหา";
translations[OPTION_FOLLOWINGOCCUROPTIONS_A_SHARP_OBJECT] = "มีการใช้วัตถุหรือเครื่องมือที่มีคมเพื่อเปิดกล่องหรือถุงหุ้ม (overpouch) หรือไม่";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_PROBLEM_OCCURRED] = "ผลิตภัณฑ์ถูกกระแทก, ชน, ตี, ฯลฯ ก่อนที่จะพบปัญหาหรือไม่";
translations[OPTION_FOLLOWINGOCCUROPTIONS_THE_PRODUCT_COLD_ENVIRONMENT] = "ผลิตภัณฑ์ถูกเก็บไว้ในสถานที่ที่มีอากาศร้อน/เย็นหรือไม่";
translations[OPTION_DAMAGEMINICAPOPTIONS_CARTON] = "กล่อง";
translations[OPTION_DAMAGEMINICAPOPTIONS_MINICAP] = "มินิแคป";
translations[OPTION_DAMAGEMINICAPOPTIONS_POUCH] = "ถุงนอก (Pouch)";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_TIGHT] = "transfer set แน่นเกินไป";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_LOOSE] = "transfer set หลวมเกินไป";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_CLOSE] = "transfer set ไม่สามารถปิดสนิท";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TRANSFER_OPEN] = "transfer set ไม่สามารถเปิดสนิท";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_CLAMP_OPEN] = "เกลียวหมุน (twist clamp) แน่นเกิดไปจนไม่สามารถหมุนเปิด transfer set ได้";
translations[OPTION_DIFFICULTTOUSEOPTIONS_THE_TWIST_LAMP_CLOSE] = "เกลียวหมุน (twist clamp) แน่นเกิดไปจนไม่สามารถหมุนปิด transfer set ได้";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THERE_WAS_DAMAGE] = "ใช่ - มีบางอย่างผิดปกติหรือพบความเสียหายกับ transfer set จนทำให้ไม่สามารถปิดจนสุดได้";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_YES_THE_MINICAP] = "ใช่ - มินิแคปถูกหมุนปิด transfer set แน่นเกินไปด้วยการใช้มือหรือเครื่องมือช่วยหมุน";
translations[OPTION_FLOWISSUEOPTIONS_COMPLETELY_STOPPED] = "หยุดสนิทโดยไม่พบการไหลของของเหลว";
translations[OPTION_FLOWISSUEOPTIONS_RESTRICTED_OR_PARTIALLY] = "ถูกจำกัดการไหล (ไหลได้ช้า)";
translations[OPTION_BLOCKINGFLOWOPTIONS_CLOTTED_BLOOD] = "ลิ่มเลือด";
translations[OPTION_BLOCKINGFLOWOPTIONS_FIBRIN] = "ไฟบริน";
translations[OPTION_BLOCKINGFLOWOPTIONS_KINK] = "บุบ";
translations[OPTION_BLOCKINGFLOWOPTIONS_PARTICULATE] = "สิ่งแปลกปลอม";
translations[OPTION_BLOCKINGFLOWOPTIONS_PRODUCT_MATERIAL] = "วัสดุที่ใช้ผลิตผลิตภัณฑ์";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_IODINE] = "พบไอโอดีนส่วนเกิน (สีน้ำตาล) ขณะต่อกับเซต หรืพบในบรรจุภัณฑ์";
translations[OPTION_DESCRIBEISSUEOPTIONS_EXCESS_MOISTURE] = "พบความชื้นส่วนเกิน (หยดน้ำใส) ในบรรจุภัณฑ์";
translations[OPTION_DESCRIBEISSUEOPTIONS_FOIL_POUCH] = "ถุงฟอยล์เสียหายก่อนเปิด";
translations[OPTION_DESCRIBEISSUEOPTIONS_PACKAGE_BOX] = "บรรจุภัณฑ์/กล่องถูกเปิดหรือเสียหายก่อนใช้งาน";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_AND_WHITE] = "ฟองน้ำแห้งและมีสีขาว";
translations[OPTION_DESCRIBEISSUEOPTIONS_SPONGE_DRIED_OUT_BROWNISH_COLOR] = "ฟองน้ำแห้งและมีสีน้ำตาล";
translations[OPTION_MATERIALLOCATEDOPTIONS_IN_THE_SECONDARY] = "ในบรรจุภัณฑ์รอง (secondary packaging)/ถุงหุ้ม (overpouch)";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_PRODUCT_FLUID] = "ภายในเส้นทางการไหลของผลิตภัณฑ์/ของเหลว";
translations[OPTION_MATERIALLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "ภายในกล่อง";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "บนด้านนอกของผลิตภัณฑ์";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_OVERPOUCH] = "ด้านนอกบรรจุภัณฑ์รอง (secondary packaging)/ถุงหุ้ม (overpouch)";
translations[OPTION_MATERIALLOCATEDOPTIONS_ON_THE_EXTERIOR] = "บนด้านนอกของกล่อง";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "ความยากในการเชื่อมต่อผลิตภัณฑ์กับผลิตภัณฑ์อื่น";
translations[OPTION_CONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "ความยากในการถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "การแยกส่วนประกอบในผลิตภัณฑ์เดียวกัน";
translations[OPTION_CONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "การแยก/ถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_RESIDUE] = "ใช่ - สิ่งตกค้าง";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_VISIBLE] = "ใช่ - ความเสียหายที่มองเห็นได้";
translations[OPTION_RESIDUETHREADSOPTIONS_YES_OTHER] = "ใช่ - อื่นๆ ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_HANGER_HOLE] = "Hanger Hole";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_INJECTION_FILLING_PORT] = "Injection/Filling Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_MEMBRANE_PORT] = "Membrane Port";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OVERPOUCH_POUCH] = "ถุงหุ้ม (overpouch)/ถุงนอก (pouch) ";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_PATCH] = "Patch";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHIPPING_CARTON] = "Shipping carton";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_SOLUTION_CONTAINER] = "Solution container";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_TAMPER_EVIDENT_SEAL] = "Tamper-evident seal(shrink wrap)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BENT] = "งอ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_BROKEN] = "แตกหัก";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CRACKED] = "ร้าว แตก";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_CUT] = "ตัด";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_DEFORMED] = "ผิดรูปร่าง";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_FLAKING] = "แตกเป็นสะเก็ด";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_HOLE] = "รู";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_KINKED] = "บุบ ยุบ";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_MELTED] = "ละลาย";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_PATCH_LAYER_SEPARATION] = "หลุดลอกเป็นแผ่น";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SHATTERED_GLASS] = "แตกกระจาย (แก้ว)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_SLICED] = "เฉือน";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_TORN] = "ฉีกขาด";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_NOT_FLOW] = "สารละลายไม่ไหล";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_FLOW] = "สารละลายไหลอย่างช้าๆ";
translations[OPTION_FLOWISSUEOBSERVEDOPTIONS_SOLUTION_WOULD_COMPOUNDING] = "สารละลายไม่ไหล (หรือไหลอย่างช้าๆ) ระหว่างทำการผสม";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_BOTTLE] = "ขวด";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_CONTAINER] = "บรรจุภัณฑ์";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_HANGER_HOLE] = "รูแขวน (Hanger Hole)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_LINER] = "แผ่นซับ (Liner)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OVERPOUCH_POUCH] = "ถุงหุ้ม (overpouch)/ถุงนอก (pouch) ";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OXYGEN_INDICATOR] = "ตัวบ่งชี้ออกซิเจน (Oxygen indicator)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PATCH] = "แผ่นแปะ (Patch)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_PORTS] = "ช่องเชื่อมต่อ (Ports)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_SOLUTION] = "สารละลาย";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_AMINO_ACID_CHAMBER] = "ช่องสารละลายอะมิโน (Amino Acid Chamber)";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_DEXTROSE_CHAMBER] = "ช่องสารละลายเด็กซ์โตรส (Dextrose Chamber) ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LIPID_CHAMBER] = "ช่องสารละลายไขมัน (Lipid Chamber)";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_LOWER_CHAMBER] = "ช่องล่าง (Lower Chamber)";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UPPER_CHAMBER] = "ช่องบน (Upper Chamber)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_BURST_RUPTURED_SEAL] = "รอยซีลแตก/ขาด";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISASSEMBLED_PRODUCT_PART] = "ผลิตภัณฑ์/ชิ้นส่วนประกอบผิด";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_MISSING_COMPONENT] = "ส่วนประกอบหายไป";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_SEPARATION_DISCONNECTION_OF] = "การแยก/หลุดออกของส่วนประกอบที่ควรติดกัน";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_OVER_FILLED] = "บรรจุสารละลายขาด/เกิน";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_PRODUCT_UNDER_FILLED] = "สินค้าไม่เต็ม";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_RECONSTITUTION] = "ปัญหาการผสมใหม่";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_IN_THE_SECONDARY] = "ในบรรจุภัณฑ์รอง/ถุงนอก (secondary packaging/overpouch)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_SHIPPING] = "ภายในกล่องบรรจุ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_EXTERIOR] = "ด้านนอกของกล่องบรรจุ";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_OTHER] = "อื่น ๆ (ระบุ)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_SOLUTION] = "ภายในทางเดินของสารละลาย (solution/fluid path)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_INSIDE_THE_VAPORIZER] = "ภายใน vaporizer sump (sight glass)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_XTERNAL_SURFACE] = "บนพื้นผิวภายนอกของผลิตภัณฑ์";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OUTSIDE] = "ด้านนอกของบรรจุภัณฑ์รอง/ถุงนอก (secondary packaging/overpouch)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_OXYGEN] = "บนตัวดูดซับออกซิเจน (Oxygen absorber)";
translations[OPTION_MATTERFOREIGNMATERIALOPTIONS_ON_THE_TRANSDERMAL] = "บนแผ่นแปะผิวหนัง (Transdermal patch)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_GLASS_PARTICLES] = "Glass Particles";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_PORT] = "Port";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_RUBBER_STOPPER] = "Rubber stopper";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_TUBING] = "Tubing";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_ADDING_ANOTHER] = "หลังจากใส่ยาหรือหลังจากทำการผสม (vials)";
translations[OPTION_WHENMATERIALOBSERVEDOPTIONS_AFTER_PRIOR_TO_SPIKING] = "ก่อนเสียบหรือผสม";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_COLD_THAWED] = "เย็น (ละลายแล้วแต่ยังไม่ถึงอุณหภูมิห้อง)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_FROZEN] = "แช่แข็ง";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_PARTIALLY_THAWED] = "ละลายบางส่วน (พบเกล็ดน้ำแข็งในผลิตภัณฑ์)";
translations[OPTION_CLOUDINESSOBSERVEDOPTIONS_ROOM_TEMPERATURE] = "อุณหภูมิห้อง";
translations[OPTION_PRODUCTTHAWEDOPTIONS_BAXTER_THAWING] = "ตู้เย็นหรือที่จัดเก็บของแบ็กซ์เตอร์ (Baxter Thawing Unit (BTU))";
translations[OPTION_PRODUCTTHAWEDOPTIONS_LEFT_ON_COUNTER] = "ทิ้งไว้บนเคาน์เตอร์ที่อุณหภูมิห้อง";
translations[OPTION_PRODUCTTHAWEDOPTIONS_REFRIGERATOR] = "ตู้เย็น";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_EVIDENCE] = "ใช่ - พบหลักฐานของความเสียหายระหว่างการขนส่ง";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_LEAK_OBSERVED] = "ใช่ - มีการรั่วไหล";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_HOLE_OR_INCOMPLETE] = "ใช่ - มีรูหรือการปิดผนึกที่ไม่สมบูรณ์บนถุงนอก";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_SPIKING] = "ใช่ - การเสียบหรือผสมทำได้ยาก";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_DIFFICULTY_BREAKING] = "ใช่ - การหักแกน frangible ทำได้ยาก";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CRYSTALLIZATION] = "ใช่ - มีการตกผลึกหรือการตกตะกอนของสารละลาย";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_YES_THERE_WAS_CLOUDINESS] = "ใช่ - พบสารละลายขุ่น/ตกตะกอนในผลิตภัณฑ์ที่แช่แข็ง (Frozen Galaxy product)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_PRODUCT_DID_NOT] = "ผลิตภัณฑ์ใช้งานไม่ได้ผล  (lack of effect)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_UNINTENDED_EFFECT] = "ผลกระทบ / ปฏิกิริยาที่เกิดขึ้นโดยไม่ได้ตั้งใจ กรุณาระบุ: ";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPTION_APPROPRIATEDESCRIPTIONOPTIONS_DAMAGED_SHIPPING] = "กล่องบรรจุเสียหายในระหว่างการขนส่ง";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "ได้รับผลิตภัณฑ์ที่หมดอายุ";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_EXPIRED_PRODUCT_FOUND] = "พบผลิตภัณฑ์ที่หมดอายุแล้ว";
translations[OPTION_LABELINGISSUEOPTIONS_BARCODE_ISSUE] = "ปัญหาบาร์โค้ด - ข้อมูลที่ไม่ถูกต้องปรากฏขึ้นเมื่อทำการสแกน";
translations[OPTION_LABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "พบความยากในการสแกน/บาร์โค้ดไม่สามารถแสกนได้";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "ได้รับผลิตภัณฑ์ที่หมดอายุ";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_PRODUCT_INVENTORY] = "พบผลิตภัณฑ์ที่หมดอายุแล้วในคลัง";
translations[OPTION_LABELINGISSUEOPTIONS_EXPIRED_ILLEGIBLE_LABEL] = "ฉลากอ่านไม่ออก";
translations[OPTION_LABELINGISSUEOPTIONS_INCORRECT_LABEL] = "ข้อมูลบนฉลากไม่ถูกต้อง";
translations[OPTION_LABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "ข้อมูลบนฉลากไม่ครบถ้วน";
translations[OPTION_LABELINGISSUEOPTIONS_ILABEL_TOO_SIMILAR] = "ฉลากเหมือนผลิตภัณฑ์อื่นเกินไป";
translations[OPTION_LABELINGISSUEOPTIONS_LABELS_PRODUCT] = "ฉลากของผลิตภัณฑ์, ฉลากกล่อง, รายการจัดส่ง ไม่ตรงกันกับข้อมูลของผลิตภัณฑ์";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_BARCODE] = "บาร์โค้ดหายไป";
translations[OPTION_DESCOFISSUEOPTIONS_CARTON_BOX] = "ผลิตภัณฑ์ในกล่องไม่ถูกต้องหรือพบผลิตภัณฑ์ผสมกัน";
translations[OPTION_DESCOFISSUEOPTIONS_DAMAGED_SHIPPING] = "กล่องเสียหายในระหว่างการขนส่งผลิตภัณฑ์";
translations[OPTION_DESCOFISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "ได้รับผลิตภัณฑ์เกิน";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "ได้รับผลิตภัณฑ์ที่หมดอายุแล้ว";
translations[OPTION_DESCOFISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "พบผลิตภัณฑ์ที่หมดอายุแล้ว";
translations[OPTION_DESCOFISSUEOPTIONS_PART_OF_THE_CARTON] = "ส่วนหนึ่งของกล่องถูกเปิดหรือไม่ถูกปิดผนึก";
translations[OPTION_DESCOFISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "ข้อมูลผลิตภัณฑ์บนกล่องและฉลากขนส่งไม่ตรงกับผลิตภัณฑ์ภายในกล่อง";
translations[OPTION_DESCOFISSUEOPTIONS_UNITS_WERE_MISSING] = "จำนวนผลิตภัณฑ์ไม่ครบถ้วนตามที่ระบุไว้";
translations[OPTION_DESCOFISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_LABELINGISSUEOPTIONS_MISSING_LABEL] = "ไม่มีฉลาก";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_EXPIRATION_DATE] = "วันหมดอายุ";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_LOT_NUMBER] = "หมายเลขรุ่นผลิตภัณฑ์ (Lot Number)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_NDC_NUMBER] = "หมายเลข NDC Number";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_DROPLETS_MOISTURE] = "มีหยดน้ำ/ความชื้นภายในถุงนอกโดยไม่พบการรั่วไหล";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK] = "รั่ว";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_LEAK_OBSERVED] = "การรั่วไหลสังเกตเห็นได้เมื่อบีบถุง";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_FLOWING] = "สารละลายไหลผ่านแกน frangible";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_SOLUTION_INSIDE] = "สารละลายอยู่ภายในถุงนอกโดยไม่พบการรั่วไหล";
translations[OPTION_COMPONENTLEAKINGOPTIONS_BETWEEN_OVERPOUCH] = "ระหว่างบรรจุภัณฑ์หลักกับถุงหุ้ม";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONNECTION_BETWEEN] = "รอยต่อระหว่างผลิตภัณฑ์";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_MEMBRANE] = "Container - Membrane Port/Tube";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_INJECTION] = "Container - Injection/Filling Port";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER_HANGER] = "Container - Hanger Hole";
translations[OPTION_COMPONENTLEAKINGOPTIONS_CONTAINER] = "บรรจุภัณฑ์";
translations[OPTION_COMPONENTLEAKINGOPTIONS_FRANGIBLE] = "Frangible";
translations[OPTION_COMPONENTLEAKINGOPTIONS_RUBBER_STOPPER] = "Rubber Stopper";
translations[OPTION_COMPONENTLEAKINGOPTIONS_SHRINKBAND] = "Shrinkband";
translations[OPTION_COMPONENTLEAKINGOPTIONS_TIP_PROTECTOR] = "Tip Protector";
translations[OPTION_COMPONENTLEAKINGOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_COMPONENTLEAKINGOPTIONS_VIAL_ADAPTER] = "Vial Adapter";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_SCENARIOSLEAKOPTIONS_DAMAGE_HOLES] = "พบความเสียหาย (รู รอยขาด) ที่บรรจุภัณฑ์รองหรือกล่องสำรอง";
translations[OPTION_SCENARIOSLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "การสัมผัสกับความร้อน/เย็นเกินไป";
translations[OPTION_SCENARIOSLEAKOPTIONS_LEAK_AT_VAPORIZER] = "การรั่วไหลที่ vaporizer interface";
translations[OPTION_SCENARIOSLEAKOPTIONS_OPENING_SHIPPING] = "เปิดกล่องด้วยคัตเตอร์/วัตถุมีคม";
translations[OPTION_SCENARIOSLEAKOPTIONS_PETS_CLAWED] = "สัตว์เลี้ยง (ข่วน/กัด)";
translations[OPTION_SCENARIOSLEAKOPTIONS_SOLUTION_BAG_UNDER] = "ถุงน้ำยาอยู่ภายใต้ความดันด้วย Pressure cuff หรือเครื่องอื่นๆ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGE_HOLES] = "พบความเสียหาย (รู รอยขาด) ที่บรรจุภัณฑ์รองหรือกล่องสำรอง";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_DAMAGED_SHIPPING] = "กล่องเสียหายในระหว่างขนส่ง";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_EXPOSURE_TO_EXTREME] = "การสัมผัสกับความร้อน/เย็นเกินไป";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_LEAK_AT_VAPORIZER] = "การรั่วไหลที่ vaporizer interface";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_OPENING_SHIPPING] = "เปิดกล่องด้วยคัตเตอร์/วัตถุมีคม";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_PETS_CLAWED] = "สัตว์เลี้ยง (ข่วน/กัด)";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_SOLUTION_BAG_UNDER] = "ถุงน้ำยาอยู่ภายใต้ความดันด้วย Pressure cuff หรือเครื่องอื่นๆ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SCENARIOSWITHLEAKOPTIONS_NONE_OF_THE_ABOVE] = "ไม่มีข้อใดข้างต้น";
translations[NO_DESCRIBE_THE_COLOR] = "ไม่ - ระบุสี ";
translations[OPTION_LIQUIDSPILLEDOPTIONS_ML] = "1-10 มล.";
translations[OPTION_LIQUIDSPILLEDOPTIONS_GREATER_THAN_ML] = "มากกว่า 10 มล.";
translations[OPTION_LIQUIDSPILLEDOPTIONS_LESS_THAN_ML] = "น้อยกว่า 1 มล.";
translations[OPTION_VISIBLEDEFECTSOPTIONS_BOTTLE] = "ขวด";
translations[OPTION_VISIBLEDEFECTSOPTIONS_CAP] = "Cap";
translations[OPTION_VISIBLEDEFECTSOPTIONS_VALVE_NECK] = "วาล์ว";
translations[OPTION_VISIBLEDEFECTSOPTIONS_NONE] = "ไม่มี";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_CONNECTING] = "ความยากในการเชื่อมต่อผลิตภัณฑ์กับผลิตภัณฑ์อื่น";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_DISCONNECTING] = "ความยากในการถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "การแยกส่วนประกอบในผลิตภัณฑ์เดียวกัน";
translations[OPTION_OPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "การแยก/ถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_DRIP_CHAMBER] = "กระเปาะ (Drip Chamber)";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_TUBING] = "สาย (Tubing)";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WHATCOMPONENTDISCOLOREDOPTIONS_OTHER_PLEASE_SPECIFY] = "อื่นๆ โปรดระบุ";
translations[OTHER_PLEASE_SPECIFY] = "อื่นๆ โปรดระบุ";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_WHITE_CLOUDY] = "ขาว/ขาวขุ่น";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_YELLOW_BROWNISH] = "สีเหลือง/น้ำตาล";
translations[OPTION_DESCRIBESDISCOLORATIONOPTIONS_OTHER_PLEASE_SPECIFY] = "อื่น ๆ - โปรดระบุ";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_IN_THE_PRIMARY_PACKAGING] = "ในบรรจุภัณฑ์หลัก /ถุงหุ้มชั้นนอก (blister pouch)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_IV] = "ภายใน IV fluid path (ในสาย)";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "ภายในกล่อง";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_ON_THE_EXTERIOR] = "บนด้านนอกของกล่อง";
translations[OPTION_WHEREMATTERLOCATEDOPTIONS_OUTSIDE_THE_IV] = "ภายนอก IV fluid path (ด้านนอกขสาย)";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_EMBEDDED] = "ฝังติดแน่น";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_LOOSE] = "เลื่อน หลุด ลอยได้";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_NOT_APPLICABLE] = "ไม่สามารถระบุได้";
translations[OPTION_INFUSATESOLUTIONOPTIONS_DESCRIBE_COLOR] = "อธิบายลักษณะสี";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_CHANGE_IN_COLOR] = "ใช่ - เปลี่ยนสี ";
translations[OPTION_INFUSATESOLUTIONOPTIONS_YES_PRECIPITATE] = "ใช่ - ตกตะกอน";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_ACCESS_SITE] = "Access Site";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_BURRETTES] = "Burrettes";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_CLAMP] = "Clamp";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_DRIP_CHAMBER] = "Drip Chamber";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_TUBING] = "Tubing";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[DAMAGECOMPONENTAFFECTEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_FILTERS] = "Filters";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_LUER_CONNECTOR] = "Luer Connector";
translations[OPTION_DAMAGECOMPONENTAFFECTEDOPTIONS_SPIKE] = "Spike";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_CUT_CRACKED_BROKEN] = "ส่วนประกอบขาด/แตก/เสียหาย";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_INCORRECT_COMPONENT_ASSEMBLY] = "ประกอบไม่ถูกต้อง - โปรดระบุ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_KINKED_COLLAPSED] = "ส่วนประกอบยุบ/บุบ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_LOOSE_COMPONENT] = "พบส่วนประกอบหลวมอยู่ภายในบรรจุภัณฑ์";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MALFORMED_MIS_SHAPED] = "ส่วนประกอบที่มีรูปแบบ/รูปร่างผิดไปจากปกติ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_MISSING_COMPONENT] = "ส่วนประกอบขาดหายไป";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_CONNECTING_THE] = "พบความยากในการเชื่อมต่อผลิตภัณฑ์กับผลิตภัณฑ์อื่น";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_DIFFICULTY_DISCONNECTING_THE] = "พบความยากในการถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_LOOSE_CONNECTION] = "การเชื่อมต่อหลวม";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_DISCONNECTION] = "การแยก/หลุดออกของผลิตภัณฑ์จากผลิตภัณฑ์อื่น";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_SEPARATION_BETWEEN_TWO] = "การแยกระหว่างส่วนประกอบที่ควรจะติดกันภายในผลิตภัณฑ์เดียวกัน";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_CONNECT] = "ไม่สามารถเชื่อมต่อสองผลิตภัณฑ์เข้าด้วยกัน";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_UNABLE_TO_DISCONNECTT] = "ไม่สามารถถอดต่อผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่นได้";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "ปัญหาบาร์โค้ด - ข้อมูลที่ไม่ถูกต้องปรากฏขึ้นเมื่อทำการสแกน";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_CHANGE_IN_LABELING] = "การเปลี่ยนแปลงฉลาก";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "พบความยากในการสแกน/บาร์โค้ดไม่สามารถแสกนได้";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_EXPIRED_PRODUCT] = "ผลิตภัณฑ์หมดอายุ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_INCORRECT_INFORMATION_ON_LABEL] = "ข้อมูลบนฉลากไม่ถูกต้อง";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_BARCODE_UDI] = "บาร์โค้ดหายไป/UDI";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_MISSING_INFORMATION_ON_LABEL] = "ข้อมูลบนฉลากไม่ครบถ้วน";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_PRODUCT_WITH_NO_EXPIRATION] = "ผลิตภัณฑ์ที่ไม่มีวันที่หมดอายุ";
translations[OPTION_DESCRIPTIONLABELINGISSUEOPTIONS_SMUDGES_ILLEGIBLE_LABELING] = "รอยเปื้อน / ฉลากอ่านไม่ออก";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_CARTON_BOX] = "ผลิตภัณฑ์ในกล่องไม่ถูกต้องหรือพบผลิตภัณฑ์ผสมกัน";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_DAMAGED_SHIPPING] = "กล่องเสียหายในระหว่างการขนส่งผลิตภัณฑ์";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_DELIVERED] = "ได้รับผลิตภัณฑ์ที่หมดอายุแล้ว";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXPIRED_PRODUCT_FOUND] = "พบผลิตภัณฑ์ที่หมดอายุแล้ว";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_BAXTER] = "แบ็กซ์เตอร์";
translations[OPTION_ORDEREDFROMBAXTEROPTIONS_DISTRIBUTOR] = "ผู้กระจายสินค้า ";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_EXTRA_UNITS_WERE_RECEIVED] = "ได้รับผลิตภัณฑ์เกิน";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PART_OF_THE_CARTON] = "ส่วนหนึ่งของกล่องถูกเปิดหรือไม่ถูกปิดผนึก";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_PRODUCT_INFO_ON_THE_CARTON] = "ข้อมูลผลิตภัณฑ์บนกล่องและฉลากขนส่งไม่ตรงกับผลิตภัณฑ์ภายในกล่อง";
translations[OPTION_APPROPRIATEDESCISSUEOPTIONS_UNITS_WERE_MISSING] = "จำนวนผลิตภัณฑ์ไม่ครบถ้วนตามที่ระบุไว้";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ACCESS_SITE] = "Access Site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_AIR_VENT] = "Air vent";
translations[OPTION_LEAKCOMINGFROMOPTIONS_BURETTES] = "Burettes";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CAP] = "Cap";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLEARLINK_INJECTION_SITES] = "Clearlink injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_CLAMP] = "Clamp";
translations[OPTION_LEAKCOMINGFROMOPTIONS_DRIP_CHAMBER] = "Drip Chamber";
translations[OPTION_LEAKCOMINGFROMOPTIONS_FILTERS] = "Filters";
translations[OPTION_LEAKCOMINGFROMOPTIONS_INTERLINK_INJECTION_SITES] = "Interlink injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LUER_CONNECTOR] = "Luer connector";
translations[OPTION_LEAKCOMINGFROMOPTIONS_SPIKE] = "Spike";
translations[OPTION_LEAKCOMINGFROMOPTIONS_TUBING] = "Tubing";
translations[OPTION_LEAKCOMINGFROMOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER] = "อื่น ๆ (ระบุ)";
translations[OPTION_LEAKCOMINGFROMOPTIONS_LEAK_BETWEEN_THE] = "พบรอยรั่วระหว่าง injection site และ tubing";
translations[OPTION_LEAKCOMINGFROMOPTIONS_NEEDLE_BASED] = "Needle-Based Injection Site";
translations[OPTION_LEAKCOMINGFROMOPTIONS_ONE_LINK_INJECTION] = "One-Link injection sites";
translations[OPTION_LEAKCOMINGFROMOPTIONS_OTHER_INJECTION] = "Other injection sites ";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CRACK_BREAK_IN] = "แตกแตกในส่วนประกอบของเซตแข็ง";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_CUT_SLICE_IN] = "รอยตัด/รอยขาด ในสายอ่อน";
translations[DISCONNECTION_OF_CONNECTABLE] = "การหลุดออกจากกันของส่วนประกอบที่เชื่อมต่อ/ผลิตภัณฑ์ที่เชื่อมต่อเข้าหากัน";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_DISCONNECTION_OF_CONNECTABLE] = "การหลุดออกจากกันของส่วนประกอบที่เชื่อมต่อ/ผลิตภัณฑ์ที่เชื่อมต่อเข้าหากัน";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_SEPARATION_OF_BONDED_COMPONENTS] = "การแยกออกจากกันของส่วนประกอบที่ควรติดกัน";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_YES_DESCRIBE_IRREGULARITIES] = "ใช่ - อธิบายเกี่ยวกับความผิดปกติ/ความเสียหายที่พบ";
translations[YES_SPECIFY_THE_TOOL] = "ใช่ - ระบุเครื่องมือที่ใช้";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_BACKFLOW] = "ไหลย้อนกลับ (Backflow)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT] = "ปัญหาการหนีบปิด - หนีบยากแต่สามารถหนีบปิดได้ (Clamp Failure - Difficult to Clamp (but able to close eventually))";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_UNABLE] = "ปัญหาการหนีบปิด - ไม่สามารถหนีบปิดสนิทได้ (Clamp Failure - Unable to close off entirely)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_CLAMP_FAILURE_DIFFICULT_UNABLE] = "ปัญหาการหนีบปิด - เปิดยากหรือไม่สามารถเปิดได้ (Clamp Failure - Difficult/Unable to Open)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_NO_FLOW] = "ไม่ไหล (No Flow)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OVER_INFUSION] = "ให้สารละลายเกิน (Over Infusion)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_RESTRICTED_SLOW] = "ไหลช้า/ไหลอย่างจำกัด (Restricted/Slow Flow)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_SIMULTANEOUS_FLOW] = "ไหลต่อเนื่อง (Simultaneous Flow)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_CLEAR] = "ไม่สามารถชะล้างส่วนประกอบได้ (Unable to clear component)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNABLE_TO_PRIME] = "ไม่สามารถไพรม์เครื่องได้ (Unable to Prime)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_UNDER_INFUSION] = "ให้สารละลายขาด (Under Infusion)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_PATIENTS_BLOOD] = "เลือดผู้ป่วย (ไม่รวมเลือดที่มาจากผลิตภัณฑ์ที่ให้ผู้ป่วย)";
translations[OPTION_FLOWINGBACKWARDSOPTIONS_SOLUTIONS_BLOOD] = "ผลิตภัณฑ์ที่เป็นสารละลาย/เลือด";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DAMAGE_HOLE] = "รั่ว/เป็นรู";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_DISCONNECTION] = "แยก/หลุดออกจากการเชื่อมต่อ";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_LEAK] = "รั่ว";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_MEDICATION_WAS_BEING] = "ยาที่ให้ผ่านการให้แรงดัน (pressurized infusion) เข็มฉีดยาหรือปั๊ม IV";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_LOWER] = "ถุงที่สองอยู่ต่ำกว่าถุงที่หนึ่ง";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SECONDARY_BAG_WAS_AT] = "ถุงที่สองมีความสูงเท่ากันกับถุงที่หนึ่ง";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_BLOOD_CLOTTING] = "การแข็งตัวของเลือด";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_CATHETER_WAS] = "สายสวนไม่สามารถล้างออกก่อนที่จะติดตั้งเซต (Catheter was not able to be flushed prior to attaching the set)";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_KINKED_TUBING] = "สายบุบ งอ";
translations[OPTION_PREVIOUSLYFLOWOBSERVEDOPTIONS_TUBING_INJECTION] = "การอุดตันของสาย/บริเวณที่ฉีดเข้าผู้ป่วย";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_PRIMARY_AND_SECONDARY] = "Primary and Secondary container (piggyback)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_OR_MORE_LEADS] = "Two or more leads flowing in a multi-lead set";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_TWO_ADMINISTRATION] = "Two administration sets each with its own infusion pump";
translations[OPTION_HANGERUSEDOPTIONS_BAXTER_HANGER] = "เสาแขวนของแบ็กซ์เตอร์";
translations[OPTION_HANGERUSEDOPTIONS_NON_BAXTER_HANGER] = "เสาแขวนที่ไม่ใช่ของแบ็กซ์เตอร์";
translations[OPTION_BAGLOWEROPTIONS_BAGS_WERE_AT] = "ทั้งสองถุงอยู่ในระดับเดียวกัน";
translations[OPTION_BAGLOWEROPTIONS_PRIMARY] = "ถุงที่หนึ่ง (Primary)";
translations[OPTION_BAGLOWEROPTIONS_SECONDARY] = "ถุงที่สอง (Secondary)";
translations[OPTION_YSITECONNECTEDOPTIONS_MIDDLE] = "กลาง";
translations[OPTION_YSITECONNECTEDOPTIONS_LOWER] = "ล่าง";
translations[OPTION_YSITECONNECTEDOPTIONS_UPPER] = "บน";
translations[OPTION_WITHPUMPOPTIONS_YES_PROVIDE_NAME] = "ใช่ - ระบุชื่อและรหัสของปั๊ม";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_DARK_BLUE] = "Dark Blue Slide Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_LIGHT_BLUE] = "Light Blue Slide Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_NOTCH_CLAMP] = "Notch Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_ROLLER_CLAMP] = "Roller Clamp";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_WHITE_SLIDE_CLAMP] = "White Slide Clamp";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_THE_CLAMP] = "ใช่ - ที่หนีบ (clamp) เสียหายหรือแตกออก";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_AIR_IN_LINE] = "พบอากาศภายในสาย (Air In Line)";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_CLAMP_ISSUE] = "ปัญหาการหนีบ";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_ODOR] = "กลิ่น";
translations[OPTION_OTHERSITUATIONSPRODUCTOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_NOTCH_PINCH] = "Notch/Pinch Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_ROLLER_CLAMP] = "Roller Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_SLIDE_CLAMP] = "Slide Clamp";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WHICHCLAMPISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_CRACKED_BROKEN] = "แตก/หัก";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_OPEN] = "เปิดได้ยาก";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_DIFFICULT_TO_CLOSE] = "ปิดได้ยาก";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_MISSING] = "หายไป";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_OPEN] = "เปิดไม่ได้";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CLOSE] = "ปิดไม่ได้";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNABLE_TO_CONTROL] = "ควบคุมการไหลไม่ได้";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_TO_SQUEEZE] = "บีบกระเปาะ (drip chamber) ลำบาก";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_INSTRUCTIONS_WERE] = "คำอธิบายการใช้งานเข้าใจยาก";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_PRODUCT_WAS_DIFFICULT] = "ผลิตภัณฑ์ใช้งานยาก";
translations[OPTION_LEAKOCCUROPTIONS_CRACK_BREAK] = "แตก หัก";
translations[OPTION_LEAKOCCUROPTIONS_CUT_SLICE] = "รอยตัด รอยเฉือน";
translations[OPTION_LEAKOCCUROPTIONS_DISCONNECTION_OF_CONNECTABLE] = "การหลุดออกจากกันของส่วนประกอบที่เชื่อมต่อ/ผลิตภัณฑ์ที่เชื่อมต่อเข้าหากัน";
translations[DISCONNECTION_OF_CONNECTABLE] = "การหลุดออกจากกันของส่วนประกอบที่เชื่อมต่อ/ผลิตภัณฑ์ที่เชื่อมต่อเข้าหากัน";
translations[OPTION_LEAKOCCUROPTIONS_HOLE_TEA] = "รู รอยขาด";
translations[OPTION_LEAKOCCUROPTIONS_SEPARATION_OF_BONDED] = "การแยกออกจากกันของส่วนประกอบที่เชื่อมติดกัน";
translations[OPTION_LEAKOCCUROPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_LEAKSCENARIOSOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGE_HOLES] = "พบความเสียหาย (รู รอยขาด) ที่บรรจุภัณฑ์รองหรือกล่องสำรอง";
translations[OPTION_LEAKSCENARIOSOPTIONS_DAMAGED_SHIPPING_CARTON] = "กล่องเสียหายในระหว่างขนส่ง";
translations[OPTION_LEAKSCENARIOSOPTIONS_EXPOSURE_TO_EXTREME] = "การสัมผัสกับความร้อน/เย็นเกินไป";
translations[OPTION_LEAKSCENARIOSOPTIONS_OPENING_SHIPPING] = "เปิดกล่องด้วยคัตเตอร์/วัตถุมีคม";
translations[OPTION_LEAKSCENARIOSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_LEAKSCENARIOSOPTIONS_NONE_OF_THE_ABOVE] = "ไม่มีข้อใดข้างต้น";
translations[OPTION_LEAKSCENARIOSOPTIONS_PRESSURE_CUFF] = "ใช้ Pressure cuff หรือ pressure injector";
translations[OPTION_SCENARIOSLEAKOPTIONS_ADHERED_PORT] = "Adhered Port";
translations[OPTION_LEAKSCENARIOSOPTIONS_PETS_CLAWED_CHEWED] = "สัตว์เลี้ยง (ข่วน/กัด)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_PRODUCT] = "ผลิตภัณฑ์";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_SHIPPING_CARTON_BOX] = "กล่องบรรจุ";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_PRODUCT] = "ภายในผลิตภัณฑ์";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_INSIDE_THE_SHIPPING] = "ภายในกล่อง";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF_PRODUCT] = "ด้านนอกของผลิตภัณฑ์";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_CONNECTING] = "ความยากในการเชื่อมต่อผลิตภัณฑ์เข้ากับผลิตภัณฑ์อื่น";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_DIFFICULTIES_DISCONNECTING] = "ความยากในการถอดผลิตภัณฑ์ออกจากผลิตภัณฑ์อื่น";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_LOOSE_CONNECTION] = "การเชื่อมต่อหลวม";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_OF_COMPONENTS] = "การแยกออกจากกันของส่วนประกอบจากผลิตภัณฑ์เดียวกัน";
translations[OPTION_SELOPTIONCONNECTIONISSUEOPTIONS_SEPARATION_DISCONNECTION] = "การแยก/หลุดออกของผลิตภัณฑ์จากผลิตภัณฑ์อื่น";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_EXTERIOR] = "ด้านนอกของกล่อง";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_INSIDE_OF] = "ด้านในของบรรจุภัณฑ์รอง/ถุงนอก";
translations[OPTION_MATTERFOREIGNLOCATEDOPTIONS_ON_THE_OUTSIDE_OF] = "ด้านนอกของบรรจุภัณฑ์รอง/ถุงนอก";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_NOT_FLOWING] = "ไม่ไหล";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_RESTRICTED_OR] = "ไหลบางส่วนหรือไม่สม่ำเสมอ";
translations[OPTION_OPTIONFLOWISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_BARCODE_ISSUE] = "ปัญหาบาร์โค้ด - ข้อมูลที่ไม่ถูกต้องปรากฏขึ้นเมื่อทำการสแกน";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_DIFFICULTIES_SCANNING] = "พบความยากในการสแกน/บาร์โค้ดไม่สามารถแสกนได้";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_ILLEGIBLE_LABEL] = "ฉลากอ่านไม่ออก";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCORRECT_LABEL] = "ข้อมูลบนฉลากไม่ถูกต้อง";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_INCOMPLETE_LABEL] = "ข้อมูลบนฉลากไม่ครบถ้วน";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABELS_PRODUCT] = "ฉลากของผลิตภัณฑ์, ฉลากกล่อง, รายการจัดส่ง ไม่ตรงกันกับข้อมูลของผลิตภัณฑ์";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_LABEL_TOO_SIMILAR] = "ฉลากเหมือนผลิตภัณฑ์อื่นเกินไป";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_LABEL] = "ไม่มีฉลาก";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_MISSING_BARCODE] = "บาร์โค้ดหายไป";
translations[OPTION_MOSTAPPROLABELINGISSUEOPTIONS_OTHER] = "อื่น ๆ (ระบุ)";
translations[OPTION_DESCOFISSUEOPTIONS_FROZEN_PRODUCT] = "ได้รับผลิตภัณฑ์แช่แข็ง";
translations[OPTION_DESCOFISSUEOPTIONS_THAWED_PRODUCT] = "ได้รับผลิตภัณฑ์ที่ละลายแล้ว";
translations[OPTION_ALARMOPTIONS_YES_ALARM_NOT_KNOWN] = "ใช่, ไม่ทราบสัญญาณแจ้งเตือน";
translations[OPTION_ALARMOPTIONS_YES_SPECIFY] = "ใช่, ระบุ";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_OPEN] = "ใช่ - transfer set ไม่สามารถเปิดจนสุดได้";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TRANSFER_FULLY_CLOSED] = "ใช่ - transfer set ไม่สามารถปิดจนสุดได้";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_OPEN_AT_ALL] = "เกลียวหมุน (twist clamp) แน่นเกิดไปจนไม่สามารถหมุนเปิด transfer set ได้";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_YES_THE_TWIST_CLOSE_AT_ALL] = "เกลียวหมุน (twist clamp) แน่นเกิดไปจนไม่สามารถหมุนปิด transfer set ได้";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BOX_OR_OVERPOUCH] = "กล่องหรือถุงหุ้ม (overpouch)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_BLUE_CLAMP_ON] = "Blue Clamp on Last Fill Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_CASSETT] = "Cassett";
translations[OPTION_COMPONENTHADISSUEOPTIONS_DRAIN_LINE] = "Drain Line Connector and Pull Ring Cap";
translations[OPTION_COMPONENTHADISSUEOPTIONS_EFFLUENT_SAMPLE] = "Effluent Sample Site";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LINES] = "Lines";
translations[OPTION_COMPONENTHADISSUEOPTIONS_LUER_SPIKE] = "Luer/Spike Connectors";
translations[OPTION_COMPONENTHADISSUEOPTIONS_ORGANIZER] = "Organizer";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PATIENT_LINE] = "Pull Ring Caps/Tip Protector on the Patient Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_PULL_RING_PROTECTORS] = "Pull Ring Caps/Tip Protectors";
translations[OPTION_COMPONENTHADISSUEOPTIONS_RED_CLAMP_ON] = "Red Clamp on Heater Line";
translations[OPTION_COMPONENTHADISSUEOPTIONS_TACK_WELD] = "Tack Weld";
translations[OPTION_COMPONENTHADISSUEOPTIONS_WHITE_CLAMP_ON_SUPPLY] = "White Clamp on Supply Line";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_BEIGE_CATHETER] = "Beige Catheter Adapter Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_CHIP_INSERT] = "Chip Insert";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_DARK_BLUE_CONNECTOR] = "Dark Blue Connector";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_MAIN] = "Light Blue Main Body";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_PULL] = "Light Blue Pull Ring Cap";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_LIGHT_BLUE_OCCLUDER] = "Light Blue Occluder Legs";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_SILICONE_TUBING] = "Silicone Tubing";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_TITANIUM_SPIKE] = "Titanium Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_UV_FLASH_SPIKE] = "UV Flash Spike";
translations[OPTION_SELECTCOMPONENTHADISSUEOPTIONS_WHITE_TWIST_CLAMP] = "White Twist Clamp/Sleeve";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONS_YES_DESCRIBE_THE_DAMAGE] = "ใช่: ระบุความเสียหายที่พบ";
translations[OPTION_MONTHOPTIONS_JAN] = "มกราคม";
translations[OPTION_MONTHOPTIONS_FEB] = "กุมภาพันธ์";
translations[OPTION_MONTHOPTIONS_MAR] = "มีนาคม";
translations[OPTION_MONTHOPTIONS_APR] = "เมษายน";
translations[OPTION_MONTHOPTIONS_MAY] = "พฤษภาคม";
translations[OPTION_MONTHOPTIONS_JUN] = "มิถุนายน";
translations[OPTION_MONTHOPTIONS_JUL] = "กรกฎาคม";
translations[OPTION_MONTHOPTIONS_AUG] = "สิงหาคม";
translations[OPTION_MONTHOPTIONS_SEP] = "กันยายน";
translations[OPTION_MONTHOPTIONS_OCT] = "ตุลาคม";
translations[OPTION_MONTHOPTIONS_NOV] = "พฤศจิกายน";
translations[OPTION_MONTHOPTIONS_DEC] = "ธันวาคม";
translations[OPTION_PROBLEMOPTIONS_OTHER] = "อื่นๆ";
translations[OPTION_REPORTEDTOOPTIONS_OTHER] = "อื่นๆ ";
translations[OPTION_DIFFICULTTOUSEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_BLOCKINGFLOWOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DESCRIBEISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_MATERIALLOCATEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_OBSERVEDDAMAGEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_TYPEOBSERVEDDAMAGEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_PRODUCTDISCOLOREDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SPECIFICALLYDESCRIBESOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_PRODUCTTHAWEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_DAMAGESPECIFICINFOOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_APPROPRIATEDESCRIPTIONOPTIONS_OTHER] = "อื่น ๆ (ระบุ)";
translations[OPTION_LABELINGISSUEOPTIONS_OTHER] = "อื่น ๆ (ระบุ)";
translations[OPTION_WHATINCORRECTLYDISPLAYEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_MOISTUREOBSERVEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_COMPONENTLEAKINGOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SITUATIONDESCRIBESISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_FOLLOWINGSCENARIOSOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SITUATIONFLOWISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SIMULTANEOUSFLOWOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_WHATCLAMPFAILEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_CLAMPDESCRIBESISSUEOPTIONS_DIFFICULT_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_PRODUCTDAMAGEDOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_COMPONENTHADISSUEOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_FOLLOWINGOCCUROPTIONS_NONE_OF_THE_ABOVE] = "ไม่มีข้อใดข้างต้น";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PREVIOUSLYREPORTEDOPTIONS_YES] = "ใช่";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ADDANOTHERFACILITYOPTIONS_YES] = "ใช่";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_YES] = "ใช่";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_OTHERFACILITYREPORTOPTIONS_YES] = "ใช่";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_ASKED_UNKNOWN] = "ผู้แจ้งไม่ทราบ";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_NO] = "ไม่ใช่";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_AVAILABILITYOPTIONSDISTRIBUTOR_YES] = "ใช่";
translations[OPTION_AVAILABILITYOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_AVAILABILITYOPTIONS_YES] = "ใช่";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_YES] = "ใช่";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_YES] = "ใช่";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_UNUSEDAVAILABILITYOPTIONS_YES] = "ใช่";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SELFNEGATIVEIMPACTOPTIONS_YES] = "ใช่";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PATIENTNEGATIVEIMPACTOPTIONS_YES] = "ใช่";
translations[OPTION_COUNTERACTIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_COUNTERACTIONOPTIONS_YES] = "ใช่";
translations[OPTION_DRUGUSEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DRUGUSEDOPTIONS_YES] = "ใช่";
translations[OPTION_SHARECONTACTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SHARECONTACTOPTIONS_YES] = "ใช่";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EXPLICITINVESTIGATIONREQUESTOPTIONS_YES] = "ใช่";
translations[OPTION_DIRECTORDEROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DIRECTORDEROPTIONS_YES] = "ใช่ ";
translations[OPTION_EXCESSIVEFORCEOPTIONS_NO] = "ไม่";
translations[OPTION_EXCESSIVEFORCEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EXCESSIVEFORCEOPTIONS_YES] = "ใช่";
translations[OPTION_TWISTCLAMPOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_TWISTCLAMPOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TWISTCLAMPOPTIONS_YES] = "ใช่";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DIFFICULTIESMINICAPOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ENVIRONMENTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ENVIRONMENTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ENVIRONMENTOPTIONS_YES] = "ใช่";
translations[OPTION_SPONGEVISIBLEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SPONGEVISIBLEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SPONGEVISIBLEOPTIONS_YES] = "ใช่";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MATERIALEMBEDDEDOPTIONS_YES] = "ใช่";
translations[OPTION_PIECESMATERIALOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PIECESMATERIALOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PIECESMATERIALOPTIONS_YES] = "ใช่";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DISPOSABLECONNECTIONOPTIONS_YES] = "ใช่";
translations[OPTION_INITIALCONNECTIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_INITIALCONNECTIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_INITIALCONNECTIONOPTIONS_YES] = "ใช่";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SPIKELUERCONNECTORSOPTIONS_YES] = "ใช่";
translations[OPTION_PETSORANIMALSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PETSORANIMALSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PETSORANIMALSOPTIONS_YES] = "ใช่";
translations[OPTION_MINICAPTWISTEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_MINICAPTWISTEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MINICAPTWISTEDOPTIONS_YES] = "ใช่";
translations[OPTION_TRANSFERSETOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_TRANSFERSETOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TRANSFERSETOPTIONS_YES] = "ใช่";
translations[OPTION_RESIDUETHREADSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_RESIDUETHREADSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DAMAGECAUSELEAKOPTIONS_YES] = "ใช่";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SHIPPINGCARTONOPENOPTIONS_YES] = "ใช่";
translations[OPTION_ADAPTERDEVICEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ADAPTERDEVICEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ADAPTERDEVICEOPTIONS_YES] = "ใช่";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_NO] = "ไม่ใช่";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SQUEEZINGSOLUTIONOPTIONSS_YES] = "ใช่";
translations[OPTION_FORTHMOTIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FORTHMOTIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FORTHMOTIONOPTIONS_YES] = "ใช่";
translations[OPTION_ALARMNOFLOWOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ALARMNOFLOWOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ALARMNOFLOWOPTIONS_YES] = "ใช่";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DISCOLORATIONMARKINGSOPTIONS_YES] = "ใช่";
translations[OPTION_BROKENACTIVATEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_BROKENACTIVATEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_BROKENACTIVATEDOPTIONS_YES] = "ใช่";
translations[OPTION_vaporizerSightGlassOptions_NO] = "ไม่ใช่";
translations[OPTION_vaporizerSightGlassOptions_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_vaporizerSightGlassOptions_YES] = "ใช่";
translations[OPTION_PRODUCTHEATOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PRODUCTHEATOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PRODUCTHEATOPTIONS_YES] = "ใช่";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DAMAGEPRIORACTIVATIONOPTIONS_YES] = "ใช่";
translations[OPTION_LEAKOBSERVEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_LEAKOBSERVEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_LEAKOBSERVEDOPTIONS_YES] = "ใช่";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EMBEDDEDINTHEPRODUCTOPTIONS_YES] = "ใช่";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASSOLUTIONADDEDPRODUCTOPTIONS_YES] = "ใช่";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_CLOUDINESSGOAWAYOPTIONS_YES] = "ใช่";
translations[OPTION_AGITATEUNITOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_AGITATEUNITOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_AGITATEUNITOPTIONS_YES] = "ใช่";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PRECIPITATEDISSOLVEOPTIONS_YES] = "ใช่";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TEMPERATURELOGSFREEZEROPTIONS_YES] = "ใช่";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_NO] = "ไม่ใช่";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_STORAGEUNITCALIBRATEDOPTIONSS_YES] = "ใช่";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_RECENTPRESCRIPTIONOPTIONS_YES] = "ใช่";
translations[OPTION_EXPIREDPRODUCTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EXPIREDPRODUCTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EXPIREDPRODUCTOPTIONS_YES] = "ใช่";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ABNORMALITIESDAMAGEOPTIONS_YES] = "ใช่";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_OVERPOUCHPOUCHSCANNINGOPTIONS_YES] = "ใช่";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_LABELSSAMEINFORMATIONOPTIONS_YES] = "ใช่";
translations[OPTION_BARCODESCANNEROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_BARCODESCANNEROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_BARCODESCANNEROPTIONS_YES] = "ใช่";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FRANGIBLEOBSERVEDOPTIONS_YES] = "ใช่";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FRANGIBLEDAMAGEDEFECTOPTIONS_YES] = "ใช่";
translations[OPTION_FRANGIBLEBROKENOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FRANGIBLEBROKENOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FRANGIBLEBROKENOPTIONS_YES] = "ใช่";
translations[OPTION_MOISTURECLEAROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MOISTURECLEAROPTIONS_YES] = "ใช่";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DIFFICULTYSPIKINGOPTIONS_YES] = "ใช่";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASFRANGIBLEDAMAGEOPTIONS_YES] = "ใช่";
translations[OPTION_PRESSURECUFFOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PRESSURECUFFOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PRESSURECUFFOPTIONS_YES] = "ใช่";
translations[OPTION_LIQUIDSPILLEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_BOTTLEINTOVAPORIZEROPTIONS_YES] = "ใช่";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_REMOVEDFROMPACKAGEOPTIONS_YES] = "ใช่";
translations[OPTION_ADDINGMEDICATIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ADDINGMEDICATIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ADDINGMEDICATIONOPTIONS_YES] = "ใช่";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PATIENTCONNECTEDPRODUCTOPTIONS_YES] = "ใช่";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASPRODUCTREPLACEDOPTIONS_YES] = "ใช่";
translations[OPTION_WASPOWERINJECTOROPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WASPOWERINJECTOROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASPOWERINJECTOROPTIONS_YES] = "ใช่";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_YES] = "ใช่";
translations[OPTION_INJECTIONSITEOPENINGOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_NO] = "ไม่";
translations[OPTION_VISIBLEIRREGULARITIESOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EVENTUALLYESTABLISHEDOPTIONS_YES] = "ใช่";
translations[OPTION_TOOLUSEDASSISTOPTIONS_NO] = "ไม่";
translations[OPTION_TOOLUSEDASSISTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SECUREPRIORUSEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SECUREPRIORUSEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SECUREPRIORUSEOPTIONS_YES] = "ใช่";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_PRIORDISCONNECTINGOPTIONS_YES] = "ใช่";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FLOWPREVIOUSLYSEENOPTIONS_YES] = "ใช่";
translations[OPTION_YSITECONNECTEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_COMPONENTSETREPLACEDOPTIONS_YES] = "ใช่";
translations[OPTION_WITHPUMPOPTIONS_NO] = "ไม่";
translations[OPTION_WITHPUMPOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_CLAMPFAILOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_CLAMPFAILOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_CLAMPFAILOPTIONS_YES] = "ใช่";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_NO] = "ไม่ ";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WASMATERIALEMBEDDEDOPTIONS_YES] = "ใช่";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_APPEARPRODUCTMATERIALOPTIONS_YES] = "ใช่";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SHIPPINGCARTONDAMAGEDOPTIONS_YES] = "ใช่";
translations[OPTION_GELPACKSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_GELPACKSOPTIONS_YES] = "ใช่";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EXPIREDPRODUCTUSEOPTIONS_YES] = "ใช่";
translations[OPTION_ALARMOPTIONS_NO] = "ไม่ ";
translations[OPTION_ALARMOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_CLEANINGSOLUTIONSOPTIONS_YES] = "ใช่";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_DIFFICULTINTWISTCLAMPOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TRANSFERREPLACEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_TRANSFERREPLACEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TRANSFERREPLACEDOPTIONS_YES] = "ใช่";
translations[OPTION_FULLYTIGHTENEDOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_FULLYTIGHTENEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_FULLYTIGHTENEDOPTIONS_YES] = "ใช่";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_NO] = "ไม่ใช่";
translations[OPTION_ANYCOMPONENTDAMAGEDOPTIONSS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ISSUERESULTLEAKOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_ISSUERESULTLEAKOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ISSUERESULTLEAKOPTIONS_YES] = "ใช่";
translations[OPTION_ISSUERESULTLEAKOPTIONS_OTHER] = "อื่นๆ (ระบุ)";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_SAMPLESAVAILABLEFOREVALUATIONOPTIONS_YES] = "ใช่";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_EXPLICITLYREQUESTOPTIONS_YES] = "ใช่";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_NO] = "ไม่ใช่";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WEREPATIENTUSINGPRODUCTOPTIONS_YES] = "ใช่";
translations[OPTION_PATIENINVOLVEMENTOPTIONS_ASKED_UNKNOWN] = "ผู้แจ้งไม่ทราบ";
translations[OPTION_MEDIAAVAILABILITYDISTRIBUTOROPTIONS_ASKED_UNKNOWN] = "ผู้แจ้งไม่ทราบ";
translations[OPTION_CHAMBERDISCOLOREDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_NO] = "ไม่";
translations[OPTION_DAMAGEISSUEOBSERVEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SCENARIOSLEAKOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_SCENARIOSLEAKOPTIONS_NONE_OF_THE_ABOVE] = "ไม่มีข้อใดข้างต้น";
translations[OPTION_MOISTURECLEAROPTIONS_NO_DESCRIBE_THE_COLOR] = "ไม่ - ระบุสี ";
translations[OPTION_EMBEDDEDPLASTICOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_WHATTYPEDAMAGEISSUEOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_TOOLUSEDASSISTOPTIONS_YES_SPECIFY_THE_TOOL] = "ใช่ - ระบุเครื่องมือที่ใช้";
translations[OPTION_SITUATIONSAPPLYEVENTOPTIONS_SEPARATION] = "การแยกออกจากัน";
translations[OPTION_HANGERUSEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_HANGERUSEDOPTIONS_NONE] = "ไม่มี";
translations[OPTION_BAGLOWEROPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_ISSUESOBSERVEDCLAMPOPTIONS_YES_OTHER] = "ใช่ - อื่นๆ ";
translations[OPTION_CLAMPISSUEEXPERIENCEDOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_MATTERFOREIGNMATERIALPIECESOPTIONS_NO] = "ไม่";
translations[OPTION_WEIGHTUNITOPTIONS_KILOGRAM] = "กิโลกรัม ";
translations[OPTION_WEIGHTUNITOPTIONS_POUND] = "ปอนด์";
translations[OPTION_INFUSATESOLUTIONOPTIONS_NO] = "ไม่";
translations[OPTION_INFUSATESOLUTIONOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[PLEASE_ENTER_THE_VALUE] = "กรุณาใส่เลือกค่า";
translations[PLEASE_SELECT_THE_VALUE] = "กรุณาเลือกค่า";
translations[PLEASE_SELECT_THE_DATE] = "กรุณาเลือกวันที่";
translations[PLEASE_CHOOSE_THE_VALUE] = "กรุณาเลือกค่า";
translations[OPTION_MEDIAAVAILABILITYOPTIONS_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_COUNTRYOPTIONS_GREAT_BRITAIN] = "GREAT BRITAIN";
translations[OPTION_COUNTRYOPTIONS_KOSOVO] = "KOSOVO";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_IRELAND] = "NORTHERN IRELAND";
translations[OPTION_COUNTRYOPTIONS_AFGHANISTAN] = "AFGHANISTAN";
translations[OPTION_COUNTRYOPTIONS_ÅLAND_ISLANDS] = "ÅLAND ISLANDS";
translations[OPTION_COUNTRYOPTIONS_ALBANIA] = "ALBANIA";
translations[OPTION_COUNTRYOPTIONS_ALGERIA] = "ALGERIA";
translations[OPTION_COUNTRYOPTIONS_AMERICAN_SAMOA] = "AMERICAN SAMOA";
translations[OPTION_COUNTRYOPTIONS_ANDORRA] = "ANDORRA";
translations[OPTION_COUNTRYOPTIONS_ANGOLA] = "ANGOLA";
translations[OPTION_COUNTRYOPTIONS_ANGUILLA] = "ANGUILLA";
translations[OPTION_COUNTRYOPTIONS_ANTARCTICA] = "ANTARCTICA";
translations[OPTION_COUNTRYOPTIONS_ANTIGUA_AND_BARBUDA] = "ANTIGUA AND BARBUDA";
translations[OPTION_COUNTRYOPTIONS_ARGENTINA] = "ARGENTINA";
translations[OPTION_COUNTRYOPTIONS_ARMENIA] = "ARMENIA";
translations[OPTION_COUNTRYOPTIONS_ARUBA] = "ARUBA";
translations[OPTION_COUNTRYOPTIONS_AUSTRALIA] = "AUSTRALIA";
translations[OPTION_COUNTRYOPTIONS_AUSTRIA] = "AUSTRIA";
translations[OPTION_COUNTRYOPTIONS_AZERBAIJAN] = "AZERBAIJAN";
translations[OPTION_COUNTRYOPTIONS_BAHAMAS] = "BAHAMAS";
translations[OPTION_COUNTRYOPTIONS_BAHRAIN] = "BAHRAIN";
translations[OPTION_COUNTRYOPTIONS_BANGLADESH] = "BANGLADESH";
translations[OPTION_COUNTRYOPTIONS_BARBADOS] = "BARBADOS";
translations[OPTION_COUNTRYOPTIONS_BELARUS] = "BELARUS";
translations[OPTION_COUNTRYOPTIONS_BELGIUM] = "BELGIUM";
translations[OPTION_COUNTRYOPTIONS_BELIZE] = "BELIZE";
translations[OPTION_COUNTRYOPTIONS_BENIN] = "BENIN";
translations[OPTION_COUNTRYOPTIONS_BERMUDA] = "BERMUDA";
translations[OPTION_COUNTRYOPTIONS_BHUTAN] = "BHUTAN";
translations[OPTION_COUNTRYOPTIONS_BOLIVIA] = "BOLIVIA";
translations[OPTION_COUNTRYOPTIONS_BOSNIA_AND_HERZEGOVINA] = "BOSNIA AND HERZEGOVINA";
translations[OPTION_COUNTRYOPTIONS_BOTSWANA] = "BOTSWANA";
translations[OPTION_COUNTRYOPTIONS_BOUVET_ISLAND] = "BOUVET ISLAND";
translations[OPTION_COUNTRYOPTIONS_BRAZIL] = "BRAZIL";
translations[OPTION_COUNTRYOPTIONS_BRITISH_INDIAN_OCEAN_TERRITORY] = "BRITISH INDIAN OCEAN TERRITORY";
translations[OPTION_COUNTRYOPTIONS_BRUNEI_DARUSSALAM] = "BRUNEI DARUSSALAM";
translations[OPTION_COUNTRYOPTIONS_BULGARIA] = "BULGARIA";
translations[OPTION_COUNTRYOPTIONS_BURKINA_FASO] = "BURKINA FASO";
translations[OPTION_COUNTRYOPTIONS_BURUNDI] = "BURUNDI";
translations[OPTION_COUNTRYOPTIONS_CAMBODIA] = "CAMBODIA";
translations[OPTION_COUNTRYOPTIONS_CAMEROON] = "CAMEROON";
translations[OPTION_COUNTRYOPTIONS_CANADA] = "CANADA";
translations[OPTION_COUNTRYOPTIONS_CAPE_VERDE] = "CAPE VERDE";
translations[OPTION_COUNTRYOPTIONS_CAYMAN_ISLANDS] = "CAYMAN ISLANDS";
translations[OPTION_COUNTRYOPTIONS_CENTRAL_AFRICAN_REPUBLIC] = "CENTRAL AFRICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_CHAD] = "CHAD";
translations[OPTION_COUNTRYOPTIONS_CHILE] = "CHILE";
translations[OPTION_COUNTRYOPTIONS_CHINA] = "CHINA";
translations[OPTION_COUNTRYOPTIONS_CHRISTMAS_ISLAND] = "CHRISTMAS ISLAND";
translations[OPTION_COUNTRYOPTIONS_COCOS_KEELING_ISLANDS] = "COCOS (KEELING) ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COLOMBIA] = "COLOMBIA";
translations[OPTION_COUNTRYOPTIONS_COMOROS] = "COMOROS";
translations[OPTION_COUNTRYOPTIONS_CONGO] = "CONGO";
translations[OPTION_COUNTRYOPTIONS_CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE] = "CONGO, THE DEMOCRATIC REPUBLIC OF THE";
translations[OPTION_COUNTRYOPTIONS_COOK_ISLANDS] = "COOK ISLANDS";
translations[OPTION_COUNTRYOPTIONS_COSTA_RICA] = "COSTA RICA";
translations[OPTION_COUNTRYOPTIONS_CÔTE_DIVOIRE_IVORY_COAST] = "CÔTE D'IVOIRE (IVORY COAST)";
translations[OPTION_COUNTRYOPTIONS_CROATIA] = "CROATIA";
translations[OPTION_COUNTRYOPTIONS_CUBA] = "CUBA";
translations[OPTION_COUNTRYOPTIONS_CYPRUS] = "CYPRUS";
translations[OPTION_COUNTRYOPTIONS_CZECH_REPUBLIC] = "CZECH REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_DENMARK] = "DENMARK";
translations[OPTION_COUNTRYOPTIONS_DJIBOUTI] = "DJIBOUTI";
translations[OPTION_COUNTRYOPTIONS_DOMINICA] = "DOMINICA";
translations[OPTION_COUNTRYOPTIONS_DOMINICAN_REPUBLIC] = "DOMINICAN REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_ECUADOR] = "ECUADOR";
translations[OPTION_COUNTRYOPTIONS_EGYPT] = "EGYPT";
translations[OPTION_COUNTRYOPTIONS_EL_SALVADOR] = "EL SALVADOR";
translations[OPTION_COUNTRYOPTIONS_EQUATORIAL_GUINEA] = "EQUATORIAL GUINEA";
translations[OPTION_COUNTRYOPTIONS_ERITREA] = "ERITREA";
translations[OPTION_COUNTRYOPTIONS_ESTONIA] = "ESTONIA";
translations[OPTION_COUNTRYOPTIONS_ETHIOPIA] = "ETHIOPIA";
translations[OPTION_COUNTRYOPTIONS_FALKLAND_ISLANDS_MALVINAS] = "FALKLAND ISLANDS (MALVINAS)";
translations[OPTION_COUNTRYOPTIONS_FAROE_ISLANDS] = "FAROE ISLANDS";
translations[OPTION_COUNTRYOPTIONS_FIJI] = "FIJI";
translations[OPTION_COUNTRYOPTIONS_FINLAND] = "FINLAND";
translations[OPTION_COUNTRYOPTIONS_FRANCE] = "FRANCE";
translations[OPTION_COUNTRYOPTIONS_FRENCH_GUIANA] = "FRENCH GUIANA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_POLYNESIA] = "FRENCH POLYNESIA";
translations[OPTION_COUNTRYOPTIONS_FRENCH_SOUTHERN_TERRITORIES] = "FRENCH SOUTHERN TERRITORIES";
translations[OPTION_COUNTRYOPTIONS_GABON] = "GABON";
translations[OPTION_COUNTRYOPTIONS_GAMBIA] = "GAMBIA";
translations[OPTION_COUNTRYOPTIONS_GEORGIA] = "GEORGIA";
translations[OPTION_COUNTRYOPTIONS_GERMANY] = "GERMANY";
translations[OPTION_COUNTRYOPTIONS_GHANA] = "GHANA";
translations[OPTION_COUNTRYOPTIONS_GIBRALTAR] = "GIBRALTAR";
translations[OPTION_COUNTRYOPTIONS_GREECE] = "GREECE";
translations[OPTION_COUNTRYOPTIONS_GREENLAND] = "GREENLAND";
translations[OPTION_COUNTRYOPTIONS_GRENADA] = "GRENADA";
translations[OPTION_COUNTRYOPTIONS_GUADELOUPE] = "GUADELOUPE";
translations[OPTION_COUNTRYOPTIONS_GUAM] = "GUAM";
translations[OPTION_COUNTRYOPTIONS_GUATEMALA] = "GUATEMALA";
translations[OPTION_COUNTRYOPTIONS_GUERNSEY] = "GUERNSEY";
translations[OPTION_COUNTRYOPTIONS_GUINEA] = "GUINEA";
translations[OPTION_COUNTRYOPTIONS_GUINEA_BISSAU] = "GUINEA-BISSAU";
translations[OPTION_COUNTRYOPTIONS_GUYANA] = "GUYANA";
translations[OPTION_COUNTRYOPTIONS_HAITI] = "HAITI";
translations[OPTION_COUNTRYOPTIONS_HEARD_ISLAND_AND_MCDONALD_ISLANDS] = "HEARD ISLAND AND MCDONALD ISLANDS";
translations[OPTION_COUNTRYOPTIONS_HOLY_SEE_VATICAN_CITY_STATE] = "HOLY SEE (VATICAN CITY STATE)";
translations[OPTION_COUNTRYOPTIONS_HONDURAS] = "HONDURAS";
translations[OPTION_COUNTRYOPTIONS_HONG_KONG] = "HONG KONG";
translations[OPTION_COUNTRYOPTIONS_HUNGARY] = "HUNGARY";
translations[OPTION_COUNTRYOPTIONS_ICELAND] = "ICELAND";
translations[OPTION_COUNTRYOPTIONS_INDIA] = "INDIA";
translations[OPTION_COUNTRYOPTIONS_INDONESIA] = "INDONESIA";
translations[OPTION_COUNTRYOPTIONS_IRAN_ISLAMIC_REPUBLIC_OF] = "IRAN, ISLAMIC REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_IRAQ] = "IRAQ";
translations[OPTION_COUNTRYOPTIONS_IRELAND] = "IRELAND";
translations[OPTION_COUNTRYOPTIONS_ISLE_OF_MAN] = "ISLE OF MAN";
translations[OPTION_COUNTRYOPTIONS_ISRAEL] = "ISRAEL";
translations[OPTION_COUNTRYOPTIONS_ITALY] = "ITALY";
translations[OPTION_COUNTRYOPTIONS_JAMAICA] = "JAMAICA";
translations[OPTION_COUNTRYOPTIONS_JAPAN] = "JAPAN";
translations[OPTION_COUNTRYOPTIONS_JERSEY] = "JERSEY";
translations[OPTION_COUNTRYOPTIONS_JORDAN] = "JORDAN";
translations[OPTION_COUNTRYOPTIONS_KAZAKHSTAN] = "KAZAKHSTAN";
translations[OPTION_COUNTRYOPTIONS_KENYA] = "KENYA";
translations[OPTION_COUNTRYOPTIONS_KIRIBATI] = "KIRIBATI";
translations[OPTION_COUNTRYOPTIONS_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF] = "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KOREA_REPUBLIC_OF] = "KOREA, REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_KUWAIT] = "KUWAIT";
translations[OPTION_COUNTRYOPTIONS_KYRGYZSTAN] = "KYRGYZSTAN";
translations[OPTION_COUNTRYOPTIONS_LAO_PEOPLES_DEMOCRATIC_REPUBLIC] = "LAO PEOPLE'S DEMOCRATIC REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_LATVIA] = "LATVIA";
translations[OPTION_COUNTRYOPTIONS_LEBANON] = "LEBANON";
translations[OPTION_COUNTRYOPTIONS_LESOTHO] = "LESOTHO";
translations[OPTION_COUNTRYOPTIONS_LIBERIA] = "LIBERIA";
translations[OPTION_COUNTRYOPTIONS_LIBYAN_ARAB_JAMAHIRIYA] = "LIBYAN ARAB JAMAHIRIYA";
translations[OPTION_COUNTRYOPTIONS_LIECHTENSTEIN] = "LIECHTENSTEIN";
translations[OPTION_COUNTRYOPTIONS_LITHUANIA] = "LITHUANIA";
translations[OPTION_COUNTRYOPTIONS_LUXEMBOURG] = "LUXEMBOURG";
translations[OPTION_COUNTRYOPTIONS_MACAO] = "MACAO";
translations[OPTION_COUNTRYOPTIONS_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF] = "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_MADAGASCAR] = "MADAGASCAR";
translations[OPTION_COUNTRYOPTIONS_MALAWI] = "MALAWI";
translations[OPTION_COUNTRYOPTIONS_MALAYSIA] = "MALAYSIA";
translations[OPTION_COUNTRYOPTIONS_MALDIVES] = "MALDIVES";
translations[OPTION_COUNTRYOPTIONS_MALI] = "MALI";
translations[OPTION_COUNTRYOPTIONS_MALTA] = "MALTA";
translations[OPTION_COUNTRYOPTIONS_MARSHALL_ISLANDS] = "MARSHALL ISLANDS";
translations[OPTION_COUNTRYOPTIONS_MARTINIQUE] = "MARTINIQUE";
translations[OPTION_COUNTRYOPTIONS_MAURITANIA] = "MAURITANIA";
translations[OPTION_COUNTRYOPTIONS_MAURITIUS] = "MAURITIUS";
translations[OPTION_COUNTRYOPTIONS_MAYOTTE] = "MAYOTTE";
translations[OPTION_COUNTRYOPTIONS_MEXICO] = "MEXICO";
translations[OPTION_COUNTRYOPTIONS_MICRONESIA_FEDERATED_STATES_OF] = "MICRONESIA, FEDERATED STATES OF";
translations[OPTION_COUNTRYOPTIONS_MOLDOVA] = "MOLDOVA";
translations[OPTION_COUNTRYOPTIONS_MONACO] = "MONACO";
translations[OPTION_COUNTRYOPTIONS_MONGOLIA] = "MONGOLIA";
translations[OPTION_COUNTRYOPTIONS_MONTENEGRO] = "MONTENEGRO";
translations[OPTION_COUNTRYOPTIONS_MONTSERRAT] = "MONTSERRAT";
translations[OPTION_COUNTRYOPTIONS_MOROCCO] = "MOROCCO";
translations[OPTION_COUNTRYOPTIONS_MOZAMBIQUE] = "MOZAMBIQUE";
translations[OPTION_COUNTRYOPTIONS_MYANMAR] = "MYANMAR";
translations[OPTION_COUNTRYOPTIONS_NAMIBIA] = "NAMIBIA";
translations[OPTION_COUNTRYOPTIONS_NAURU] = "NAURU";
translations[OPTION_COUNTRYOPTIONS_NEPAL] = "NEPAL";
translations[OPTION_COUNTRYOPTIONS_NETHERLANDS] = "NETHERLANDS";
translations[OPTION_COUNTRYOPTIONS_NEW_CALEDONIA] = "NEW CALEDONIA";
translations[OPTION_COUNTRYOPTIONS_NEW_ZEALAND] = "NEW ZEALAND";
translations[OPTION_COUNTRYOPTIONS_NICARAGUA] = "NICARAGUA";
translations[OPTION_COUNTRYOPTIONS_NIGER] = "NIGER";
translations[OPTION_COUNTRYOPTIONS_NIGERIA] = "NIGERIA";
translations[OPTION_COUNTRYOPTIONS_NIUE] = "NIUE";
translations[OPTION_COUNTRYOPTIONS_NORFOLK_ISLAND] = "NORFOLK ISLAND";
translations[OPTION_COUNTRYOPTIONS_NORTHERN_MARIANA_ISLANDS] = "NORTHERN MARIANA ISLANDS";
translations[OPTION_COUNTRYOPTIONS_NORWAY] = "NORWAY";
translations[OPTION_COUNTRYOPTIONS_OMAN] = "OMAN";
translations[OPTION_COUNTRYOPTIONS_PAKISTAN] = "PAKISTAN";
translations[OPTION_COUNTRYOPTIONS_PALAU] = "PALAU";
translations[OPTION_COUNTRYOPTIONS_PALESTINIAN_TERRITORY_OCCUPIED] = "PALESTINIAN TERRITORY, OCCUPIED";
translations[OPTION_COUNTRYOPTIONS_PANAMA] = "PANAMA";
translations[OPTION_COUNTRYOPTIONS_PAPUA_NEW_GUINEA] = "PAPUA NEW GUINEA";
translations[OPTION_COUNTRYOPTIONS_PARAGUAY] = "PARAGUAY";
translations[OPTION_COUNTRYOPTIONS_PERU] = "PERU";
translations[OPTION_COUNTRYOPTIONS_PHILIPPINES] = "PHILIPPINES";
translations[OPTION_COUNTRYOPTIONS_PITCAIRN] = "PITCAIRN";
translations[OPTION_COUNTRYOPTIONS_POLAND] = "POLAND";
translations[OPTION_COUNTRYOPTIONS_PORTUGAL] = "PORTUGAL";
translations[OPTION_COUNTRYOPTIONS_PUERTO_RICO] = "PUERTO RICO";
translations[OPTION_COUNTRYOPTIONS_QATAR] = "QATAR";
translations[OPTION_COUNTRYOPTIONS_RÉUNION] = "RÉUNION";
translations[OPTION_COUNTRYOPTIONS_ROMANIA] = "ROMANIA";
translations[OPTION_COUNTRYOPTIONS_RUSSIAN_FEDERATION] = "RUSSIAN FEDERATION";
translations[OPTION_COUNTRYOPTIONS_RWANDA] = "RWANDA";
translations[OPTION_COUNTRYOPTIONS_SAINT_BARTHÉLEMY] = "SAINT BARTHÉLEMY";
translations[OPTION_COUNTRYOPTIONS_SAINT_HELENA] = "SAINT HELENA";
translations[OPTION_COUNTRYOPTIONS_SAINT_KITTS_AND_NEVIS] = "SAINT KITTS AND NEVIS";
translations[OPTION_COUNTRYOPTIONS_SAINT_LUCIA] = "SAINT LUCIA";
translations[OPTION_COUNTRYOPTIONS_SAINT_MARTIN] = "SAINT MARTIN";
translations[OPTION_COUNTRYOPTIONS_SAINT_PIERRE_AND_MIQUELON] = "SAINT PIERRE AND MIQUELON";
translations[OPTION_COUNTRYOPTIONS_SAINT_VINCENT_AND_THE_GRENADINES] = "SAINT VINCENT AND THE GRENADINES";
translations[OPTION_COUNTRYOPTIONS_SAMOA] = "SAMOA";
translations[OPTION_COUNTRYOPTIONS_SAN_MARINO] = "SAN MARINO";
translations[OPTION_COUNTRYOPTIONS_SAO_TOME_AND_PRINCIPE] = "SAO TOME AND PRINCIPE";
translations[OPTION_COUNTRYOPTIONS_SAUDI_ARABIA] = "SAUDI ARABIA";
translations[OPTION_COUNTRYOPTIONS_SENEGAL] = "SENEGAL";
translations[OPTION_COUNTRYOPTIONS_SERBIA] = "SERBIA";
translations[OPTION_COUNTRYOPTIONS_SEYCHELLES] = "SEYCHELLES";
translations[OPTION_COUNTRYOPTIONS_SIERRA_LEONE] = "SIERRA LEONE";
translations[OPTION_COUNTRYOPTIONS_SINGAPORE] = "SINGAPORE";
translations[OPTION_COUNTRYOPTIONS_SLOVAKIA] = "SLOVAKIA";
translations[OPTION_COUNTRYOPTIONS_SLOVENIA] = "SLOVENIA";
translations[OPTION_COUNTRYOPTIONS_SOLOMON_ISLANDS] = "SOLOMON ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SOMALIA] = "SOMALIA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_AFRICA] = "SOUTH AFRICA";
translations[OPTION_COUNTRYOPTIONS_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS] = "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS";
translations[OPTION_COUNTRYOPTIONS_SPAIN] = "SPAIN";
translations[OPTION_COUNTRYOPTIONS_SRI_LANKA] = "SRI LANKA";
translations[OPTION_COUNTRYOPTIONS_SUDAN] = "SUDAN";
translations[OPTION_COUNTRYOPTIONS_SURINAME] = "SURINAME";
translations[OPTION_COUNTRYOPTIONS_SVALBARD_AND_JAN_MAYEN] = "SVALBARD AND JAN MAYEN";
translations[OPTION_COUNTRYOPTIONS_SWAZILAND] = "SWAZILAND";
translations[OPTION_COUNTRYOPTIONS_SWEDEN] = "SWEDEN";
translations[OPTION_COUNTRYOPTIONS_SWITZERLAND] = "SWITZERLAND";
translations[OPTION_COUNTRYOPTIONS_SYRIAN_ARAB_REPUBLIC] = "SYRIAN ARAB REPUBLIC";
translations[OPTION_COUNTRYOPTIONS_TAIWAN_ROC] = "TAIWAN, R.O.C.";
translations[OPTION_COUNTRYOPTIONS_TAJIKISTAN] = "TAJIKISTAN";
translations[OPTION_COUNTRYOPTIONS_TANZANIA_UNITED_REPUBLIC_OF] = "TANZANIA, UNITED REPUBLIC OF";
translations[OPTION_COUNTRYOPTIONS_THAILAND] = "THAILAND";
translations[OPTION_COUNTRYOPTIONS_TIMOR_LESTE] = "TIMOR-LESTE";
translations[OPTION_COUNTRYOPTIONS_TOGO] = "TOGO";
translations[OPTION_COUNTRYOPTIONS_TOKELAU] = "TOKELAU";
translations[OPTION_COUNTRYOPTIONS_TONGA] = "TONGA";
translations[OPTION_COUNTRYOPTIONS_TRINIDAD_AND_TOBAGO] = "TRINIDAD AND TOBAGO";
translations[OPTION_COUNTRYOPTIONS_TUNISIA] = "TUNISIA";
translations[OPTION_COUNTRYOPTIONS_TURKEY] = "TURKEY";
translations[OPTION_COUNTRYOPTIONS_TURKMENISTAN] = "TURKMENISTAN";
translations[OPTION_COUNTRYOPTIONS_TURKS_AND_CAICOS_ISLANDS] = "TURKS AND CAICOS ISLANDS";
translations[OPTION_COUNTRYOPTIONS_TUVALU] = "TUVALU";
translations[OPTION_COUNTRYOPTIONS_UGANDA] = "UGANDA";
translations[OPTION_COUNTRYOPTIONS_UKRAINE] = "UKRAINE";
translations[OPTION_COUNTRYOPTIONS_UNITED_ARAB_EMIRATES] = "UNITED ARAB EMIRATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_KINGDOM] = "UNITED KINGDOM";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES] = "UNITED STATES";
translations[OPTION_COUNTRYOPTIONS_UNITED_STATES_MINOR_OUTLYING_ISLANDS] = "UNITED STATES MINOR OUTLYING ISLANDS";
translations[OPTION_COUNTRYOPTIONS_URUGUAY] = "URUGUAY";
translations[OPTION_COUNTRYOPTIONS_UZBEKISTAN] = "UZBEKISTAN";
translations[OPTION_COUNTRYOPTIONS_VANUATU] = "VANUATU";
translations[OPTION_COUNTRYOPTIONS_VENEZUELA] = "VENEZUELA";
translations[OPTION_COUNTRYOPTIONS_VIET_NAM] = "VIET NAM";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_BRITISH] = "VIRGIN ISLANDS, BRITISH";
translations[OPTION_COUNTRYOPTIONS_VIRGIN_ISLANDS_US] = "VIRGIN ISLANDS, U.S.";
translations[OPTION_COUNTRYOPTIONS_WALLIS_AND_FUTUNA] = "WALLIS AND FUTUNA";
translations[OPTION_COUNTRYOPTIONS_WESTERN_SAHARA] = "WESTERN SAHARA";
translations[OPTION_COUNTRYOPTIONS_YEMEN] = "YEMEN";
translations[OPTION_COUNTRYOPTIONS_ZAMBIA] = "ZAMBIA";
translations[OPTION_COUNTRYOPTIONS_ZIMBABWE] = "ZIMBABWE";
translations[OPTION_DOESTHEPARTICULATEMATTER_NO] = "ไม่ใช่";
translations[OPTION_DOESTHEPARTICULATEMATTER_UNKNOWN] = "ไม่ทราบ";
translations[OPTION_DOESTHEPARTICULATEMATTER_YES] = "ใช่";
translations[I_HAVE_READ_AND_UNDERSTAND_THE_LINKED_PRIVACY_NOTICE] = "ฉันได้อ่านและทำความเข้าใจประกาศความเป็นส่วนตัวที่เชื่อมโยงสำหรับพอร์ทัลคำติชมผลิตภัณฑ์ของ Baxter แล้ว";
translations[PRODUCT_LOT] = "หมายเลขรุ่นการผลิต";
translations[SHIPPING_DISTRIBUTION_LABEL] = "ฉลากการจัดส่ง/การจัดจำหน่าย";
translations[CARTON_LABEL] = "ป้ายกล่อง";
translations[INTERNAL_PRODUCT_LABEL] = "ฉลากผลิตภัณฑ์ภายใน";
translations[TITLE_PD_RENAL] = "PD ไต";
translations[TITLE_SOLUTIONS] = "โซลูชั่น";
translations[TITLE_ACCESS] = "เข้าถึง";
translations[TITLE_ALL_OTHER_PRODUCT] = "สินค้าอื่นๆ ทั้งหมด";
translations[REPORTED_PROBLEM] = "รายงานปัญหา";
translations[LOGIN] = "เข้าสู่ระบบ";
translations[SYSTEM_MENU] = "เมนูระบบ";
translations[INITIATE_PRODUCT_FEEDBACK] = "เริ่มต้นการเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์";
translations[FEEDBACK_STATUS] = "สถานะคำติชม";
translations[OKTACALLBACK] = "OktaCallback";
translations[VALID_EMAIL] = "กรุณาใส่อีเมล";
translations[VALID_NUMERIC] = "กรุณาใส่หมายเลขให้ครบถ้วน";
translations[PLEASE_UPLOAD_IMAGE] = "กรุณาอัพโหลดรูปภาพ";
translations[VALID_DATE] = "โปรดเลือกวันที่ที่ถูกต้อง";
translations[QUANTITY] = "จำนวน";
translations[EDIT] = "แก้ไข";
translations[DELETE] = "ลบ";
translations[LOT_SERIAL_NO] = "หมายเลขล็อต/ซีเรียลนัมเบอร์";
translations[LOT_NUMBER_NOT_FOUND] = "ไม่พบหมายเลขรุ่นผลิตภัณฑ์";
translations[SEARCHING_LOT_NUMBER] = "ค้นหาหมายเลขรุ่นผลิตภัณฑ์";
translations[PRODUCT_CODE_NOT_FOUND] = "ไม่พบรหัสผลิตภัณฑ์";
translations[SEARCHING_PRODUCT_CODE] = "ค้นหารหัสผลิตภัณฑ์";
translations[FILE_OF_TYPES_ARE_NOT_ALLOWED] = "ระบบไม่รองรับไฟล์ประเภท (.asa, .asax, .bat, .cer, .cmd, .docm, .exe, .img, .iso, .js, .php, .php5, .pht, .phtml, .ps1, .py, .rar,  .scr, .shtml, .swf, .vbs, .xap, .xml, .xps)";
translations[THE_FILE_YOU_ARE_ATTEMPTING] = "ไฟล์ที่คุณพยายามแนบเกินขีดจำกัดการจัดเก็บ โปรดบีบอัดหรือแนบไฟล์อื่น";
translations[IMAGE_ICON] = "กดที่รูปภาพเพื่อเลือกตัวเลือก";
translations[LOGIN_TO_ACCOUNT] = "เข้าสู่ระบบบัญชี";
translations[SIGN_IN_TO_YOUR_ACCOUNT] = "ลงชื่อเข้าใช้บัญชีของคุณ";
translations[BAXTER_EMAIL_ADDRESS] = "ที่อยู่อีเมลของแบ็กซ์เตอร์";
translations[PASSWORD] = "รหัสผ่าน";
translations[SIGN_IN] = "เข้าสู่ระบบ";
translations[UNKNOWN] = "ไม่ทราบ";
translations[ASKED_UNKNOWN] = "ผู้แจ้งไม่ทราบ";
translations[DD_MMM_YYYY] = "DD-MMM-YYYY";
translations[DD] = "DD";
translations[MMM] = "MMM";
translations[YYYY] = "YYYY";
translations[SELECT_COUNTRY] = "เลือกประเทศ";
translations[CHINESE_SIMPLIFIED_CHINESE] = "จีน (จีนตัวย่อ)";
translations[DUTCH] = "ดัตช์ ";
translations[ENGLISH] = "อังกฤษ";
translations[FRENCH] = "ฝรั่งเศส";
translations[GERMAN] = "เยอรมัน";
translations[ITALIAN] = "อิตาลี";
translations[JAPANESE] = "ญี่ปุ่น";
translations[KOREAN] = "เกาหลี";
translations[MANDARIN_TRADITIONAL_CHINESE] = "จีนแมนดาริน (จีนดั้งเดิม)";
translations[POLISH] = "โปแลนด์";
translations[PORTUGUESE] = "โปรตุเกส";
translations[SPANISH] = "สเปน";
translations[THAI] = "ไทย ";
translations[TURKISH] = "ตุรกี";
translations[VIETNAMESE] = "เวียดนาม";
translations[BROWSE] = "เรียกดู";
translations[FEEDBACK_SUBMITTED] = "ส่งคำติชมแล้ว";
translations[YOUR_PRODUCT_EXPERIENCE_FEEDBACK] = "ขอบคุณสำหรับการเสนอแนะความคิดเห็นเกี่ยวกับผลิตภัณฑ์ให้กับเรา ข้อเสนอแนะของคุณถูกส่งเรียบร้อยแล้ว คุณจะได้รับอีเมลที่ระบุเลขอ้างอิงหลังจากนี้ ในฐานะผู้จำหน่ายยาและเวชภัณฑ์ ความพึงพอใจของลูกค้าและข้อเสนอแนะเกี่ยวกับผลิตภัณฑ์ถือเป็นส่วนสำคัญต่อเป้าหมายของเราที่จะมอบผลิตภัณฑ์ที่มีคุณภาพดีที่สุดให้กับลูกค้า กรุณาติดต่อมาที่";
translations[IF_YOU_HAVE_QUESTIONS_OR_ADDITIONAL_INFORMATION] = "หากคุณมีคำถามหรือข้อมูลเพิ่มเติม";
translations[CLOSE] = "ปิด I";
translations[PATIENT_AGE] = "อายุของผู้ป่วย";
translations[ENTER_AGE] = "ป้อนอายุ";
translations[PATIENT_DOB] = "วันเดือนปีเกิดของผู้ป่วย";
translations[RELEVANT_ATTACHMENTS] = "โปรดระบุไฟล์แนบที่เกี่ยวข้องใด ๆ";
translations[BAXTER_ACCOUNT_CREDENTIALS] = "ป้อนข้อมูลบัญชี Baxter ของคุณ";
translations[GET_PRODUCT_DETAILS] = "รับรายละเอียดสินค้า";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_2] = "ใช้ไดอะแกรมด้านบน (รูปที่ 2) เพื่อระบุตำแหน่งของปัญหาที่รายงาน";
translations[FACILITY_ADDRESS] = "ที่อยู่";
translations[LABEL_ANOTHER_FACILITY_ADDRESS] = "ที่อยู่เพิ่มเติม";
translations[CHOOSE_PRODUCT_CODE] = "โปรดเลือกรหัสผลิตภัณฑ์และหมายเลขรุ่นการผลิต";
translations[DECLINE] = "ปฏิเสธ";
translations[OPTION_COUNTRYOPTIONS_BONAIRE_SINT_EUSTATIUS_AND_SABA] = "BONAIRE, SINT EUSTATIUS AND SABA";
translations[OPTION_COUNTRYOPTIONS_CURAÇAO] = "CURAÇAO";
translations[OPTION_COUNTRYOPTIONS_SOUTH_SUDAN] = "SOUTH SUDAN";
translations[OPTION_COUNTRYOPTIONS_ESWATINI] = "ESWATINI";
translations[FORM_HELP_TEXT] = "การระบุข้อความช่วยเหลือสามารถทำได้ในช่องนี้";
translations[YOUR_FIRST_NAME] = "ชื่อจริงของคุณ";
translations[YOUR_LAST_NAME] = "นามสกุลของคุณ";
translations[MY_FIRST_NAME] = "ชื่อของฉัน";
translations[MY_LAST_NAME] = "นามสกุลของฉัน";
translations[PATIENT_FIRST_NAME] = "ชื่อผู้ป่วย";
translations[PATIENT_LAST_NAME] = "นามสกุลผู้ป่วย";
translations[REPORTER_FIRST_NAME] = "ชื่อผู้รายงาน";
translations[REPORTER_LAST_NAME] = "นามสกุลผู้รายงาน";
translations[EMPLOYEE_FIRST_NAME] = "ชื่อพนักงาน";
translations[EMPLOYEE_LAST_NAME] = "นามสกุลพนักงาน";
translations[END_USER_CUSTOMER_FIRST_NAME] = "ชื่อผู้ใช้งาน/ลูกค้า";
translations[END_USER_CUSTOMER_LAST_NAME] = "นามสกุลของผู้ใช้งาน/ลูกค้า";
translations[ADDITIONAL_CONTACT_FIRST_NAME] = "ชื่อผู้ติดต่อเพิ่มเติม";
translations[ADDITIONAL_CONTACT_LAST_NAME] = "นามสกุลผู้ติดต่อเพิ่มเติม";
translations[COPYRIGHT] = "Copyright ©";
translations[COPYRIGHT_BAXTER] = "Baxter";
translations[COPYRIGHT_VERSION] = "All rights reserved | Version";
translations[ADD_ADDITIONAL_CONTACT] = "เพิ่มผู้ติดต่อเพิ่มเติม";
translations[CONTACT_ME] = "ลูกค้าไม่ประสงค์ให้ติดต่อกลับ ติดต่อฉันหากมีคำถามเพิ่มเติมอื่นๆ";
translations[DO_NOT_CONTACT] = "ห้ามติดต่อ";
translations[END_USER_CUSTOMER_FACILITY_NAME] = "ชื่อสถานที่ทำงานของผู้ใช้งาน/ลูกค้า";
translations[END_USER_CUSTOMER_PHONE] = "เบอร์โทรศัพท์ที่ทำงานผู้ใช้งาน/ลูกค้า";
translations[END_USER_CUSTOMER_EMAIL] = "อีเมลของผู้ใช้งาน/ลูกค้า";
translations[END_USER_CUSTOMER_FACILITY_ADDRESS] = "ที่อยู่สถานที่ทำงานของผู้ใช้งาน/ลูกค้า";
translations[SAME_AS_PATIENT_ADDRESS] = "เช่นเดียวกับที่อยู่ของผู้ป่วย";
translations[SAME_AS_REPORTER_ADDRESS] = "เช่นเดียวกับที่อยู่ของผู้สื่อข่าว";
translations[SAME_AS_END_USER_CUSTOMER_ADDRESS] = "เหมือนกับที่อยู่ที่ทำงานของผู้ใช้/ลูกค้า";
translations[USE_THE_DIAGRAM_ABOVE_FIGURE_3] = "ใช้แผนภาพด้านบน (รูปที่ 3) เพื่อระบุตำแหน่งของปัญหาที่รายงาน";
translations[CONTACT_US] = "ติดต่อเรา";
translations[LANDING_BRIEF_FOR_DEVICE] = "กรณีแจ้งซ่อมเครื่อง, ชิ้นส่วน, ขอรับบริการจากช่าง, หรือการสนับสนุนทางเทคนิค กรุณาติดต่อทีม technical service ในประเทศของท่าน";
translations[PATIENT_SEX] = "เพศผู้ป่วย";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_MAN_BOY] = "ชาย/ชาย";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_CISGENDER_WOMAN_GIRL] = "ผู้หญิง/ผู้หญิง";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_MAN_TRANS_MAN_FEMALE_TO_MALE_FTM] = "ชายข้ามเพศ/ชายข้ามเพศ/หญิงเป็นชาย";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_TRANSGENDER_WOMAN_TRANS_WOMAN_MALE_TO_FEMALE_MTF] = "หญิงข้ามเพศ/หญิงข้ามเพศ/ชายเป็นหญิง";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_OTHER_GENDER_CATEGORY_PLEASE_SPECIFY] = "หมวดหมู่เพศอื่น ๆ โปรดระบุ";
translations[OPTION_PATIENTGENDEROPTIONS_CISGENDER_DECLINE_TO_ANSWER] = "ปฏิเสธที่จะตอบ";
translations[ATTENTION_NEEDED] = "!!!จำเป็นต้องให้ความสนใจอย่างเร่งด่วน: การส่งพอร์ทัลความคิดเห็นเกี่ยวกับผลิตภัณฑ์ของคุณล้มเหลว!";
translations[SUBMIT_ERR_MSG] = "หากต้องการส่งอีกครั้ง โปรดคลิก ตกลง จากนั้นส่งหรือส่งอีเมลข้อร้องเรียนของคุณไปที่ (@@@)";
translations[SUBMIT_RETRY_MSG] = "หากคุณส่งอีกครั้ง โปรดยืนยันว่าคุณได้รับอีเมลยืนยันในกล่องอีเมลของคุณจากพอร์ทัลข้อเสนอแนะผลิตภัณฑ์หากไม่ได้รับอีเมลยืนยัน การส่งไม่สำเร็จ และคุณต้องส่งข้อความร้องเรียนของคุณไปที่ (@@@)";
translations[OK] = "OK";

export default lang;